/* global createjs */
function initSetup() {
  window.AdobeAn = {};

  window.cjs = createjs || {};
  // console.log('window.AdobeAn', window.AdobeAn);
  // console.log('window.cjs', window.cjs);
  var an = window.AdobeAn;
  var cjs = window.cjs;
  // console.log('an', an);
  // console.log('cjs', cjs);

  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.Top3ConsumnerGoodsLogosvg = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#000000")
      .s()
      .p("AoqEmIAApLIRUAAIjxElIDxEmgAGvDtIjBjsIDAjqIueAAIAAHWIOfAAg");
    this.shape.setTransform(313.75, 202.675);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f("#FFFFFF").s().p("An9EJIAAoQIP6AAIjZEHIDZEJg");
    this.shape_1.setTransform(312.15, 202.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f("#000000").s().p("Ah2jvIDthrIAAJLIjtBpg");
    this.shape_2.setTransform(270.2, 195.95);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#000000")
      .s()
      .p("AoqEmIDykmIjyklIRUAAIAAJLgAjuAAIjBDrIOgAAIAAnWIugAAg");
    this.shape_3.setTransform(55.45, 202.7);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f("#FFFFFF").s().p("An8EJIDYkJIjYkHIP5AAIAAIQg");
    this.shape_4.setTransform(57.025, 202.65);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f("#000000").s().p("Ah2DxIAApLIDtBrIAAJJg");
    this.shape_5.setTransform(99, 195.95);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#000000")
      .s()
      .p(
        "AiFHJQg8gOglgiQgmgjgRg4QgTg4ABhTIDiAAQAAAkAGAdQAEAaAIASQAOAhAoABQAUgBAOgFQAMgGAIgRQAHgPACgcQADgdAAgqQABhGgXgVQgVgYgsAAIg9AAIAAiYIAjAAQAZABAWgGQARgEAPgQQALgNAJgaQAGgeABglQAAg7gPgTQgQgVgdAAQgkAAgPAbQgOAbAABLIjcAAQACiQBIhEQBJhDCMAAQBUgBA5ASQA3AQAjAhQAgAgAPAwQAOA0AAA5QgBAdgGAcQgGAbgRAdQgPAZgYAUQgaATgkAIIAAADQBRAPAiA3QAgA3AABLQABCehMBDQhNBFiVABQhQAAg4gNg",
      );
    this.shape_6.setTransform(183.7, 184.35);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#000000")
      .s()
      .p(
        "AhrCNIAAkZIB6AAQArAAAZAWQAZAWAAAuQAAAygZAUQgaAUguAAIg7AAIAABlgAgxgGIA2AAQATgBAOgKQALgKAAgWQAAgWgMgJQgLgJgVAAIg2AAg",
      );
    this.shape_7.setTransform(212.25, 104.725);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#000000")
      .s()
      .p(
        "AhbB0QgrgoAAhMQAAhNArgmQAgghA7AAQA9AAAfAhQArAoAABLQAABLgrApQgfAhg9AAQg8AAgfghgAg5hIQgVAaAAAuQAAAwAVAZQAWAaAiAAQAkAAAUgaQAUgYAAgxQAAgugVgaQgWgaghAAQgjAAgVAag",
      );
    this.shape_8.setTransform(183.375, 104.8);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#000000")
      .s()
      .p("AgcCNIAAjnIhVAAIAAgyIDjAAIAAAyIhUAAIAADng");
    this.shape_9.setTransform(156.7, 104.8);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AhzBlQgdgbgIg2QgHg2AWgkQAXgjAsgGIAHA5QgUAEgIAKQgQAQAEAjQAEAXAFALQAMAYAagDQANgCAIgNQAGgNADgcIACgeQAFguAKgSQAPgfArgGQApgFAbAZQAdAXAHA4QAGAsgVAjQgVAigtAIIgHg5QAbgFAHgWQAGgPgDgUQgDgWgLgOQgLgNgRADQgPABgHAPQgEAIgDAfIgGAyQgEAhgLASQgRAcgmAFIgLAAQgiAAgZgWg",
      );
    this.shape_10.setTransform(316.3229, 148.7478);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgoCNQg+gMgUg+Ignh0IEUhdIAnB1QAIAaAAARQAAAggUAaQgTAXgTALQgWANgWAIQgnAMggAAQgPAAgOgCgAhggLIASA0QANAoAuADQAXACAggLQAsgQARgTQASgVgNgmIgSg1g",
      );
    this.shape_11.setTransform(308.6, 118.8338);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ag2CPQgugLggg0Qgfg0ALgtQAOg8BEgoQBEgqA5ARQAuAKAfA1QAgA1gMAsQgLA6hGAqQgxAegqAAQgRAAgRgFgAgohCQgqAagMAgQgMAfATAfQASAeAiAEQAgAEArgaQAqgaAMgfQALgggSgdQgSgegigFIgLgBQgcAAgkAWg",
      );
    this.shape_12.setTransform(296.7099, 91.4296);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AhrBvQgsgsAAguQgCg7A3g5QA4g5A7ABQAvgBAsAqQAsAsAAAuQADA4g4A8Qg3A4g7AAIgCAAQgxAAgpgpgAAMheQghAFgiAjQgjAlgDAfQgDAjAZAYQAYAZAjgEQAggEAjgkQAjgjADghQAEgggagbQgWgVgeAAIgHAAg",
      );
    this.shape_13.setTransform(276.2818, 65.5486);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAHCYIAMgjQgWAHgTADQgbABgegQQgygbgNg1QgOg2Aig8QAihAA3gRQA0gTA5AeQAuAaASApQAPApgRAnIg0gdQAJgcgSgZQgKgNgQgJQgdgPghALQggANgZAvQgbAxALAdQAKAgAbAOQAZAPAagHQAYgFATgYIg5ggIAXgqIBpA5IhMCKg",
      );
    this.shape_14.setTransform(249.6257, 47.7566);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAmCYIgBgPQAAgSACgHIAEgbQAFgagJgMQgMgMgYgDIg8gKIgSBwIg6gJIAvkgICKAYQAeAGAPAIQAOAJAKAQQAJAPACAMQADAOgDASQgDAUgOASQgOASgYAFQARAJAHASQAGAPgFAfIgDATQgDATAAAIQAAALAIAHIgBAHgAgygZIBCALQAUACALgCQATgHAEgYQAEgZgPgNQgLgHgRgDIhEgKg",
      );
    this.shape_15.setTransform(208.475, 31.85);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#FFFFFF")
      .s()
      .p("AhxiOIDSgGIACAzIiXAFIACA/ICLgGIACAyIiLAEIABBMICfgGIACA2IjZAHg");
    this.shape_16.setTransform(180, 29.95);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AirhnIBTgXIBvDPIgKjrIBTgXIBMEZIg2APIg0i+IgGgXIgGgXIAMD6Ig5APIhzjdIBBDsIg2APg",
      );
    this.shape_17.setTransform(148.3, 34.425);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgRCeQgXgOgagpIhbiaIA1gfIBbCaQAPAaAMAIQAWAOAfgRQAfgSgDgbQAAgRgQgZIhaiaIA0geIBbCbQAXAkACAhQACA2hBAmQglAVggAAQgXAAgTgLg",
      );
    this.shape_18.setTransform(116.1517, 45.6817);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AguB4IAqgoQAQAMAMACQAXAAAZgYQAPgPAIgMQAMgYgTgSQgKgJgPADQgMADgZANIgbAQQgmAYgWADQgiAGgfgfQgcgdADgkQACgnAoglQAhggAngEQAogFAhAhIgoAoQgVgSgVAHQgRAGgNANQgRARgEAQQgDARAMAMQALAKAPgDQAMgEAXgNIArgaQAfgSAUgBQAhgDAaAcQAcAcgDAoQgCApgpAlQgoAmgqAFIgHAAQglAAgcgdg",
      );
    this.shape_19.setTransform(94.2, 65.505);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#FFFFFF")
      .s()
      .p("Ai6AQIAjgzIDoASIiphxIAfgvID0ChIghAxIjtgRICsBzIggAvg");
    this.shape_20.setTransform(75.525, 87.65);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgxCAQhKgbgXg6QgTgpAVg6QAWg5AsgSQA2gZBJAdQBJAbAYA4QAUAsgWA5QgWA5gsASQgaALgeAAQghAAgmgPgAgyhPQghALgNAgQgNAgARAfQAQAdAvATQAtASAhgKQAhgLANggQANgkgRgcQgTgdgsgSQgegLgYAAQgNAAgLADg",
      );
    this.shape_21.setTransform(60.9556, 115.475);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgSCBQhMgMgjguQgfgqAJgzQAKhHA2gaQAfgOAaADIgJA7QgWACgMAIQgWANgEAgQgFAfAYAXQAYAWAwAIQAuAHAdgQQAbgRAFgdQAEgfgRgTQgMgLgTgJIAJg7QAvAQAYAjQAYAkgHAyQgJA9guAdQgiAVguAAQgRAAgSgDg",
      );
    this.shape_22.setTransform(52.7515, 145.8649);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#FFFFFF")
      .s()
      .p("AAsBaIjdhBIA5g3ICSA0Ig0iRIA1g2IBBDcIBWBWIgwAxg");
    this.shape_23.setTransform(273.9, 255.2);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#FFFFFF")
      .s()
      .p("AjChGIA+gkIDhB+Ih1jCIA1ggICmEWIg5AjIjniBIB1DEIg1Ahg");
    this.shape_24.setTransform(252.45, 278.775);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#FFFFFF")
      .s()
      .p("Ah7igIBKgVIDEEYIhHAUIgmg6IhyAgIgCBGIhEATgAhJAiIBPgXIhJhug");
    this.shape_25.setTransform(226.125, 293.45);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ah+icICMgJQAwgDAfAXQAfAXADA2QADA5gbAYQgbAbg2ACIhEAEIAHB0IhDAEgAAIhqIg+AEIAGBfIA+gEQAVgCAOgNQAOgMgDgZQgBgagOgJQgJgJgVAAIgHABg",
      );
    this.shape_26.setTransform(193.415, 296.8827);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#FFFFFF")
      .s()
      .p("AA/CvIAxkKIhtD/IhAgMIgKkVIgzEMIg+gNIA9k8IBhARIALEEIBnjvIBgASIg8E9g");
    this.shape_27.setTransform(158.95, 294.675);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AhOCZQg+gggPgzQgXhBAohLQAphPBAgSQAwgQA/AfQA+AgAPAyQAYA8gpBQQgmBNhCAVQgRAFgSAAQgkAAgpgUgAgUhpQghAPgbAxQgZAuAIAnQAHAkAlAUQAkAUAigRQAigPAZgxQAZgugIgnQgIgkgjgUQgTgJgUAAQgPAAgQAGg",
      );
    this.shape_28.setTransform(123.7517, 282.7526);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AhxB/Qg0gvABg8QAAg8A1g5QA5g/A/gDQA3gEAvApQA8A5gHA/QgFAjgTAYIgygtQALgUAAgQQAAgbgagZQgagYglAHQgjAIgkAoQglApgBAiQgCAjAaAYQAaAYAegFQAQgDAVgNIAyAtQguAggtAAQgyAAgqgmg",
      );
    this.shape_29.setTransform(95.3143, 263.4862);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#000000")
      .s()
      .p(
        "AmPOzQi5hOiOiNQiOiPhOi4QhRi/AAjRQAAjRBRi/QBOi4COiOQCPiPC4hNQC/hRDQAAQDRAAC+BQQC5BOCOCOQCPCOBOC4QBRC/AADRQAADRhRC/QhNC4iPCOQiOCPi5BOQi+BQjSABQjQgBi/hQgAl3t7QiuBJiGCHQiGCFhKCuQhMC0AADEQAADEBMC0QBKCuCGCGQCGCGCuBKQC0BLDDAAQDEAAC1hLQCthKCHiGQCGiGBJiuQBMi0AAjEQAAjEhMi0QhJiuiGiFQiHiHithJQi1hNjEAAQjEAAizBNg",
      );
    this.shape_30.setTransform(184.7, 163.55);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#000000")
      .s()
      .p(
        "Ap8XkQkmh9jijiQjjjjh8klQiAkwAAlNQAAlMCAkwQB9kmDijiQDjjjElh8QExiAFLAAQFNAAEvCAQEmB8DiDjQDjDiB8EmQCBEwAAFMQAAFNiBEwQh7EmjjDiQjiDjkmB8QkwCAlNAAQlMAAkwiAgAmkvnQjEBTiVCWQiXCWhSDCQhVDKgBDcQABDbBVDJQBSDDCXCWQCVCWDEBTQDJBVDbAAQDcAADKhVQDChSCWiWQCWiXBTjCQBVjJAAjcQAAjchVjKQhTjCiWiWQiWiWjChTQjKhVjcAAQjbAAjJBVg",
      );
    this.shape_31.setTransform(184.7, 163.625);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#F4F4F6")
      .s()
      .p(
        "An/TsQj+hnjEjDQjDjEhoj+Qhjj2AAkKQAAkJBjj2QBoj/DDjDQDEjED+hmQD2hkEJAAQEKAAD2BkQD+BmDDDEQDFDDBmD/QBkD2AAEJQAAEKhkD2QhmD+jFDEQjDDDj+BnQj2BkkKAAQkJAAj2hkg",
      );
    this.shape_32.setTransform(184.65, 163.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 369.2, 327.3);

  (lib.quoteSymbol = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#0CBD96")
      .s()
      .p(
        "ABQBtQgkhCAAhUIAAiPICbAAIAACcIhOAAIgDAIIAAAJQAAAwAVAlQAVAnAnAFIAABDQhTgJgkhDgAicB4Qgqg4gBhpIAAiPICcAAIAACcIhQAAIgBAKIAAAHQAAAcAKAfQAUA+AzAIIAABDQhGgHgrg6g",
      );
    this.shape.setTransform(19.95, 18.5);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // Layer_1_copy
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#003300")
      .s()
      .p(
        "ABQBtQgkhCAAhUIAAiPICbAAIAACcIhOAAIgDAIIAAAJQAAAwAVAlQAVAnAnAFIAABDQhTgJgkhDgAicB4Qgqg4gBhpIAAiPICcAAIAACcIhQAAIgBAKIAAAHQAAAcAKAfQAUA+AzAIIAABDQhGgHgrg6g",
      );
    this.shape_1.setTransform(21.75, 18.5);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // Layer_1_copy
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s("#FFFFFF")
      .ss(3, 0, 1)
      .p(
        "ADIB3QgogGgVgmQgVgmAAgwIABgJQAAgDACgFIBPAAIAAicIicAAIAACPQAABVAkBBQAlBDBTAJgAgrB3QgzgJgUg+QgKgfAAgdIAAgGIABgKIBQAAIAAicIicAAIAACPQAABpArA4QArA6BGAHg",
      );
    this.shape_2.setTransform(19.95, 18.5);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "ABQBtQgkhCAAhUIAAiPICbAAIAACcIhOAAIgDAIIAAAJQAAAwAVAlQAVAnAnAFIAABDQhTgJgkhDgAicB4Qgqg4gBhpIAAiPICcAAIAACcIhQAAIgBAKIAAAHQAAAcAKAfQAUA+AzAIIAABDQhGgHgrg6g",
      );
    this.shape_3.setTransform(19.95, 18.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.quoteSymbol,
    new cjs.Rectangle(-1.5, -1.5, 43.2, 40),
    null,
  );

  (lib.GSKsvg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ak3HCQgQgFgGgIQgHgKAAgRQABgRAAhdIAnARQBfAqBIAQQBcAUBTgOQA3gJAfgbQAfgcADgqQADgmgNgeQgOgggfgUQgigWg3gfIhbgzIhagyQg1gegggbQhXhKAGhwQAFhwBdhFQBTg8BlgOQBZgMBsAYQBdAVARAWQARAVgBBeIAAAdQh4hXhzgCQhGgBg/AWQg2AVgPAxQgOAyAjAuQAhArA6AkQAeASA4AdQA8AfAaAPQBdA1AyArQBWBKgNBxQgLBshaA+QheBDiSAIIgmACQiFAAiKg0g",
      );
    this.shape.setTransform(168.3281, 145.3539);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "ACtKZQhHguhEhNQg2g+hPhfIiEifQgOgQgLgGQABBPgECeQgBCMATBhIjZAAQAWhLADhnQgCh3AAg7QACnegElVQAAgegIgsQgKgzgEgbIDGg0IAAM2IAigdIAbgZIE8k0QALgLALAAIDTAAQhlBGiEB9QjDC4gYAUIAmAuICZCtQBbBmBABFQApAtA+AkQAVAMAiANIA7AVQhPAjhAADIgOAAQhGAAg8glg",
      );
    this.shape_1.setTransform(259.8, 124.2426);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#000000")
      .s()
      .p(
        "AhxDEQhZg7gLhwQgGg7AKgyQAOhAAvgoQAugmBDgGQBSgGA7AiQA8AiAcBFQAMAeAEAXQAEAWACAqQgBBRgiA1QgjA2g/ASQgnALgjAAQhBAAg5glg",
      );
    this.shape_2.setTransform(78.6875, 128.7593);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#000000")
      .s()
      .p(
        "Ai9X9Ql1gMlajrQlSjpjll7IgIgPQCkBqC3AdQCtAcDEgoQB0gZBIhMQBbhkgdh3Qgdh3h/gsQg8gUhagHQhlgFgzgFIg+gFQglgDgZgFQgtgJgNgjQgNgkAcglQArg6BHAIQB5ALBrgtQCJg6AoiLQAniKhVh7IgUgcICyAKIAAhyQhbAJgtADQhVAGhtgeQhjgchVAEQhgAEhUAsQhZAugtBKQgtBLACBkQAFC7CxBaIAVALIggAUQg9AlgaAxQgbAwAMA2QAOA6AwAmQAwAnBEAGQB5AKDyAQQAcABAeAKQBAASARA6QAQA6guAvQguAugvAKQjGAoikgdQi2ghiTh4QjBihhVkfQhxl9Btk3QBYj/D1jIQCNhzCzhUQCchKDFg4QF9htHlgZQDdgLCeACQDNACCtAXQCkAXB/AoQCXAwB3BOQE6DRAIGPQAECigqCsQgkCThKCpQjdH8m4HXQh8CGh0BlQiGB0iIBUQkkC1k+AAIgrgBgAm3EXQAAAggCAVQgBAQAHAJQAHAIAQAHQCeA6CXgIQCRgJBfhCQBZg/AMhsQANhxhWhIQgygqhdg3QgagQg8geQg5gdgdgSQg7glgggqQgkgvAOgxQAPgyA3gUQA7gVBLAAQBzgCB3BZIAAgbQABhegRgWQgRgVhdgVQhsgZhZAMQhmAOhSA9QhdBEgFBwQgGBxBXBJQAgAcA1AeIBaAzIBcAxQA3AfAhAXQAeAUAOAfQAOAfgDAmQgDAqgfAbQgeAcg3AJQhUAOhcgVQhIgQhfgpIgngRIABA5gAJFhCICFCeQBOBfA3A+QBGBOBFAtQBCAqBPgEQA/gEBQgiIg8gVQgigNgVgMQg+gmgpgsQhAhFhbhmIiairIgSgXIgUgYQAPgMDNjCQCEh8BlhGIjTAAQgHAAgPAMIk9E0IgcAZIghAdIAAs3IjGA0IAOBOQAIAtAAAdQADF/gBG0QAAA7ACB3QgCBogXBKIDZAAQgShhAAiMQAEidgBhPQANAJAMANg",
      );
    this.shape_3.setTransform(178.4251, 153.4012);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ai9X+Ql1gNlajrQlTjpjkl6IgIgPQClBpC3AdQCuAcDDgpQB1gZBHhMQBbhjgdh3Qgdh3h/gsQg9gVhZgHQhmgFgygEIg/gEQgkgEgZgFQgvgKgMgjQgNgkAdglQAsg6BGAIQB6AMBqguQCJg7AniKQAoiKhVh7IgUgcICyAKIAAhyQhbAJgtADQhWAGhsgeQhjgchWAEQhfAEhUAsQhZAugtBKQgtBLACBkQAEC7CyBaIAVALIggAUQg/AlgaAxQgaAwANA2QANA6AwAmQAxAnBEAGQB5AKDyAQQAaACAgAJQA/ASARA6QARA6guAvQgUAUgXAPQgaAQgYAFQjGAoilgdQi1ghiTh4QjCiehVkhQg2i3gDiiQgEi2A5ilQBZkAD0jGQCNhzCyhUQCchKDGg4QF9htHlgZQDdgMCeACQDMACCuAYQCkAWB/AoQCWAwB4BPQE6DQAIGQQADCigpCrQgkCUhKCpQjdH7m4HYQh9CGhzBkQiGB1iIBUQkjC0lDAAIgnAAgAxXgxQhYg7gMhwQgHg9ALgxQAOhBAvgoQAugnBDgEQBSgGA8AiQA7AiAdBFQALAaAFAbQACAKAFA3QgCBSgiA0QgiA1hBATQgmALglAAQhBAAg4glg",
      );
    this.shape_4.setTransform(178.4005, 153.3928);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0.1, 0, 356.7, 306.9);

  (lib.Darpasvg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics.f("#FFFFFF").s().p("AgKgNQAFgSASgCIgTBDQgJgdAFgSg");
    this.shape.setTransform(342.2607, 117.85);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgEAvQgDgFABgCQACgUAJhIQAAAAAAAAQAAgBABAAQAAAAAAAAQABAAABAAIAABfQAAAEgIAIIgEgHg",
      );
    this.shape_1.setTransform(274.4458, 139.15);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f("#FFFFFF").s().p("AgUAuIAAhcIApAAIgmBdIgDgBg");
    this.shape_2.setTransform(74, 91.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f("#FFFFFF").s().p("AgbA/IAAh9QAUAxAjBMg");
    this.shape_3.setTransform(74.95, 139);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#FFFFFF")
      .s()
      .p("AgJgHQgegsgtgiICpAiIgyCJQgSg1gagog");
    this.shape_4.setTransform(114.45, 84.6);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f("#FFFFFF").s().p("AAWhRIA1CFQhmAVgvAJg");
    this.shape_5.setTransform(116.5, 146.325);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#FFFFFF")
      .s()
      .p("AiRgRQAHgIAiAAIDnAAQAFAAAIAEIAOAHQAAAFgEAFIkuAeQgBgiAIgJg");
    this.shape_6.setTransform(158.9944, 145.875);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#FFFFFF")
      .s()
      .p("AgTCbQAOhWgEhFQgFhSgfhIIANAEQAIADABAEQBCCTADCRIgCAGg");
    this.shape_7.setTransform(333.975, 96.15);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics.f("#FFFFFF").s().p("Agyh/IBkAIIgVD2IgCABg");
    this.shape_8.setTransform(177.5, 98.5);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics.f("#FFFFFF").s().p("Ag9BsIA7jXIAFAAIA7DXg");
    this.shape_9.setTransform(159.15, 101.175);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#FFFFFF")
      .s()
      .p("Ai/gkIAAgJQAlgaARgLQAEgCAHABQAGAAAFACIEsCZIAHAEIgDAIIl8h4g");
    this.shape_10.setTransform(180.65, 206.47);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f("#FFFFFF").s().p("Ag8BrIA5jVIAFAAIA7DVg");
    this.shape_11.setTransform(365.4, 100.9);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#FFFFFF")
      .s()
      .p("AiVBSIgmgdIgNgGIADgMIGKh7IAEAJIgYALQibA/iGBYQgKAGgJAAQgKAAgIgHg");
    this.shape_12.setTransform(178.65, 22.738);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#FFFFFF")
      .s()
      .p("AjXBXIA1gYQAggOAUgKQCChGBgg4QANgIAJgBQAKgBAKAHIA6AjIgBANQkcBbiOAwg");
    this.shape_13.setTransform(278.55, 205.4688);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#FFFFFF")
      .s()
      .p("ACJBjQgGgCgEgDQiWhsjJhQIgEgEQDqAzDfBcIgqAcIgpAaIgDAAIgGAAg");
    this.shape_14.setTransform(280.475, 24.4375);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#FFFFFF")
      .s()
      .p("AhoBCQAWhRAMgoQABgDAFgEQAEgDAFAAQA4gBA4ABQAFAAAFAFQAEADACAFIAgB2g");
    this.shape_15.setTransform(159, 121.1625);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#FFFFFF")
      .s()
      .p("AhoBEIAhh5QABgFAHgEQAGgDAEgBQA1gCA0ACQAEAAAGADQAGADABAEIAkB8g");
    this.shape_16.setTransform(365.35, 121.0125);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#FFFFFF")
      .s()
      .p("AhJB+QAdg3AEhDQADgugJhNIBggGIAYD7g");
    this.shape_17.setTransform(266.55, 99.4);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAgBIQhggYhNgSQAJgpAPgzQABgDAFgEQAGgDAEAAIDpABIAKAHIhiCDQgBADgEABIgGACIgBgBg",
      );
    this.shape_18.setTransform(362.6, 150.6063);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#FFFFFF")
      .s()
      .p("AjXBLQgKgCgHgKQgigqgeghQExg4EggGIhXAVQjKA9jKBAQgKADgHAAIgEAAg");
    this.shape_19.setTransform(178.175, 16.9455);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#FFFFFF")
      .s()
      .p("AhHA5QgWhEANg9QAFgUABgeIABg1ICeAAIhmFfQgqhUgMgjg");
    this.shape_20.setTransform(128.4586, 132.3);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgSC0QgMgCgCgIIAAgQQgJiIg2iEIgIgUIAAgFIDPgoIhkFSQgDALgDAFQgFAFgKAAIgBAAg",
      );
    this.shape_21.setTransform(344.45, 93.9771);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#FFFFFF")
      .s()
      .p("ADiBYQj6hmkrhDIgLgHQFgAOE9BFIhaBcQgCACgGAAQgGAAgFgBg");
    this.shape_22.setTransform(281.6, 17.975);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgICMQgKgKgCg/QgDgwgKglQgPg+g8gdQAWgZAegJQAZgIAhADQAVACAegBIA4AAIgPDNIgJBIQgCATgVAAIgKABQg0AAgIgKg",
      );
    this.shape_23.setTransform(262.975, 129.4511);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#FFFFFF")
      .s()
      .p("AlLATIgGgIQA5g9AfgfQAEgDAGgBQAHgBAEACQD+BgE3BKQlMgElQg/g");
    this.shape_24.setTransform(182.9, 213.1333);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#FFFFFF")
      .s()
      .p("AiMBXIAAitIBoAEQA9ACAoADQATACAPAMQAPAMAFATQAJAmANBRg");
    this.shape_25.setTransform(231.6, 134.7);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics.f("#FFFFFF").s().p("AhbB/IAVj9ICiAJIAAD0g");
    this.shape_26.setTransform(192.25, 99.2);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#FFFFFF")
      .s()
      .p("AgQCOQgHgFgCgFQgqiHgShEQgDgPgCgVIAAgnIC1AAIgBEhQhAAEgeAAQgFAAgHgFg");
    this.shape_27.setTransform(192.2, 129.5);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#FFFFFF")
      .s()
      .p("AjqA9QD/hBDWhVQAOgGAKABQAKACAKAKQAeAfA9A6QgBAGgDADQltBLlyAEICHgig");
    this.shape_28.setTransform(277, 211.9173);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#FFFFFF")
      .s()
      .p("AAXBPQi5hShWg9QCEhFB6gZIA4BXQAgAzAaAfQAZAhAnArIBBBIIgCAAQgtAAizhQg");
    this.shape_29.setTransform(195.3, 202.5287);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AiCB/IAAj8IBYgBQAyAAAkACQAhABAXATQAVAUAGAgQAIA6gIA9QgFAfgUAPQgTAOghAAg",
      );
    this.shape_30.setTransform(304.2, 99.325);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgtByIhmgBIAAjhIDIAAQAvgCATAPQATAQAIAvQAFAbgEAgQgHArgVAVQgWAWgrADQgiACguAAIgTAAg",
      );
    this.shape_31.setTransform(232.2889, 99.2473);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AiGAdQgBgKAGgSIAyiSQABgFAHgFQAIgFAEABIDCAdIhFDsQgMAogJAGQgJAHgqAAQgkABhKAAIgSiDg",
      );
    this.shape_32.setTransform(132.8359, 96.1417);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AjPBpQAigkAVgcQAcgmAkg3IA9hhQAIgMADgCQAGgGALACQCWAfBrAwIAKAIQjpCdkuBbIA8g/g",
      );
    this.shape_33.setTransform(262.375, 202.0733);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#FFFFFF")
      .s()
      .p("AkHA9QD4ieEXhIQhRBBhBBbQg4BNg0BqQifgnhyhGg");
    this.shape_34.setTransform(194.05, 27.4);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AiiB9QAChJAZhOIAEgMIAqhWIBGAEQAnADAcAGQAdAGAWAYQASASAPAiQAOAcAJAuQAJAvgCAhg",
      );
    this.shape_35.setTransform(88.2682, 99.375);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgUCrQgIgFgHgPQhQiqh0hvQglgggOgLQE7BSD5CsIhKAeQgrARgcAJQgYAHgqALQgvALgUAGQgGACgGAAQgHAAgFgDg",
      );
    this.shape_36.setTransform(264.35, 28.069);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ag9CaQgEAAgFgDQgFgDgDgDQhTiPgCiSIAEgKIFBAAQAGBVgTBOQgUBUg3AjQgrAbhIAAIgUgBg",
      );
    this.shape_37.setTransform(88.272, 129.9732);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "ACGCzIllgsQgEgBgFgEQgGgEAAgEIgBiUIBuAAIA9AAQAjAAAZgDQBvgPArhlQAJgUAMgIQANgIAVACQAgADADACQAFAEgCAfQgICZhDCUQgFALgGAEQgEADgHAAIgIgBg",
      );
    this.shape_38.setTransform(314.8036, 132.2133);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AkVDeQgNgGg7gmQDwirCIjqIgZBbIBbAAQALAAAZADQAUAAAKgGQAJgFAGgUIALgjICmAlQhNBVh0BSQiuB9jiBeQgHAEgIAAQgKAAgKgGg",
      );
    this.shape_39.setTransform(329.5, 175.7531);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AEXDtQiohFh+hHQiXhVh2hkQgLgJhEhAIFIhNIgXBVIAKACIAKAAQAbgFAUAMQARAKATAaQBmCOC7CFIAdAVIhBAxQgEACgEAAQgFAAgGgCg",
      );
    this.shape_40.setTransform(129.25, 177.1875);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAADdQhyjcjXikQgIgFgDgDIgEgHIBQg4QAIgFAKAEQCxBNCFBXQCaBjBzB8IANAQQhFAAgMABQgHABgRANIgKAJQgGAGgFAAIjAAmIgHABQgPAAgGgQg",
      );
    this.shape_41.setTransform(331.9, 54.0533);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgpDyIk7hBIgEgPIBYhOQAzgtAmgdQC8iREMhoQAGgDAIABQAIABAEAEQANAIASAPIAfAZQhDAzgfAaQi3CVhkDBQgDAEgHAEQgFADgEAAIgCAAg",
      );
    this.shape_42.setTransform(127.075, 52.6812);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#FFFFFF")
      .s()
      .p("AgNC6Qiwh+hpjUIABgFQElg3EnAsQhoDai3CHQgEADgGAAIgCAAQgFAAgEgCg");
    this.shape_43.setTransform(228.7, 201.6631);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AjmDdQgEgHgBgFQgji4g8iPIgDgLIA+gPQAlgIAYgJQBNgZBVglQARgHAKABQAMAAANALQBnBRBLBUQBVBdA3BqIALAXQgEACgBAFIgUgGQgLgEgEgFQhAg+heAAIlcAAIAABtQAAAEgDAHIgGAMIgIgKg",
      );
    this.shape_44.setTransform(296.7, 61.0983);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAADGQifgDiZgeIAqhIQAYgqASgaQBYiGB1hPQANgJALAAQAMAAANAJQCXBrBgCzIAoBQQiTAUiHAAIgfAAg",
      );
    this.shape_45.setTransform(228.4, 28.5378);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgvDgQiBg7iTgaIgMgFIAGgRQBCiUAhisQADgOAEgEQAGgGAOAGIAACPICcAAIAAiJIF5AtIAGALIg/BXQglA0gbAhQhdBtiHBhQgHAEgHABIgHABIgHgBg",
      );
    this.shape_46.setTransform(295.5, 169.4256);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AAaDkQjGiGh1idIgRgWIAOgCQAkgCAIgGQAHgGAJgkQAMgtAJgJQAKgIAvgFQC/gUApgFQASgCAJAGQAIAGAEASQAGAgATA+QACAKAEAFQAGAEAKAAIAigCQASAAAKAHQAIAGAFATIAIAgQAWA7AmBjQg3ANgaALIisBIQgIACgHABIgCAAQgIAAgDgDg",
      );
    this.shape_47.setTransform(164.2, 170.9296);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "ACDDqQgFAAgFgGQgGgFgCgFQgRg7gLgeQgCgFgHgFQgHgGgFAAQhIgBhLABQgFAAgGAGQgGAFgDAFIgKAfIgKAfQgCAGgGAEQgGAFgFAAQhWgLhqgRIAjg6QAUgiAOgVQBuieC8iLQALgIAJgBQAKgCAMAIQBfA7CPAnIAWAHIhtF1QhDgFgcgEg",
      );
    this.shape_48.setTransform(159.875, 59.5882);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AmoCxQAijIBIiiICNAPQBVAIA3AEQCaALCwgbQASgDAJAFQAKAGAHARQBACoAYCfQg8AEgbAAQgEAAgGgFQgFgEgDgGQgvh0iQgFQhOgChxAAIjBABIgLACQACAtAABeIiggJg",
      );
    this.shape_49.setTransform(228.175, 66.275);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AB6EBQgIgCgFgEQhoh1iMhgQh6hUighLQgWgLgxgVIBXhkQACgDAGAAQAGgBAFABQD5A5DBBKQDkBXC5B6QADAAANAKQhBA5hjAnQg6AXiDArIgHACIgHgBg",
      );
    this.shape_50.setTransform(357.1, 44.0121);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AmYgcIA9AAIgsiXIBqgGIAACZICdAAIAAibIESAAIAOCAQABARAJAHQAIAHASgBQAXgBB6AAIgDgTQgCgJgDgFQgQgXgEgiQgBgQABgrIBgAAIgkB+IgkB4QgKAggbA9QgEAKgFAEQgHADgLgBQjbgejKATQghADg2AHIhdANg",
      );
    this.shape_51.setTransform(230.05, 164.9);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AjXD2Ih8gzQhFgggwgjQgKgHgOgMIgZgYIBBgmIA+gjQEvigGahdQAOgDAfgKQAagHAQAFQAOAFARAWIAaAlIAbAdQhSAkgoATQkiCIi4CzIgMALQgUAigdAGIgNABQgWAAgdgNg",
      );
    this.shape_52.setTransform(103.25, 42.204);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AmDD/QgNgFgMgQQgTgYhChEIBfguQA6gcAlgTQD4iBCfimQAFgFAHgDQAJgEAFACQBtAeBHAcQBgAmBHAzQAGADAHAGIAMAKQiIBbiwBOQjoBnk2BJQgJACgIAAQgIAAgGgCg",
      );
    this.shape_53.setTransform(355.8, 186.8202);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#FFFFFF")
      .s()
      .p("Al8EpQAJiTBciMQA6hYBVhQQBKhFBmhGQA/BABgAwQA2AaCAAxIkZAAIAAGXg");
    this.shape_54.setTransform(46.775, 82.15);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AGTEDQlvhJkbiBQg1gYhPgoIiIhHQA4gvAMgHQA+gqBRggQBAgaBagaQAEgCAIADQAIACADAEQBiBlCCBWQBuBJCSBFQA2AcBpArIhZBsQgDADgIAAQgGAAgHgBg",
      );
    this.shape_55.setTransform(104.3, 188.085);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#FFFFFF")
      .s()
      .p("AjwAeQh7iwAKisIHcAAIAAHWIDnAAIABAIQhvAtgnAUQhSApg0A0QjEh5hzing");
    this.shape_56.setTransform(44.3874, 146.55);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AgQEwQhGg2hfgoQhGgehughIgagJIBtidIAgBwQAEAMAFAdQAFAYAKAHQALAIAYAAIApgBIBUAAQhDjihMj6IJQgBQADB+g5B3Qg0BshYBeQhNBThvBOQgDADgHAAIgCAAQgGAAgDgCg",
      );
    this.shape_57.setTransform(408.2075, 144.9792);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AjtEfQgIh6g3h3QgOgfgQgsIgchOIgCgPQBwgmA+gcQBdgrBCg3QCpB9BYB2QBwCVATC1g",
      );
    this.shape_58.setTransform(410.85, 83.2);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#000000")
      .s()
      .p(
        "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",
      );
    this.shape_59.setTransform(227.9016, 115.3998);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "At7QiQjzg1jKhKQjjhUi/h0Qh2hIhahNQhmhYhIhjQiSjJAHjXQAHjQCUi/QBYhwB4heQBqhUCLhLQFSi5HVhiQFEhDFcgOQF+gQFfAtQEpAnD7BFQEYBNDxB6QD2B8CmCjQBcBbA5BdQBBBpAXByQA0D5iXDmQhJByhuBhQhfBViCBPQidBhi8BLQimBCjJA1QlRBXlKAYQhKAGhvAGIi6AJQncgEmlhcg",
      );
    this.shape_60.setTransform(227.6404, 115.3998);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 455.6, 230.8);

  (lib.biogensvg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#000000")
      .s()
      .p(
        "AgbAxQgOgIgHgNQgHgNAAgPQAAgMAIgPQAIgOANgHQALgHAPAAQAPAAAMAHQAOAIAIANQAHANAAAOQAAAPgHANQgHANgOAIQgOAHgOAAQgNAAgOgHgAgWgmQgLAHgGAKQgGAKAAAMQAAAMAGAKQAGALALAGQAMAGAKAAQALAAALgGQAKgGAHgLQAFgKAAgMQAAgKgFgMQgHgMgKgFQgLgGgLAAQgLAAgLAGgAAKAeIgFgKQgFgKgDgCQgCgDgGAAIgCAAIAAAYIgMAAIAAg6IAeAAIAIACQADACAEAEIACAJQAAAHgFAEQgEADgIACIAFACIADAFIAEAHIAHAMgAgNgDIAEAAQALAAACgBIADgDQABgBAAgEQAAgBAAgBQAAAAAAgBQAAAAAAAAQgBgBAAAAIgDgDQgDgBgKAAIgEAAg",
      );
    this.shape.setTransform(431.55, 118.475);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#FFFFFF")
      .s()
      .p("AiDBIQAAhBAognQApgoA9ACQA0ACAlArQAkAqgFA3g");
    this.shape_1.setTransform(333.8052, 78.9952);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AhNBKQgfgZgBguQgBgrAcgcQAdgcAwgBQAzgCAfAZQAfAYACAsQABAzgbAaQgbAbg1ABIgFAAQgvAAgdgZg",
      );
    this.shape_2.setTransform(275.6014, 80.4998);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "Ag3BHQhJgNgngrQgKgMgCgUQgCgWAIgPQAIgOAQgFQALgDAUABICYAGQBMADAWAHQA8AQgNAzQgGAZgfAPQgPAHgnALQgMAEgcAEQgVACgWAAQgdAAgfgFg",
      );
    this.shape_3.setTransform(275.7975, 128.563);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#FFFFFF")
      .s()
      .p("AiSBvIAAjZIAHgEIBdAAQA1AAAnACQAxAEAbAeQAbAdgCAuQgBAxgeAeQgdAegyABg");
    this.shape_4.setTransform(127.779, 65.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#FFFFFF")
      .s()
      .p(
        "AguByIhvgBIAAjfIAUgDICtAAQA2ABAiAfQAhAfABAxQABAtgaAfQgaAhgsAEQgiACguAAIgdAAg",
      );
    this.shape_5.setTransform(128.8519, 99.5861);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f("#000000").s().p("AhBhGICDAAIAACMIiDABg");
    this.shape_6.setTransform(174.1, 49.6);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics.f("#000000").s().p("AhBEqIAApSICDgBIAAJTg");
    this.shape_7.setTransform(174.1, 93.425);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#000000")
      .s()
      .p(
        "AiQEhQgEgEgGgMQg1hrgChqQABh3BJhiQA7hQBgg0QAEgDAIABQAIACADADQA7BLAkA9QAsBMAWBKQAYBWhKA8Qg5AvhMAmQg6AdhYAeIgJACQgGAAgEgDg",
      );
    this.shape_8.setTransform(20.9847, 31.3199);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#000000")
      .s()
      .p(
        "Aj2EyIAApSIB5AAIAAB/IAmg8QBNhuB+AjQA7AQAhAqQAjArACBAQACBZAAB/IgBDcIiGAAIAAlzQAAgbgFgSQgMgxgqgSQgpgRgsAYQhGAogEBPQgDAtgBBDIgCD2g",
      );
    this.shape_9.setTransform(393.9, 92.6276);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#000000")
      .s()
      .p(
        "AgwE3QiKgUg5iCQhOiwBTidQAphOBNglQBMgkBaANQA7AJAyAiQAxAiAfAzQAvBQAABlQAAAsgLAvQgdBuhPA7QhHA4hcAAQgXAAgZgEgAhqiCQg5B/A2CDQAPAnAhATQAfASAqgDQA+gFAdguQAagqAIhLIAAglQgDg7gWg9QgNglgcgTQgbgSgnAAIgEAAQhNAAgeBEg",
      );
    this.shape_10.setTransform(216.4231, 93.3438);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#000000")
      .s()
      .p(
        "AgLE5Qh3gGhEhNQg8hFgLhcQgTiUA9hlQAthLBMgiQBLgiBXAPQBSANA4A1QA4A2ASBXQACAFACA6IACA3ImaAAQgPA0AdA1QAbA1AzAVQA2AWAygSQAxgTAbgzIANgbIAvAJQAzALAWADQgWBShIA2QhDA0hkAAIgTgBgAhYivQgpAoABBBIEFAAQAFg3gkgrQgkgrg1gCIgGAAQg5AAgmAmg",
      );
    this.shape_11.setTransform(333.5744, 93.2824);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#000000")
      .s()
      .p(
        "AhnF8QiJgQhUhbIBEgZQApgOAagNQBigxA/gpQA3gmANguQAOgtgYg+Qg0iMhziFIgZgfQB2gnB7AwQCGAzBEB/QBECAgkCNQgjCPh3BRQhjBDhzAAQgXAAgZgDg",
      );
    this.shape_12.setTransform(54.8338, 38.1786);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#000000")
      .s()
      .p(
        "AjBGaQhxgjADhrQAEhKBQgsQg7hNAJgwQAIgxBSgyIgOgNQhIg5AIhYQAJhXBSgsQAxgaA7gFQAxgFA+AIQBCAIA0gVIBkghQAGAeANBVIhQAJIAKAVQAgA1gKA5QgKA4gwAnQg3AshHALQg6AKhOgOQhBgKgJAwQgEAaAQAUQAQAUAeABQApACA9ABIBoAAQBeACA1A1QAsAtABBBQABBBgtAqQg3A0g2AQQhTAahTAAQhYAAhagcgAgLk1QgwACgcAcQgcAcAAAsQABAtAfAaQAfAaAzgCQA0gBAbgbQAbgbgBgyQgBgsgfgZQgegXgvAAIgGAAg",
      );
    this.shape_13.setTransform(276.1972, 101.6255);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#000000")
      .s()
      .p(
        "AhoGWIi2gBIgQgDIgBsnIBjAAQDbACBIAEQA9ADAsAeQAsAfAXA5QAXA5gGAzQgGA4goAsQgNAPgZARQgdARgOAKIAKADQB+AkARCGQAJBBgdA7QgeA9g2AaQg7Acg/ADQg+AChUAAIgiAAgAijA3IAADgIBwACQBAAAArgDQAsgDAbghQAZgggBguQAAgxghgfQgigfg2gBIitAAIgUADgAickfIgEABIgDACIAADbIC3AAQAygCAdgeQAegdABgxQACgvgageQgbgegygDQglgDg3AAIhdABg",
      );
    this.shape_14.setTransform(129.4463, 82.9042);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 437.2, 145.4);

  (lib.Logo_GSK = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.GSKsvg("synched", 0);
    this.instance.setTransform(
      73.25,
      51.6,
      0.315,
      0.315,
      0,
      0,
      0,
      178.4,
      153.7,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Logo_GSK,
    new cjs.Rectangle(17.1, 3.2, 112.4, 96.7),
    null,
  );

  (lib.Logo_Darpa = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.Darpasvg("synched", 0);
    this.instance.setTransform(
      70.5,
      39.25,
      0.2949,
      0.2949,
      0,
      0,
      0,
      227.8,
      115.7,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Logo_Darpa,
    new cjs.Rectangle(3.4, 5.2, 134.29999999999998, 68),
    null,
  );

  (lib.Logo_ConsumerGoodsCompanyLogo = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.Top3ConsumnerGoodsLogosvg("synched", 0);
    this.instance.setTransform(49.6, 49.3, 0.243, 0.243, 0, 0, 0, 184.8, 163.6);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Logo_ConsumerGoodsCompanyLogo,
    new cjs.Rectangle(4.7, 9.6, 89.7, 79.5),
    null,
  );

  (lib.Logo_Biogenbw = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.biogensvg("synched", 0);
    this.instance.setTransform(
      45.7,
      18.15,
      0.2125,
      0.2125,
      0,
      0,
      0,
      218.3,
      72.7,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Logo_Biogenbw,
    new cjs.Rectangle(-0.7, 2.7, 92.9, 30.900000000000002),
    null,
  );

  (lib.Quote14testimonialConsumergoods02 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-105.725, -112.025);

    this.instance_1 = new lib.Logo_ConsumerGoodsCompanyLogo();
    this.instance_1.setTransform(56.7, 99.05, 0.7684, 0.7684);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_1.setTransform(-1.5679, 74.775);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_2.setTransform(-8.6529, 74.875);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_3.setTransform(-13.325, 73.6);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(-18.3923, 74.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_5.setTransform(-22.675, 73.6);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgLhDIANAAIAHA3IAdg3IANAAIgoBDg");
    this.shape_6.setTransform(-26.95, 74.85);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_7.setTransform(-32.025, 73.6);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhcIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXgBgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgJIADgKQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_8.setTransform(-38.312, 73.6);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_9.setTransform(-50.3292, 74.9);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAGgFAHAAIACAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_10.setTransform(-55.65, 74.775);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_11.setTransform(-62.0188, 74.9);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgGgDgEQgCgFgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgKg",
      );
    this.shape_12.setTransform(-68.535, 74.85);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_13.setTransform(-75.6679, 73.575);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-80.3821, 73.95);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_15.setTransform(-83.825, 73.6);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_16.setTransform(-89.3688, 74.9);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_17.setTransform(-96.3792, 74.9);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p("AAOAuIAJgrIgvAAIgJArIgNAAIAUhcIANAAIgJAnIAwAAIAIgnIANAAIgUBcg");
    this.shape_18.setTransform(-104.3, 73.6);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_19.setTransform(-61.6321, 58.15);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_20.setTransform(-67.2923, 59.075);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_21.setTransform(-71.575, 57.8);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_22.setTransform(-74.5821, 58.15);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_23.setTransform(-80.6679, 58.975);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgJAEgQQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_24.setTransform(-87.7292, 59.1);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_25.setTransform(-92.425, 57.8);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgLADgOQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgJg",
      );
    this.shape_26.setTransform(-97.285, 59.05);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAoQgIgIADgPIAMAAQgBAIACAFQAFAJAPgBQAHAAAGgBQAMgFACgKQACgHgEgDQgEgDgKgDIgLgDQgMgDgEgCQgIgGACgMQADgMAKgIQALgIAPAAQAOAAAJAHQAJAHgDAQIgMAAQAAgIgCgEQgEgHgOAAQgKAAgGAFQgGAEgBAGQgCAIAFACQAEACALAEIANACQAJADAEADQAIAGgDAMQgDAQgNAGQgNAHgOAAQgRAAgIgJg",
      );
    this.shape_27.setTransform(-104.7787, 57.8);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_28.setTransform(77.825, 12.1);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_29.setTransform(72.4, 7.825);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAqQgQgOAAgcQAAgWAMgOQANgQAUAAQAUAAAKAKQAKAKABANIgNAAQgCgKgHgFQgHgGgMAAQgNAAgJAKQgJALAAAUQAAASAIALQAJALAOAAQAPAAAIgMQAEgGACgKIANAAQgCAQgJALQgMANgVAAQgPAAgMgLg",
      );
    this.shape_30.setTransform(63.05, 7.825);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_31.setTransform(53.65, 7.825);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_32.setTransform(40.975, 9.225);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_33.setTransform(33.275, 7.8);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_34.setTransform(27.4, 8.225);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_35.setTransform(17.775, 9.225);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_36.setTransform(10.875, 7.825);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_37.setTransform(5.375, 7.825);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_38.setTransform(2.3, 7.825);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_39.setTransform(-7.25, 10.675);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_40.setTransform(-14.725, 9.1);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_41.setTransform(-20.175, 7.825);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgMAAIgWhIIAOAAIAOA4IAOg4IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_42.setTransform(-26.8, 9.2);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAIQAGAIAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_43.setTransform(-35.75, 9.2);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_44.setTransform(-41.1, 7.825);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_45.setTransform(-44.575, 7.75);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_46.setTransform(-54.275, 9.225);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_47.setTransform(-62.025, 9.225);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_48.setTransform(-67.775, 9.1);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_49.setTransform(-72.425, 7.75);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_50.setTransform(-82.125, 9.225);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_51.setTransform(-87.875, 9.1);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAIQAGAIAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_52.setTransform(-94.55, 9.2);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgDQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_53.setTransform(-104.175, 9.1);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_54.setTransform(102.875, -7.575);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_55.setTransform(95.325, -8.875);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_56.setTransform(83.5, -7.6);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_57.setTransform(77.7, -8.575);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_58.setTransform(66.175, -7.7);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_59.setTransform(56.425, -7.575);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_60.setTransform(48.725, -9);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_61.setTransform(42.85, -8.575);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_62.setTransform(35.225, -7.7);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_63.setTransform(28.575, -7.575);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_64.setTransform(22.825, -9.05);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_65.setTransform(16.975, -7.575);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_66.setTransform(11.225, -7.7);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAHAAAKQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_67.setTransform(4.775, -6.25);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_68.setTransform(-7.225, -8.875);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQACgDAAgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgEAGQgDAGgGABg",
      );
    this.shape_69.setTransform(-12.05, -12.225);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_70.setTransform(-15.75, -8.975);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_71.setTransform(-25.775, -8.875);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_72.setTransform(-33.275, -7.7);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_73.setTransform(-40.875, -7.575);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAPA4IAOg4IANAAIgWBIg");
    this.shape_74.setTransform(-53.85, -7.6);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_75.setTransform(-62.8, -7.6);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_76.setTransform(-70.475, -7.7);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_77.setTransform(-82.125, -7.575);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_78.setTransform(-87.5, -8.975);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_79.setTransform(-90.625, -8.975);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_80.setTransform(-96.025, -9);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_81.setTransform(-105, -7.6);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_82.setTransform(96.975, -24.375);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_83.setTransform(87.175, -24.5);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_84.setTransform(80.5, -24.4);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_85.setTransform(74.775, -25.85);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgJgDQgKgCgEgCQgJgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgEQgFgEgKAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_86.setTransform(65.5, -24.35);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_87.setTransform(58.925, -25.775);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_88.setTransform(51.05, -24.4);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_89.setTransform(43.3, -24.4);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_90.setTransform(35.775, -25.675);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_91.setTransform(27.825, -24.375);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_92.setTransform(22, -25.375);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_93.setTransform(16.2, -24.4);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_94.setTransform(8.525, -24.5);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_95.setTransform(-2.925, -25.675);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_96.setTransform(-10.675, -24.375);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_97.setTransform(-16.25, -25.775);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_98.setTransform(-25.125, -24.425);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_99.setTransform(-30.225, -25.775);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_100.setTransform(-35.625, -24.5);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_101.setTransform(-43.45, -24.4);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_102.setTransform(-49.175, -24.5);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_103.setTransform(-53.9, -25.375);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_104.setTransform(-59.225, -24.425);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_105.setTransform(-66.675, -24.375);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_106.setTransform(-72.05, -25.775);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_107.setTransform(-77.525, -24.375);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_108.setTransform(-89.075, -25.8);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_109.setTransform(-94.95, -25.375);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_110.setTransform(-98.375, -25.775);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_111.setTransform(-105, -24.4);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGAAgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_112.setTransform(104.15, -39.725);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_113.setTransform(96.675, -41.3);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_114.setTransform(91.225, -42.575);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_115.setTransform(86.625, -42.575);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_116.setTransform(80.775, -41.3);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgPAAgJgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_117.setTransform(74.1, -41.2);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgMAAIgVhIIANAAIAOA4IAOg4IANAAIAOA3IAPg3IAMAAIgVBIg");
    this.shape_118.setTransform(65.2, -41.2);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_119.setTransform(52.475, -41.3);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_120.setTransform(44.675, -41.175);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_121.setTransform(36.925, -41.175);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_122.setTransform(29.375, -42.475);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_123.setTransform(17.575, -41.175);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_124.setTransform(10.225, -41.2);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBACgEQAAgDAAgEIAAgBIAAgBIgHAAIAAgPIAOAAIAAAOQAAAIgDAGQgEAGgHABg",
      );
    this.shape_125.setTransform(5.55, -45.825);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_126.setTransform(-0.275, -41.175);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p("AAXAyIgXhSIgXBSIgNAAIgbhjIAPAAIATBQIAWhQIAOAAIAXBRIAThRIAPAAIgbBjg");
    this.shape_127.setTransform(-10.4, -42.575);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_128.setTransform(-22.825, -38.3);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_129.setTransform(-26.75, -42.175);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_130.setTransform(-32.475, -41.3);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_131.setTransform(-40.075, -41.175);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgMAAIgWhIIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBIg");
    this.shape_132.setTransform(-49.2, -41.2);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAFACAEQAEAGAIABQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIABgLQgDAEgDACQgIAHgJgBQgOAAgGgKg",
      );
    this.shape_133.setTransform(-62, -41.1);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_134.setTransform(-69.75, -41.2);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgKIAFABIACAAIAGgBIACgEIACgFIAEgIIgbhJIANAAIATA6IAUg6IANAAIgLAfIgLAeQgLAcgDAGQgEAHgMgBg",
      );
    this.shape_135.setTransform(-77.05, -39.7);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgNAAIgUhIIANAAIAOA4IAOg4IANAAIAOA3IAPg3IAMAAIgVBIg");
    this.shape_136.setTransform(-89.5, -41.2);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_137.setTransform(-98.45, -41.2);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_138.setTransform(-106.125, -42.6);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_139.setTransform(103.25, -58.975);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_140.setTransform(99.825, -59.375);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_141.setTransform(90.525, -57.975);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_142.setTransform(84.775, -58.1);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQADAGAJAAQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_143.setTransform(78.1, -57.9);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_144.setTransform(72.3, -58.975);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_145.setTransform(66.975, -58.025);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAFACAEQAEAGAIAAQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIABgKQgDAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_146.setTransform(59.5, -57.9);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_147.setTransform(53.775, -58.1);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_148.setTransform(49.05, -58.975);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_149.setTransform(43.7, -57.95);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_150.setTransform(32.4, -58);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_151.setTransform(26.6, -58.975);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhKIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAHQgEAFgKAAg",
      );
    this.shape_152.setTransform(17.4, -56.5);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_153.setTransform(11.9, -58.975);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_154.setTransform(8.475, -59.375);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_155.setTransform(5.4, -59.375);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_156.setTransform(2.275, -59.375);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_157.setTransform(-2.975, -59.275);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_158.setTransform(-10.725, -57.975);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_159.setTransform(-22.525, -57.975);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_160.setTransform(-30.225, -59.4);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_161.setTransform(-36.1, -58.975);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_162.setTransform(-43.725, -59.45);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_163.setTransform(-49.6, -58);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_164.setTransform(-61.175, -57.975);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgEQAGgDgBgGQAAgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgCgDQgEgEgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_165.setTransform(-68.5, -57.95);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAFACAEQAEAGAIAAQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIABgKQgDAEgDADQgIAFgJAAQgOAAgGgKg",
      );
    this.shape_166.setTransform(-75.95, -57.9);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_167.setTransform(-83.475, -57.975);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_168.setTransform(-90.975, -58.025);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_169.setTransform(-98.425, -57.975);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_170.setTransform(-105.975, -59.275);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_171.setTransform(82.175, -76.075);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_172.setTransform(74.625, -74.775);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_173.setTransform(66.675, -76.075);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_174.setTransform(59.175, -74.9);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_175.setTransform(51.375, -74.775);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_176.setTransform(39.825, -74.9);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_177.setTransform(32.025, -74.775);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_178.setTransform(24.475, -73.45);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_179.setTransform(16.5, -74.8);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgDAAgHQABgEgEgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgEQgDgEgKAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_180.setTransform(5.35, -74.75);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQABgDABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_181.setTransform(0.9, -79.425);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_182.setTransform(-3, -75.775);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_183.setTransform(-6.425, -76.175);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_184.setTransform(-13.8, -75.775);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_185.setTransform(-19.375, -74.775);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_186.setTransform(-27.275, -76.2);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_187.setTransform(-33.15, -75.775);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_188.setTransform(-42.775, -74.775);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_189.setTransform(-49.675, -76.175);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_190.setTransform(-55.175, -76.175);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_191.setTransform(-58.25, -76.175);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_192.setTransform(-65.45, -76.175);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_193.setTransform(-73.275, -71.9);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_194.setTransform(-76.325, -74.9);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_195.setTransform(-82.975, -74.775);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_196.setTransform(-88.8, -75.775);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_197.setTransform(-92.65, -75.775);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_198.setTransform(-98.425, -74.775);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_199.setTransform(-105.975, -76.075);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_200.setTransform(70.95, -92.575);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_201.setTransform(67.525, -92.975);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAGAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_202.setTransform(58.65, -91.55);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_203.setTransform(51.225, -91.575);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_204.setTransform(44.325, -92.975);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_205.setTransform(36.675, -91.575);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_206.setTransform(26.825, -91.7);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_207.setTransform(15.15, -92.575);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgDgBgGQAAgFgEgCIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAGAAAIIgMAAQAAgEgCgDQgEgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_208.setTransform(9.8, -91.55);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAFACAEQAEAGAIABQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIABgLQgDAEgDACQgIAHgJgBQgOAAgGgKg",
      );
    this.shape_209.setTransform(2.35, -91.5);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDgBIAAgKQAIAAACgBQABgBAAgHIAAhRIAMAAIAABSQAAAJgDADQgEAHgLAAgAAAgyIAAgOIAMAAIAAAOg",
      );
    this.shape_210.setTransform(-3.6, -91.5);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_211.setTransform(-10.4, -92.575);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_212.setTransform(-15.975, -91.575);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_213.setTransform(-23.875, -93);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p("AgGAyIAAhXIgiAAIAAgMIBQAAIAAAMIghAAIAABXg");
    this.shape_214.setTransform(-32, -92.975);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_215.setTransform(-41.825, -88.7);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgKIAFABIACAAIAGgBIACgEIACgFIADgIIgbhJIAOAAIATA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgLgBg",
      );
    this.shape_216.setTransform(-46.2, -90.1);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_217.setTransform(-51.25, -92.975);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_218.setTransform(-54.725, -93.05);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_219.setTransform(-64.425, -91.575);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_220.setTransform(-72.125, -93);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_221.setTransform(-78, -92.575);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_222.setTransform(-87.575, -91.7);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_223.setTransform(-95.4, -91.6);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_224.setTransform(-105.05, -92.575);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_225.setTransform(-108.475, -92.975);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgahKIAOAAIASA7IAUg7IANAAIgLAhIgLAdQgLAcgEAHQgEAFgKAAg",
      );
    this.shape_226.setTransform(103.25, -106.9);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_227.setTransform(97.825, -109.85);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_228.setTransform(94.325, -109.775);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_229.setTransform(88.675, -109.675);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_230.setTransform(81.1, -108.4);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_231.setTransform(71.475, -108.5);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_232.setTransform(57.675, -109.675);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_233.setTransform(50.175, -108.5);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_234.setTransform(42.575, -108.375);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_235.setTransform(32.7, -109.375);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_236.setTransform(29.275, -109.775);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p("AASAkIgSgbIgRAbIgPAAIAZgkIgYgkIAQAAIAQAaIARgaIAOAAIgZAkIAaAkg");
    this.shape_237.setTransform(20.35, -108.4);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_238.setTransform(15.325, -109.775);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_239.setTransform(11.875, -109.85);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_240.setTransform(2.15, -108.4);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_241.setTransform(-3.65, -109.375);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_242.setTransform(-13.275, -108.375);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_243.setTransform(-18.65, -109.775);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_244.setTransform(-23.925, -109.675);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_245.setTransform(-31.675, -108.375);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_246.setTransform(-43.7, -106.925);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_247.setTransform(-51.175, -108.5);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_248.setTransform(-56.625, -109.775);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_249.setTransform(-62.075, -108.375);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_250.setTransform(-69.625, -109.675);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_251.setTransform(-81.425, -108.375);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_252.setTransform(-88.325, -109.775);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_253.setTransform(-93.825, -109.775);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_254.setTransform(-96.9, -109.775);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_257.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_257).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote14testimonialConsumergoods02,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote13testimonialGSK04 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AgjBMIAAgHIAJgBIAJgCQADgBACgDQACgDAAgEIAAh6IgHAAIgIAAIgKABQgDAAgEAEIgHAJIgFAKIgEAJIgHAAIAAgpICDAAIAAApIgHAAIgEgJIgFgKIgHgJQgEgDgDgBIgJgBIgJAAIgHAAIAAB5QABAEABADQACADADABIAJACIAJACIAAAHg",
      );
    this.shape.setTransform(-93.2, -85.725);

    this.instance_1 = new lib.Logo_GSK();
    this.instance_1.setTransform(85.7, 142.8, 0.3553, 0.3553);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_1.setTransform(23.8863, 68.825);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAFABADQABAHAJAAQALAAAGgLQAEgFACgKIAHghIAMAAIgPBDIgLAAIADgKIgHAGQgHAGgJAAQgPAAgDgKg",
      );
    this.shape_2.setTransform(17.2625, 67.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_3.setTransform(9.8471, 67.575);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgCgBIgCAAQgIAAgGAGQgFAFgBAIIgIAmg",
      );
    this.shape_4.setTransform(4.55, 67.475);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AglAmQgKgNAFgYQAFgWAQgOQAPgNASAAQANAAAIAFQANAHgBASIgNAAQAAgJgGgGQgGgEgLAAQgMAAgLAKQgLAKgEARQgDARAFAKQAFALAQAAQAMAAAKgHQAKgHADgRIgdAAIACgJIApAAIgKAwIgIAAIgBgLQgIAHgFACQgKAFgMAAQgQAAgKgLg",
      );
    this.shape_5.setTransform(-2.9046, 66.3);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_6.setTransform(-12.825, 66.3);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_7.setTransform(-18.2029, 67.575);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIALAAIgCAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgCgBIgDAAQgIAAgFAGQgFAFgCAIIgJAmg",
      );
    this.shape_8.setTransform(-23.5, 67.475);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_9.setTransform(-27.3321, 66.65);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_10.setTransform(-33.4179, 67.475);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_11.setTransform(-40.5029, 67.575);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_12.setTransform(-48.3132, 66.275);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAwIgDgBIACgKIAEABIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA2IAeg2IAMAAIgRAeIgQAcQgPAZgFAGQgFAGgKAAg",
      );
    this.shape_13.setTransform(-60.225, 68.95);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-64.7821, 66.65);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_15.setTransform(-68.225, 66.3);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_16.setTransform(-71.075, 66.3);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgEQACgGgEgDQgEgCgHAAQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_17.setTransform(-76.6188, 67.6);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAFABADQABAHAJAAQALAAAGgLQAEgFACgKIAHghIAMAAIgPBDIgLAAIADgKIgHAGQgHAGgJAAQgPAAgDgKg",
      );
    this.shape_18.setTransform(-83.4375, 67.65);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAOApQgFADgHABQgFACgHAAQgWAAgJgOQgIgOAEgUQAEgTAMgNQAQgSAXAAQAYAAAJAQQAHANgFATQgBAIgEAIQgGANgKAIIAKAKIgHAIgAgRgeQgLAKgEAUQgEAQAHAKQAGAKARAAIAGgBIAGgCIgHgIIAHgIIAKAKQAHgHAEgIQAEgIABgHQAEgQgGgKQgHgKgPAAQgOAAgLAJg",
      );
    this.shape_19.setTransform(-91.943, 66.525);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_20.setTransform(7.9179, 50.85);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_21.setTransform(2.2577, 51.775);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_22.setTransform(-2.025, 50.5);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_23.setTransform(-9.2929, 51.675);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_24.setTransform(-18.1792, 51.8);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_25.setTransform(-25.5179, 50.475);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_26.setTransform(-33.2132, 50.475);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_27.setTransform(-43.025, 50.5);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHgBQgIAAgFAGQgDACgBAGIgLAAQADgOAJgEQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_28.setTransform(-48.5688, 51.8);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgJADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgHgDgEQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgEADgIIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_29.setTransform(-55.085, 51.75);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_30.setTransform(-59.575, 50.5);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_31.setTransform(-62.5821, 50.85);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAvIgDAAIACgLIAEABIADABIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAbQgPAbgFAFQgFAGgKAAg",
      );
    this.shape_32.setTransform(-68.125, 53.15);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_33.setTransform(-72.525, 50.5);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHgBQgIAAgFAGQgDACgBAGIgLAAQADgOAJgEQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_34.setTransform(-78.0688, 51.8);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_35.setTransform(-85.2179, 51.675);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p("AAcAvIgEgcIgjAAIgQAcIgOAAIA2hdIAOAAIAPBdgAAWAJIgFgpIgXApIAcAAg");
    this.shape_36.setTransform(-93.65, 50.5);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_37.setTransform(-11.575, 4.8);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgCQAGgDAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_38.setTransform(-17, 1.95);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_39.setTransform(-24.225, 1.925);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgMAAIgVhIIANAAIAOA4IAOg4IANAAIAOA4IAPg4IAMAAIgVBIg");
    this.shape_40.setTransform(-33.35, 1.9);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_41.setTransform(-46.125, 1.925);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAGACADQAEAHAIAAQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIABgMQgDAFgDACQgIAHgJAAQgOAAgGgLg",
      );
    this.shape_42.setTransform(-53.9, 2);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgCQAGgDAAgHQgBgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_43.setTransform(-61.2, 1.95);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_44.setTransform(-68.2, 1.95);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_45.setTransform(-73.275, 0.525);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_46.setTransform(-82.575, 1.925);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_47.setTransform(-90.275, 0.5);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_48.setTransform(-96.15, 0.925);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_49.setTransform(88.625, -14.875);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_50.setTransform(82.875, -15);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_51.setTransform(76.225, -14.875);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_52.setTransform(68.525, -16.3);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhHIANAAIAOA4IAOg4IANAAIAPA3IAOg3IANAAIgWBHg");
    this.shape_53.setTransform(59.55, -14.9);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_54.setTransform(46.775, -14.875);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_55.setTransform(39.225, -16.175);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgahJIAOAAIASA6IAUg6IANAAIgLAfIgLAeQgLAcgEAHQgEAFgKAAg",
      );
    this.shape_56.setTransform(31.7, -13.4);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_57.setTransform(24.475, -14.875);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAApIgLAAIAAguQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAvg",
      );
    this.shape_58.setTransform(14.625, -15);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_59.setTransform(2.95, -15.875);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQABAGABADQADAGAJAAQAMAAAEgLQADgGAAgKIAAgjIAMAAIAABHIgMAAIABgKQgDAEgEADQgGAFgKAAQgOAAgGgKg",
      );
    this.shape_60.setTransform(-2.85, -14.8);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_61.setTransform(-10.6, -14.9);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_62.setTransform(-22.375, -16.175);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_63.setTransform(-29.875, -15);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_64.setTransform(-35.325, -16.275);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_65.setTransform(-38.775, -16.35);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_66.setTransform(-48.5, -14.9);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_67.setTransform(-54.3, -15.875);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_68.setTransform(-61.925, -15);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_69.setTransform(-68.575, -14.875);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_70.setTransform(-73.975, -16.275);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgLAAQgBgEgDgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_71.setTransform(-79, -14.85);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_72.setTransform(-86.225, -14.875);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_73.setTransform(-94.175, -14.875);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_74.setTransform(97.8, -32.675);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_75.setTransform(94.375, -33.075);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_76.setTransform(89.125, -32.975);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_77.setTransform(77.525, -31.675);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEAAgGQgBgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgDgDQgDgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAKgHAGQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_78.setTransform(66.15, -31.65);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics.f("#31353B").s().p("AgDAUIgCgnIALAAIgCAng");
    this.shape_79.setTransform(61.675, -36.075);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_80.setTransform(58, -32.675);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_81.setTransform(54.575, -33.075);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_82.setTransform(45.075, -32.975);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_83.setTransform(37.575, -31.8);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_84.setTransform(29.975, -31.675);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_85.setTransform(19.025, -33.075);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_86.setTransform(11.625, -31.725);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_87.setTransform(4.375, -31.675);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_88.setTransform(-3.375, -32.975);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_89.setTransform(-15.2, -31.7);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_90.setTransform(-23.15, -30.225);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_91.setTransform(-32.525, -33.15);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_92.setTransform(-38.4, -31.7);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_93.setTransform(-50.175, -32.975);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_94.setTransform(-57.675, -31.8);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_95.setTransform(-63.125, -33.075);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_96.setTransform(-67.725, -33.075);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_97.setTransform(-79.375, -31.8);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_98.setTransform(-86.975, -31.675);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_99.setTransform(-94.475, -31.725);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_100.setTransform(84.4, -48.4);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_101.setTransform(76.65, -48.5);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgKgBg",
      );
    this.shape_102.setTransform(69.35, -47);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_103.setTransform(57.875, -49.775);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_104.setTransform(50.375, -48.6);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_105.setTransform(42.775, -48.475);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_106.setTransform(30.775, -49.775);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_107.setTransform(23.225, -48.475);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_108.setTransform(15.275, -49.775);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_109.setTransform(9.725, -48.6);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_110.setTransform(3.05, -48.5);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_111.setTransform(-4.225, -48.525);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_112.setTransform(-11.675, -48.475);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_113.setTransform(-17.425, -48.6);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgDQgDgGgKAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_114.setTransform(-27.5, -48.45);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics.f("#31353B").s().p("AgDAUIgCgnIALAAIgCAng");
    this.shape_115.setTransform(-31.975, -52.875);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_116.setTransform(-37.8, -47.025);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_117.setTransform(-45.275, -48.6);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_118.setTransform(-50.725, -49.875);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_119.setTransform(-56.125, -49.9);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_120.setTransform(-62, -49.475);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEAAIAAgLIAFABIACAAIAGgBIACgEIACgFIADgHIgbhKIAOAAIATA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgLgBg",
      );
    this.shape_121.setTransform(-67.35, -47);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_122.setTransform(-72.775, -48.6);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_123.setTransform(-79.425, -48.475);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_124.setTransform(-86.775, -48.5);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_125.setTransform(-94.175, -48.475);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_126.setTransform(81.975, -65.275);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgEgDQgDgFgKgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_127.setTransform(74.65, -65.25);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQAEAGAIAAQAMAAAEgLQACgGAAgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgEADQgHAFgIAAQgQAAgFgKg",
      );
    this.shape_128.setTransform(67.2, -65.2);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_129.setTransform(59.675, -65.275);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_130.setTransform(52.175, -65.325);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_131.setTransform(44.725, -65.275);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_132.setTransform(37.175, -66.575);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_133.setTransform(26.3, -66.675);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAqQgQgOAAgcQAAgWAMgOQAMgQAVAAQAUAAAJAKQALAKABANIgNAAQgCgKgHgFQgHgGgMAAQgNAAgJAKQgJALAAAUQAAASAIALQAJALAOAAQAPAAAIgMQAEgGACgKIANAAQgCAQgKALQgLANgUAAQgQAAgMgLg",
      );
    this.shape_134.setTransform(16.95, -66.675);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA3AAIAAAKIg3AAIAAAiIA8AAIAAAMg");
    this.shape_135.setTransform(7.55, -66.675);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_136.setTransform(-5.075, -66.7);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_137.setTransform(-10.95, -66.275);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_138.setTransform(-14.375, -66.675);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhHIANAAIAOA4IAOg4IANAAIAPA3IAOg3IANAAIgWBHg");
    this.shape_139.setTransform(-21, -65.3);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_140.setTransform(-31.775, -65.4);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_141.setTransform(-38.425, -65.275);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_142.setTransform(-43.825, -66.675);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgLAAQgBgEgDgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_143.setTransform(-48.85, -65.25);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_144.setTransform(-56.075, -65.275);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_145.setTransform(-64.025, -65.275);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_146.setTransform(-73.7, -66.275);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_147.setTransform(-79.5, -65.3);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_148.setTransform(-84.85, -66.675);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_149.setTransform(-93.975, -65.275);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_150.setTransform(92, -82.05);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_151.setTransform(86.925, -83.475);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_152.setTransform(77.4, -80.625);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_153.setTransform(69.925, -82.2);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_154.setTransform(64.475, -83.475);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_155.setTransform(60.95, -83.075);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_156.setTransform(55.15, -82.1);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgQAAQgPAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_157.setTransform(47.4, -82.1);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_158.setTransform(39.725, -83.5);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEABgGQgBgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgEgDQgDgEgKAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_159.setTransform(32.35, -82.05);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_160.setTransform(24.925, -82.075);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_161.setTransform(19.55, -83.475);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_162.setTransform(14.275, -83.375);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgIAFgIABQgPAAgGgLg",
      );
    this.shape_163.setTransform(6.3, -82);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_164.setTransform(-1.45, -82.1);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_165.setTransform(-7.175, -82.2);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_166.setTransform(-11.9, -83.075);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_167.setTransform(-19.6, -83.075);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_168.setTransform(-25.175, -82.075);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_169.setTransform(-33.075, -83.5);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_170.setTransform(-38.95, -83.075);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_171.setTransform(-46.65, -83.075);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_172.setTransform(-51.975, -82.125);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_173.setTransform(-59.225, -82.075);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_174.setTransform(-65.175, -83.55);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_175.setTransform(-74.875, -82.075);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_176.setTransform(-82.575, -83.5);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_179.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_179).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote13testimonialGSK04,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote12testimonialBiogen04 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.instance_1 = new lib.Logo_Biogenbw();
    this.instance_1.setTransform(54.45, 144.55, 0.9023, 0.9006);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTBMQgKgDgIgEIgEAHIgJAAIgCg0IAJAAIAGASQAEAHAGAIQAGAGAHADQAIAEAJAAQAHAAAFgCQAGgCADgDQAEgDACgFQABgFAAgHQAAgIgFgIQgFgIgLgFIgOgFIgQgHQgNgFgHgKQgHgJAAgPQAAgIADgIQAEgHAGgHQAHgFAIgDQAJgEAJABQAJgBAJAEQAIADAHAEIAEgHIAJAAIABAzIgJAAIgFgRQgDgIgFgHQgEgFgHgFQgGgDgJAAQgLAAgHAHQgHAGAAAJQAAAKAFAHQAEAGAJAEIAPAHIAOAGIANAGQAFADAFAEQAEAGADAHQADAFgBAJQABAUgQANQgPANgWAAQgJAAgKgDg",
      );
    this.shape.setTransform(-98.75, -89.9);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_1.setTransform(101.9679, 45.7);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_2.setTransform(95.8821, 46.525);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_3.setTransform(88.8208, 46.65);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_4.setTransform(79.7071, 46.525);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_5.setTransform(73.1679, 45.7);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_6.setTransform(69.1, 46.525);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_7.setTransform(62.7312, 46.65);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_8.setTransform(55.3363, 47.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_9.setTransform(48.5208, 46.65);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgLQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_10.setTransform(40.388, 45.35);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_11.setTransform(30.7179, 45.7);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(24.6321, 46.525);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_13.setTransform(17.5708, 46.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_14.setTransform(8.4571, 46.525);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_15.setTransform(-0.8137, 47.875);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_16.setTransform(-7.6529, 46.625);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_17.setTransform(-12.325, 45.35);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_18.setTransform(-17.6792, 46.65);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgLhDIANAAIAHA3IAdg3IANAAIgoBDg");
    this.shape_19.setTransform(-23.8, 46.6);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_20.setTransform(-31.3792, 46.65);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgLQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_21.setTransform(-39.512, 45.35);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_22.setTransform(-49.025, 45.35);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_23.setTransform(-54.5688, 46.65);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgHgDgDQgCgEgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_24.setTransform(-61.085, 46.6);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-65.575, 45.35);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_26.setTransform(-68.5821, 45.7);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAvIgDAAIACgKIAEABIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAbQgPAbgFAFQgFAGgKAAg",
      );
    this.shape_27.setTransform(-74.125, 48);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_28.setTransform(-78.525, 45.35);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_29.setTransform(-84.0688, 46.65);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_30.setTransform(-91.2179, 46.525);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p("AAcAvIgEgdIgjAAIgRAdIgMAAIA2hdIANAAIAPBdgAAXAIIgGgoIgXAoIAdAAg");
    this.shape_31.setTransform(-99.65, 45.35);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgrIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_32.setTransform(-55.6321, 29.9);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_33.setTransform(-61.2923, 30.825);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_34.setTransform(-65.575, 29.55);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgrIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_35.setTransform(-68.5821, 29.9);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_36.setTransform(-74.6679, 30.725);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAGgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_37.setTransform(-81.7292, 30.85);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_38.setTransform(-86.425, 29.55);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAGQgJAGgLAAQgOAAgFgJg",
      );
    this.shape_39.setTransform(-91.285, 30.8);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAoQgIgIADgPIAMAAQgBAHACAFQAFAKAPgBQAHAAAGgBQAMgEACgLQACgHgEgEQgEgDgKgCIgLgDQgMgDgEgCQgIgGACgLQADgNAKgIQALgIAPAAQAOAAAJAHQAJAHgDAQIgMAAQAAgIgCgEQgEgHgOAAQgKAAgGAEQgGAFgBAGQgCAIAFACQAEADALACIANADQAJACAEADQAIAHgDAMQgDAQgNAHQgNAGgOAAQgRAAgIgJg",
      );
    this.shape_40.setTransform(-98.7787, 29.55);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_41.setTransform(-10.625, -16.15);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALABQAHgBAFgDQAGgDgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_42.setTransform(-16.05, -19);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_43.setTransform(-21.55, -20.025);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_44.setTransform(-27.275, -19.15);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_45.setTransform(-35.075, -19.025);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_46.setTransform(-44.725, -19.15);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_47.setTransform(-52.125, -20.425);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_48.setTransform(-55.575, -19.15);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_49.setTransform(-62.225, -19.025);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAWgMALQgIAHgLAAQgHAAgGgEIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFALAMAAQAIAAAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_50.setTransform(-69.775, -17.7);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgZgjIAQAAIAQAZIARgZIAQAAIgZAjIAaAlg");
    this.shape_51.setTransform(-77.35, -19.05);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_52.setTransform(-84.725, -19.025);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_53.setTransform(-94.325, -20.5);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_54.setTransform(-100.2, -19.05);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_55.setTransform(91.875, -35.95);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_56.setTransform(83.85, -34.375);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_57.setTransform(78.675, -37.225);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_58.setTransform(73.65, -35.8);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_59.setTransform(66.225, -35.825);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_60.setTransform(58.275, -37.125);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_61.setTransform(46.675, -37.125);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_62.setTransform(39.175, -35.95);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_63.setTransform(31.575, -35.825);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_64.setTransform(19.975, -35.825);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_65.setTransform(13.95, -36.825);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_66.setTransform(8.375, -35.825);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_67.setTransform(0.225, -37.125);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_68.setTransform(-9.175, -37.3);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_69.setTransform(-15.05, -35.85);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_70.setTransform(-26.575, -35.95);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_71.setTransform(-34.4, -35.85);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_72.setTransform(-39.775, -37.225);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_73.setTransform(-43.3, -36.825);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_74.setTransform(-48.875, -35.825);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_75.setTransform(-54.9, -36.825);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_76.setTransform(-60.675, -35.825);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_77.setTransform(-66.425, -35.95);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgHAAgNQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_78.setTransform(-72.875, -34.5);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_79.setTransform(-78.825, -35.95);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(-85.475, -35.825);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_81.setTransform(-91.3, -36.825);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_82.setTransform(-97.025, -35.95);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_83.setTransform(-102.475, -37.225);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_84.setTransform(99.775, -52.75);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_85.setTransform(91.95, -52.65);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_86.setTransform(80.15, -51.175);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_87.setTransform(72.675, -52.75);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_88.setTransform(67.225, -54.025);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgCQAGgDAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgMAAQAAgFgDgDQgDgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_89.setTransform(62.2, -52.6);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQABAGABADQADAHAJAAQAMAAAEgMQADgGAAgKIAAgkIAMAAIAABJIgMAAIABgMQgDAFgEACQgGAHgKAAQgOAAgGgLg",
      );
    this.shape_90.setTransform(54.75, -52.55);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_91.setTransform(47.475, -52.675);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_92.setTransform(40, -52.65);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_93.setTransform(34.275, -54.1);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_94.setTransform(24.375, -53.925);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_95.setTransform(17.025, -52.625);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_96.setTransform(9.075, -52.625);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_97.setTransform(3.25, -53.625);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_98.setTransform(-2.1, -52.6);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_99.setTransform(-9.475, -52.75);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_100.setTransform(-14.925, -54.025);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_101.setTransform(-24.225, -52.625);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_102.setTransform(-29.975, -52.75);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_103.setTransform(-36.425, -52.625);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_104.setTransform(-48.425, -53.925);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_105.setTransform(-55.925, -52.75);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_106.setTransform(-63.525, -52.625);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgJgDQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_107.setTransform(-74.9, -52.6);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_108.setTransform(-81.475, -54.025);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_109.setTransform(-88.9, -52.6);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_110.setTransform(-96.125, -52.625);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_111.setTransform(-102.15, -53.625);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_112.setTransform(85.875, -70.725);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_113.setTransform(78.125, -69.425);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_114.setTransform(72.55, -70.825);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_115.setTransform(65.6, -70.825);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_116.setTransform(60.325, -69.425);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAFACAEQAEAGAIABQAMAAAEgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgEACQgHAHgIgBQgQAAgFgKg",
      );
    this.shape_117.setTransform(52.35, -69.35);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_118.setTransform(44.675, -69.55);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_119.setTransform(37.075, -69.425);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_120.setTransform(27.225, -69.55);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_121.setTransform(13.625, -69.425);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_122.setTransform(6.275, -69.45);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_123.setTransform(1.225, -70.825);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_124.setTransform(-2.3, -70.425);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_125.setTransform(-5.725, -70.825);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_126.setTransform(-9.25, -70.425);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_127.setTransform(-15.025, -69.425);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAWgMALQgIAHgLAAQgHAAgGgEIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFALAMAAQAIAAAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_128.setTransform(-22.575, -68.1);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_129.setTransform(-30.525, -69.425);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_130.setTransform(-36.275, -69.55);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_131.setTransform(-46.725, -69.55);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_132.setTransform(-54.55, -69.45);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_133.setTransform(-66.125, -69.425);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_134.setTransform(-75.775, -69.55);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_135.setTransform(-83.175, -70.825);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_136.setTransform(-86.7, -70.425);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_137.setTransform(-94.325, -70.9);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_138.setTransform(-100.2, -69.45);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_139.setTransform(93.75, -87.225);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAJgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAHQAFAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_140.setTransform(87.95, -86.25);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_141.setTransform(82.6, -87.625);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_142.setTransform(73.475, -86.225);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_143.setTransform(61.45, -84.775);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_144.setTransform(53.975, -86.35);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_145.setTransform(48.525, -87.625);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_146.setTransform(42.875, -87.525);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_147.setTransform(35.375, -86.35);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_148.setTransform(27.575, -86.225);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgHAAgNQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_149.setTransform(20.025, -84.9);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEgBgGQAAgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_150.setTransform(12.5, -86.2);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_151.setTransform(3.15, -87.225);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_152.setTransform(-2.65, -86.25);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_153.setTransform(-10.325, -86.35);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_154.setTransform(-21.975, -86.225);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_155.setTransform(-27.725, -86.35);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_156.setTransform(-34.175, -86.225);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEgBgGQAAgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_157.setTransform(-45.55, -86.2);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_158.setTransform(-51.05, -87.225);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_159.setTransform(-56.4, -86.2);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_160.setTransform(-61.475, -87.625);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_161.setTransform(-65, -87.225);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_162.setTransform(-70.725, -86.35);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_163.setTransform(-78.525, -86.225);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_164.setTransform(-83.925, -87.625);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_165.setTransform(-88.925, -86.275);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.instance_1 },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_168.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_168).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote12testimonialBiogen04,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote11testimonialDarpa02 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_2
    this.instance_1 = new lib.Logo_Darpa();
    this.instance_1.setTransform(
      72.7,
      150.9,
      0.5158,
      0.5149,
      0,
      0,
      0,
      22.6,
      24.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AgjBMIAAgHIAKgBIAIgCQAEgBABgDQABgDAAgEIAAh6IgFAAIgJAAIgJABQgEAAgEAEIgHAJIgFAKIgEAJIgIAAIAAgpICEAAIAAApIgHAAIgDgJIgGgKIgHgJQgEgDgDgBIgJgBIgJAAIgHAAIAAB5QABAEABADQABADAFABIAIACIAJACIAAAHg",
      );
    this.shape.setTransform(-86.2, -81.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAwIgDgBIACgKIAEABIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA2IAeg2IAMAAIgRAeIgQAcQgPAZgFAGQgFAGgKAAg",
      );
    this.shape_1.setTransform(50.825, 40.05);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIALAAIgCAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgCgBIgDAAQgIAAgFAGQgFAFgCAIIgJAmg",
      );
    this.shape_2.setTransform(45.8, 38.575);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAEACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_3.setTransform(41.9679, 37.75);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(36.3077, 38.675);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_5.setTransform(32.025, 37.4);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_6.setTransform(24.7571, 38.575);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_7.setTransform(15.8708, 38.7);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_8.setTransform(8.5321, 37.375);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_9.setTransform(0.8368, 37.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics.f("#949EA7").s().p("AgPAuIAThbIAMAAIgTBbg");
    this.shape_10.setTransform(-8.975, 37.4);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgCgHAAQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgCAAgFQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_11.setTransform(-14.5188, 38.7);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(-21.6679, 38.575);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_13.setTransform(-28.7529, 38.675);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_14.setTransform(-33.425, 37.4);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAEACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_15.setTransform(-36.4321, 37.75);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgCgHAAQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgCAAgFQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_16.setTransform(-42.5688, 38.7);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAEACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_17.setTransform(-47.2321, 37.75);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAFABADQABAHAJAAQALAAAGgLQAEgFACgJIAHgiIAMAAIgPBDIgLAAIADgKIgHAGQgHAGgJAAQgPAAgDgKg",
      );
    this.shape_18.setTransform(-52.9875, 38.75);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_19.setTransform(-60.7637, 39.925);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_20.setTransform(-69.4929, 38.575);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_21.setTransform(-78.4029, 38.675);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_22.setTransform(-86.2132, 37.375);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAKAAIgCAMQABgEAGgFQAGgFAIAAIAAAAIADABIgDAMIgBgBIgCAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_23.setTransform(27.1, 22.775);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_24.setTransform(20.8971, 22.875);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_25.setTransform(16.0679, 21.95);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHAAQgIgBgFAGQgDACgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_26.setTransform(9.9312, 22.9);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgeAsQgHgFABgLIAMAAQAAAFACADQADADAIAAQAMAAAGgJQAEgGADgOQgFAFgFAEQgFACgHAAQgMAAgGgIQgHgIAEgRQAEgRAKgJQAKgKALAAQAIAAAFAEIAGAGIABgIIALAAIgNA9QgDANgFAHQgKAOgTAAQgLAAgGgFgAgMgbQgDAGgCAKQgDALAEAGQADAFAIAAQALABAIgMQAEgFABgJQADgMgEgGQgEgGgIAAQgLAAgHALg",
      );
    this.shape_27.setTransform(2.7433, 24.25);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_28.setTransform(-1.775, 21.6);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_29.setTransform(-4.7821, 21.95);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_30.setTransform(-10.4423, 22.875);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_31.setTransform(-17.2292, 22.9);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgLhDIANAAIAHA3IAdg3IANAAIgoBDg");
    this.shape_32.setTransform(-23.35, 22.85);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_33.setTransform(-31.0679, 22.775);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics.f("#949EA7").s().p("AgPAvIAShdIANAAIgTBdg");
    this.shape_34.setTransform(-35.875, 21.6);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_35.setTransform(-45.3292, 22.9);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_36.setTransform(-50.025, 21.6);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_37.setTransform(-55.7637, 24.125);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_38.setTransform(-60.075, 21.6);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgJADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgHgDgEQgCgDgIAAQgKgBgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgEADgIIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_39.setTransform(-64.935, 22.85);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_40.setTransform(-72.0679, 22.775);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_41.setTransform(-76.625, 21.6);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIALAAIgCAMQABgEAGgFQAGgFAIAAIABAAIACABIgCAMIgCgBIgDAAQgIAAgFAGQgGAFgBAIIgJAmg",
      );
    this.shape_42.setTransform(-80.1, 22.775);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAvIAUhdIApAAQAMABAGAGQAGAIgCAMQgDALgIAIQgJAHgOAAIgcAAIgJAogAgSgDIAYAAQAJAAAGgDQAGgEACgJQACgKgHgEQgEgCgHAAIgYAAg",
      );
    this.shape_43.setTransform(-86.6632, 21.6);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_44.setTransform(54.025, -40.9);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgCgDQgEgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_45.setTransform(48.6, -43.75);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_46.setTransform(40.975, -45.075);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_47.setTransform(33.475, -43.9);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_48.setTransform(28.025, -45.175);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_49.setTransform(20.675, -43.9);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_50.setTransform(9.075, -43.9);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_51.setTransform(4.775, -45.175);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_52.setTransform(-0.675, -43.775);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_53.setTransform(-8.375, -45.2);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_54.setTransform(-14.25, -44.775);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgEgDQgDgGgKAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_55.setTransform(-23.45, -43.75);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgNAAIgVhIIAOAAIAOA4IAOg4IANAAIAPA3IAOg3IANAAIgWBIg");
    this.shape_56.setTransform(-32.05, -43.8);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAOAAAKAKQAKAJAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_57.setTransform(-41, -43.8);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_58.setTransform(-46.35, -45.175);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_59.setTransform(-51.625, -45.075);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_60.setTransform(-61.5, -44.775);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_61.setTransform(-64.925, -45.175);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_62.setTransform(-73.8, -43.75);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_63.setTransform(-78.875, -45.175);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_64.setTransform(-84.275, -45.2);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_65.setTransform(-90.15, -44.775);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_66.setTransform(85.65, -61.575);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAFACAEQADAGAJAAQALAAAFgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgDADQgIAFgJAAQgOABgGgLg",
      );
    this.shape_67.setTransform(79.85, -60.5);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAHQAFAIAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_68.setTransform(72.1, -60.6);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_69.setTransform(64.575, -61.875);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_70.setTransform(56.825, -60.575);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_71.setTransform(45.025, -60.575);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_72.setTransform(39.65, -61.975);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgHAAgNQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_73.setTransform(34.375, -59.25);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgPAAgJgKgAgPgTQgFAJgBALQABAMAFAHQAFAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_74.setTransform(26.4, -60.6);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_75.setTransform(18.675, -60.575);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgHAAgNQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_76.setTransform(11.125, -59.25);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_77.setTransform(1.7, -61.975);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_78.setTransform(-1.4, -61.975);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_79.setTransform(-6.875, -60.575);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_80.setTransform(-12.7, -61.575);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_81.setTransform(-20.2, -61.975);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_82.setTransform(-30.025, -60.575);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgHgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIAAQAIAAAGAEQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_83.setTransform(-39.675, -60.7);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_84.setTransform(-47.075, -61.975);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_85.setTransform(-50.6, -61.575);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgCIAAgLIAFABIADAAIAEgBIADgCIACgGIADgIIgbhKIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgDAHQgFAFgKABg",
      );
    this.shape_86.setTransform(-59.8, -59.1);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_87.setTransform(-65.225, -60.7);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_88.setTransform(-71.875, -60.575);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_89.setTransform(-79.225, -60.6);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_90.setTransform(-87.1, -61.975);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p("AgGAyIAAgOIANAAIAAAOgAgCAaIgEgqIAAghIANAAIAAAhIgEAqg");
    this.shape_91.setTransform(63.2, -78.775);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_92.setTransform(56.75, -75.925);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_93.setTransform(49.275, -77.5);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_94.setTransform(43.825, -78.775);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_95.setTransform(40.3, -78.375);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_96.setTransform(36.875, -78.775);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_97.setTransform(31.875, -77.425);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgZgkIAQAAIAQAaIARgaIAQAAIgZAkIAaAlg");
    this.shape_98.setTransform(24.8, -77.4);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_99.setTransform(17.425, -77.375);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAgIgMAeQgKAcgEAGQgDAHgLAAg",
      );
    this.shape_100.setTransform(6.25, -75.9);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_101.setTransform(0.825, -77.5);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_102.setTransform(-5.825, -77.375);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhJIAOAAIATA7IAUg7IAOAAIgcBJg");
    this.shape_103.setTransform(-13.175, -77.4);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgFgEgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_104.setTransform(-24, -77.35);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_105.setTransform(-29.075, -78.775);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_106.setTransform(-37.45, -78.775);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcAqQgPgOAAgcQAAgWAMgOQAMgQAWAAQASAAAKAKQALAKABANIgNAAQgCgKgHgFQgGgGgMAAQgOAAgJAKQgJALAAAUQAAASAIALQAIALAQAAQAOAAAIgMQAEgGACgKIANAAQgBAQgLALQgLANgUAAQgRAAgMgLg",
      );
    this.shape_107.setTransform(-46.8, -78.775);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA3AAIAAAKIg3AAIAAAiIA8AAIAAAMg");
    this.shape_108.setTransform(-56.2, -78.775);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_109.setTransform(-68.875, -77.375);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAgvQAAgHgCgEQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQABAGAKQADAHAAAJIAAAwg",
      );
    this.shape_110.setTransform(-76.575, -78.8);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_4
    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_113.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_113).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote11testimonialDarpa02,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote10testimonialGSK03 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-102.725, -109.225);

    this.instance_1 = new lib.Logo_GSK();
    this.instance_1.setTransform(85.7, 142.8, 0.3553, 0.3553);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_1.setTransform(14.8863, 95.225);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAGABADQABAFAJAAQALAAAGgKQAEgGACgJIAHghIAMAAIgPBDIgLAAIADgKIgHAHQgHAFgJAAQgPAAgDgKg",
      );
    this.shape_2.setTransform(8.2625, 94.05);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_3.setTransform(0.8471, 93.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgCgBIgCAAQgIAAgGAGQgFAFgBAIIgIAmg",
      );
    this.shape_4.setTransform(-4.45, 93.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AglAmQgKgNAFgXQAFgXAQgOQAPgNASAAQANAAAIAFQANAHgBASIgNAAQAAgJgGgFQgGgFgLAAQgMAAgLAJQgLAKgEATQgDAQAFALQAFAKAQAAQAMAAAKgHQAKgHADgRIgdAAIACgKIApAAIgKAyIgIAAIgBgNQgIAIgFACQgKAFgMAAQgQAAgKgLg",
      );
    this.shape_5.setTransform(-11.9046, 92.7);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_6.setTransform(-21.825, 92.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_7.setTransform(-27.2029, 93.975);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIALAAIgCAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgCgBIgDAAQgIAAgFAGQgFAFgCAIIgJAmg",
      );
    this.shape_8.setTransform(-32.5, 93.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_9.setTransform(-36.3321, 93.05);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_10.setTransform(-42.4179, 93.875);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_11.setTransform(-49.5029, 93.975);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_12.setTransform(-57.3132, 92.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAvIgDAAIACgKIAEAAIADABIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAbQgPAbgFAFQgFAGgKAAg",
      );
    this.shape_13.setTransform(-69.225, 95.35);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-73.7821, 93.05);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_15.setTransform(-77.225, 92.7);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_16.setTransform(-80.075, 92.7);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHgBQgIAAgFAGQgDACgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_17.setTransform(-85.6188, 94);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAGABADQABAFAJAAQALAAAGgKQAEgGACgJIAHghIAMAAIgPBDIgLAAIADgKIgHAHQgHAFgJAAQgPAAgDgKg",
      );
    this.shape_18.setTransform(-92.4375, 94.05);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAOApQgFADgHABQgFACgHAAQgWAAgJgOQgIgOAEgUQAEgTAMgNQAQgSAXAAQAYAAAJAQQAHANgFATQgBAIgEAIQgGANgKAIIAKAKIgHAIgAgRgeQgLAKgEAUQgEAQAHAKQAGAKARAAIAGgBIAGgCIgHgIIAHgIIAKAKQAHgHAEgIQAEgIABgHQAEgQgGgKQgHgKgPAAQgOAAgLAJg",
      );
    this.shape_19.setTransform(-100.943, 92.925);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAEACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_20.setTransform(-1.0821, 77.25);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_21.setTransform(-6.7423, 78.175);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_22.setTransform(-11.025, 76.9);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_23.setTransform(-18.2929, 78.075);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_24.setTransform(-27.1792, 78.2);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_25.setTransform(-34.5179, 76.875);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_26.setTransform(-42.2132, 76.875);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics.f("#949EA7").s().p("AgPAuIAThbIAMAAIgTBbg");
    this.shape_27.setTransform(-52.025, 76.9);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAEQgDADgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_28.setTransform(-57.5688, 78.2);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgJg",
      );
    this.shape_29.setTransform(-64.085, 78.15);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_30.setTransform(-68.575, 76.9);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAEACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_31.setTransform(-71.5821, 77.25);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAwIgDgBIACgLIAEACIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA2IAeg2IAMAAIgRAeIgQAcQgPAZgFAGQgFAGgKAAg",
      );
    this.shape_32.setTransform(-77.125, 79.55);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics.f("#949EA7").s().p("AgPAuIAThbIAMAAIgTBbg");
    this.shape_33.setTransform(-81.525, 76.9);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAEQgDADgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_34.setTransform(-87.0688, 78.2);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_35.setTransform(-94.2179, 78.075);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p("AAcAuIgEgcIgjAAIgQAcIgOAAIA2hbIAOAAIAPBbgAAWAJIgFgpIgXApIAcAAg");
    this.shape_36.setTransform(-102.65, 76.9);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_37.setTransform(93.825, 31.2);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_38.setTransform(89.9, 27.325);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQABAGABADQADAGAJAAQAMAAAEgLQACgGABgKIAAgjIAMAAIAABIIgMAAIABgLQgDAEgEADQgGAFgKAAQgPAAgFgKg",
      );
    this.shape_39.setTransform(84.1, 28.4);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgPAAgJgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_40.setTransform(76.35, 28.3);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_41.setTransform(66.7, 27.325);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_42.setTransform(61.125, 28.325);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_43.setTransform(53.225, 26.9);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_44.setTransform(47.35, 27.325);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_45.setTransform(40.1, 26.925);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_46.setTransform(37, 26.925);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQAAAGABADQAEAGAIAAQALAAAFgLQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_47.setTransform(31.5, 28.4);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_48.setTransform(23.975, 29.65);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_49.setTransform(11.975, 27.025);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAJQAFgFAGgDQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_50.setTransform(4.475, 28.2);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_51.setTransform(-3.125, 28.325);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAJQAFgFAGgDQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_52.setTransform(-14.875, 28.2);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_53.setTransform(-22.7, 28.3);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_54.setTransform(-28.075, 26.925);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_55.setTransform(-31.6, 27.325);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_56.setTransform(-37.175, 28.325);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgCQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_57.setTransform(-47.025, 28.2);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_58.setTransform(-54.775, 28.2);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_59.setTransform(-61.45, 28.3);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_60.setTransform(-67.175, 26.85);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAJQAFgFAGgDQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_61.setTransform(-72.975, 28.2);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_62.setTransform(-78.425, 26.925);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_63.setTransform(-85.8, 27.325);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_64.setTransform(-91.375, 28.325);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_65.setTransform(-99.275, 26.9);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_66.setTransform(-105.15, 27.325);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_67.setTransform(91.2, 11.5);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_68.setTransform(85.4, 10.525);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGABQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_69.setTransform(79.675, 11.4);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_70.setTransform(74.225, 10.125);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGABQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_71.setTransform(64.975, 11.4);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_72.setTransform(56, 11.5);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_73.setTransform(47.05, 11.5);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_74.setTransform(39.125, 10.225);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_75.setTransform(28.575, 10.125);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_76.setTransform(21.175, 11.475);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_77.setTransform(13.925, 11.525);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_78.setTransform(6.175, 10.225);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_79.setTransform(-3.25, 10.125);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_80.setTransform(-6.35, 10.125);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_81.setTransform(-9.475, 10.125);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_82.setTransform(-12.925, 11.4);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_83.setTransform(-19.775, 10.225);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_84.setTransform(-31.2, 11.5);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_85.setTransform(-37, 10.525);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_86.setTransform(-46.625, 11.525);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_87.setTransform(-52, 10.125);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_88.setTransform(-57.275, 10.225);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_89.setTransform(-65.025, 11.525);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFADACQAEAFAIAAQAOAAAEgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgIgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgEAMg",
      );
    this.shape_90.setTransform(-77.05, 12.975);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGABQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_91.setTransform(-84.525, 11.4);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_92.setTransform(-89.975, 10.125);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_93.setTransform(-95.425, 11.525);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_94.setTransform(-102.975, 10.225);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_95.setTransform(82.625, -6.575);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_96.setTransform(75.125, -5.4);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p("AAeAyIgKgeIgnAAIgLAeIgOAAIAmhjIAOAAIAlBjgAAPAJIgPgrIgPArIAeAAg");
    this.shape_97.setTransform(66.625, -6.675);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_98.setTransform(56.925, -2.4);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_99.setTransform(50.875, -6.575);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_100.setTransform(43.325, -5.275);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_101.setTransform(35.375, -6.575);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_102.setTransform(29.825, -5.4);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_103.setTransform(23.15, -5.3);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_104.setTransform(15.875, -5.325);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_105.setTransform(8.425, -5.275);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_106.setTransform(2.675, -5.4);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_107.setTransform(-8.05, -3.825);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_108.setTransform(-15.525, -5.4);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_109.setTransform(-20.975, -6.675);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_110.setTransform(-26.425, -5.275);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_111.setTransform(-33.975, -6.575);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_112.setTransform(-43.85, -6.275);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_113.setTransform(-49.575, -5.4);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_114.setTransform(-57.375, -5.275);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_115.setTransform(-67.025, -5.4);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_116.setTransform(-76.775, -5.275);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_117.setTransform(-84.125, -5.3);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_118.setTransform(-91.55, -5.3);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_119.setTransform(-101.175, -5.4);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAHQgEAFgKAAg",
      );
    this.shape_120.setTransform(56.1, -20.6);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_121.setTransform(50.675, -22.2);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_122.setTransform(44.025, -22.075);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_123.setTransform(36.675, -22.1);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_124.setTransform(29.275, -22.075);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHALQAFAAACgHIABgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAHgEAGQgDAHgIABg",
      );
    this.shape_125.setTransform(19.65, -18.15);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_126.setTransform(13.875, -22.2);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_127.setTransform(6.075, -22.075);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_128.setTransform(-0.825, -23.475);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_129.setTransform(-8.475, -22.075);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_130.setTransform(-14.5, -23.075);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_131.setTransform(-24.35, -20.625);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_132.setTransform(-31.825, -22.2);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_133.setTransform(-37.275, -23.475);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_134.setTransform(-42.725, -22.075);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_135.setTransform(-50.275, -23.375);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAHQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_136.setTransform(-61.65, -22.05);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_137.setTransform(-69.075, -22.075);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_138.setTransform(-74.825, -22.2);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQABAGABADQADAGAJAAQAMAAAEgLQACgGABgKIAAgjIAMAAIAABHIgMAAIABgKQgDAEgEADQgGAFgKAAQgPAAgFgKg",
      );
    this.shape_139.setTransform(-81.5, -22);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_140.setTransform(-87.3, -23.075);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_141.setTransform(-92.625, -22.125);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_142.setTransform(-97.725, -23.475);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_143.setTransform(-102.975, -20.75);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_144.setTransform(104.45, -38.9);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcArQgKgJAAgRIANAAQAAAJAEAGQAGAKAQAAQAHAAAGgCQAMgFAAgLQAAgIgFgDQgFgEgLgDIgMgCQgNgEgFgCQgKgHAAgMQAAgOAJgJQAKgIAQAAQAPAAAKAHQALAJAAAQIgNAAQgBgIgDgEQgGgIgNAAQgMAAgFAFQgFAFAAAHQAAAHAGAEIARAFIAOADQAJACAGADQAJAIAAANQAAAQgMAIQgMAHgPAAQgSAAgKgKg",
      );
    this.shape_145.setTransform(95.9489, -40.25);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_146.setTransform(85.575, -36);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_147.setTransform(80.15, -38.85);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_148.setTransform(73.15, -38.85);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_149.setTransform(65.725, -38.875);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_150.setTransform(58.425, -38.925);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_151.setTransform(50.95, -38.9);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_152.setTransform(45.225, -39);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_153.setTransform(38.775, -37.55);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_154.setTransform(26.975, -38.875);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_155.setTransform(19.275, -40.3);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_156.setTransform(13.4, -39.875);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_157.setTransform(3.55, -37.425);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_158.setTransform(-3.925, -39);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_159.setTransform(-11.75, -38.9);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_160.setTransform(-17.1, -40.275);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_161.setTransform(-22.375, -38.875);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_162.setTransform(-34.375, -40.175);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_163.setTransform(-41.925, -38.875);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_164.setTransform(-47.75, -39.875);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_165.setTransform(-53.475, -39);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_166.setTransform(-61.275, -38.875);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_167.setTransform(-70.925, -39);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAGABADQADAHAJgBQAMAAAEgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgOAAgGgLg",
      );
    this.shape_168.setTransform(-80.7, -38.8);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_169.setTransform(-87.975, -38.925);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_170.setTransform(-95.45, -38.9);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_171.setTransform(-103.375, -40.175);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_172.setTransform(74.75, -54.225);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_173.setTransform(67.275, -55.8);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_174.setTransform(61.825, -57.075);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_175.setTransform(56.375, -55.675);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_176.setTransform(48.825, -56.975);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_177.setTransform(37.025, -55.675);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_178.setTransform(31.275, -55.8);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_179.setTransform(24.825, -55.675);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_180.setTransform(14.95, -56.675);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_181.setTransform(9.375, -55.675);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_182.setTransform(1.475, -57.1);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_183.setTransform(-4.4, -56.675);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgCgDQgEgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_184.setTransform(-13.6, -55.65);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_185.setTransform(-20.575, -55.725);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_186.setTransform(-25.675, -57.075);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_187.setTransform(-29.125, -57.15);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_188.setTransform(-32.625, -57.075);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_189.setTransform(-37.625, -55.725);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_190.setTransform(-45.075, -55.675);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_191.setTransform(-52.625, -54.35);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_192.setTransform(-60.15, -55.65);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_193.setTransform(-71.375, -55.8);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_194.setTransform(-76.825, -57.075);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_195.setTransform(-86.325, -56.975);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_196.setTransform(-93.825, -55.8);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p("AAeAyIgKgeIgnAAIgLAeIgOAAIAmhjIAOAAIAlBjgAAPAJIgPgrIgPArIAeAAg");
    this.shape_197.setTransform(-102.325, -57.075);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_198.setTransform(112.575, -69.6);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_199.setTransform(106.7, -72.5);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_200.setTransform(98.775, -73.775);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_201.setTransform(87.425, -72.6);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_202.setTransform(79.825, -72.475);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_203.setTransform(72.325, -72.525);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_204.setTransform(61, -72.4);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_205.setTransform(53.25, -72.5);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIACgGIADgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgKAAg",
      );
    this.shape_206.setTransform(45.95, -71);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_207.setTransform(36.6, -73.475);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_208.setTransform(31.025, -72.475);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_209.setTransform(23.125, -73.9);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhHIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBHg");
    this.shape_210.setTransform(14.15, -72.5);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_211.setTransform(1.425, -72.6);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_212.setTransform(-4.025, -73.875);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgFgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_213.setTransform(-12.9, -72.45);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_214.setTransform(-20.125, -72.475);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhHIAOAAIAOA4IAOg4IANAAIAPA3IAPg3IAMAAIgVBHg");
    this.shape_215.setTransform(-29.25, -72.5);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_216.setTransform(-42.025, -72.475);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_217.setTransform(-47.775, -72.6);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_218.setTransform(-54.425, -72.475);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_219.setTransform(-62.125, -73.9);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_220.setTransform(-68, -73.475);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_221.setTransform(-75.25, -73.875);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_222.setTransform(-78.375, -73.875);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_223.setTransform(-83.625, -72.475);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_224.setTransform(-89.65, -73.475);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_225.setTransform(-95.425, -72.475);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_226.setTransform(-103.375, -73.775);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_227.setTransform(95.925, -90.7);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_228.setTransform(88.575, -89.325);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIABgLQgDAFgDADQgIAFgJABQgOAAgGgLg",
      );
    this.shape_229.setTransform(81.1, -89.2);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_230.setTransform(71.475, -89.4);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA5IAPg5IAMAAIgVBIg");
    this.shape_231.setTransform(56.7, -89.3);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_232.setTransform(47.75, -89.3);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_233.setTransform(40.075, -90.7);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_234.setTransform(30.425, -90.75);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_235.setTransform(24.55, -89.3);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_236.setTransform(14.9, -90.275);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_237.setTransform(9.175, -89.4);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgIAFgIABQgPAAgGgLg",
      );
    this.shape_238.setTransform(1.35, -89.2);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_239.setTransform(-6.4, -89.3);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_240.setTransform(-16.025, -89.4);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_241.setTransform(-25.575, -89.275);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_242.setTransform(-37.375, -89.275);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_243.setTransform(-45.075, -90.7);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_244.setTransform(-50.95, -90.275);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_245.setTransform(-60.525, -90.7);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_246.setTransform(-66.4, -90.275);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_247.setTransform(-69.825, -90.675);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAOA5IAPg5IAMAAIgVBIg");
    this.shape_248.setTransform(-76.45, -89.3);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_249.setTransform(-87.3, -90.275);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_250.setTransform(-92.65, -89.25);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQADAHAJgBQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgIAFgIABQgQAAgFgLg",
      );
    this.shape_251.setTransform(-100.1, -89.2);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDAAIAAgLQAIAAACgCQABgBAAgGIAAhSIAMAAIAABUQAAAIgDAEQgEAGgLAAgAAAgxIAAgPIAMAAIAAAPg",
      );
    this.shape_252.setTransform(-106.05, -89.2);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_253.setTransform(112.125, -107.375);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_254.setTransform(104.575, -106.075);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgDgDQgFgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_255.setTransform(97.25, -106.05);

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgJgDQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_256.setTransform(90.25, -106.05);

    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_257.setTransform(82.825, -106.075);

    this.shape_258 = new cjs.Shape();
    this.shape_258.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_258.setTransform(77.075, -106.2);

    this.shape_259 = new cjs.Shape();
    this.shape_259.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_259.setTransform(70.625, -104.75);

    this.shape_260 = new cjs.Shape();
    this.shape_260.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_260.setTransform(60.775, -106.2);

    this.shape_261 = new cjs.Shape();
    this.shape_261.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_261.setTransform(53.375, -107.475);

    this.shape_262 = new cjs.Shape();
    this.shape_262.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_262.setTransform(43.875, -107.375);

    this.shape_263 = new cjs.Shape();
    this.shape_263.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_263.setTransform(36.375, -106.2);

    this.shape_264 = new cjs.Shape();
    this.shape_264.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_264.setTransform(28.775, -106.075);

    this.shape_265 = new cjs.Shape();
    this.shape_265.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_265.setTransform(16.775, -107.375);

    this.shape_266 = new cjs.Shape();
    this.shape_266.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_266.setTransform(9.225, -106.075);

    this.shape_267 = new cjs.Shape();
    this.shape_267.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgDQAGgCAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_267.setTransform(1.9, -106.05);

    this.shape_268 = new cjs.Shape();
    this.shape_268.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_268.setTransform(-3.175, -107.475);

    this.shape_269 = new cjs.Shape();
    this.shape_269.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_269.setTransform(-6.625, -106.2);

    this.shape_270 = new cjs.Shape();
    this.shape_270.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_270.setTransform(-13.075, -104.75);

    this.shape_271 = new cjs.Shape();
    this.shape_271.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_271.setTransform(-19.025, -106.2);

    this.shape_272 = new cjs.Shape();
    this.shape_272.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAGABADQADAHAJAAQAMAAAEgMQACgGABgKIAAgjIAMAAIAABIIgMAAIABgMQgDAFgEACQgGAHgKAAQgPAAgFgLg",
      );
    this.shape_272.setTransform(-25.7, -106);

    this.shape_273 = new cjs.Shape();
    this.shape_273.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCABgHQAAgEgFgDIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgEgEgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_273.setTransform(-33, -106.05);

    this.shape_274 = new cjs.Shape();
    this.shape_274.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEAAIAAgLIAFABIACAAIAGgBIACgEIACgFIAEgHIgbhKIANAAIATA6IAUg6IANAAIgLAfIgMAeQgKAcgDAGQgFAHgLgBg",
      );
    this.shape_274.setTransform(-43.85, -104.6);

    this.shape_275 = new cjs.Shape();
    this.shape_275.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_275.setTransform(-49.275, -106.2);

    this.shape_276 = new cjs.Shape();
    this.shape_276.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_276.setTransform(-55.925, -106.075);

    this.shape_277 = new cjs.Shape();
    this.shape_277.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_277.setTransform(-63.275, -106.1);

    this.shape_278 = new cjs.Shape();
    this.shape_278.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_278.setTransform(-74.1, -106.05);

    this.shape_279 = new cjs.Shape();
    this.shape_279.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_279.setTransform(-81.325, -106.075);

    this.shape_280 = new cjs.Shape();
    this.shape_280.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgNAAIgVhIIAOAAIAOA4IAOg4IANAAIAPA4IAPg4IAMAAIgVBIg");
    this.shape_280.setTransform(-90.45, -106.1);

    this.shape_281 = new cjs.Shape();
    this.shape_281.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_282 = new cjs.Shape();
    this.shape_282.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_282 },
            { t: this.shape_281 },
            { t: this.shape_280 },
            { t: this.shape_279 },
            { t: this.shape_278 },
            { t: this.shape_277 },
            { t: this.shape_276 },
            { t: this.shape_275 },
            { t: this.shape_274 },
            { t: this.shape_273 },
            { t: this.shape_272 },
            { t: this.shape_271 },
            { t: this.shape_270 },
            { t: this.shape_269 },
            { t: this.shape_268 },
            { t: this.shape_267 },
            { t: this.shape_266 },
            { t: this.shape_265 },
            { t: this.shape_264 },
            { t: this.shape_263 },
            { t: this.shape_262 },
            { t: this.shape_261 },
            { t: this.shape_260 },
            { t: this.shape_259 },
            { t: this.shape_258 },
            { t: this.shape_257 },
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_283 = new cjs.Shape();
    this.shape_283.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_283.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_283).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote10testimonialGSK03,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote09testimonialBiogen03 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.instance_1 = new lib.Logo_Biogenbw();
    this.instance_1.setTransform(54.45, 144.55, 0.9023, 0.9006);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AhABMIAAgHIAJgBIAHgCQAEgBABgDQABgDAAgDIAAhtIgBgGQgBgDgEgCIgIgCIgIgCIAAgHIB1AAIAAAlIgIAAQgCgJgHgJQgHgJgGgBIgIAAIgLgBIgXAAIAAA9IARAAQAIAAADgCQAEgBADgEIAEgIIACgKIAIAAIAAA7IgIAAIgCgLIgEgJQgDgEgEgBIgLgBIgRAAIAAAtIABALQABAEADACQADACAEABIANAAIAKAAIAJAAIAJgBQAEgCACgCQAFgFAFgKIAHgQIAIAAIgDAtg",
      );
    this.shape.setTransform(-106.625, -136.475);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_1.setTransform(91.9679, 116.7);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_2.setTransform(85.8821, 117.525);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_3.setTransform(78.8208, 117.65);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_4.setTransform(69.7071, 117.525);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_5.setTransform(63.1679, 116.7);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAGgFAHAAIACAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_6.setTransform(59.1, 117.525);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_7.setTransform(52.7312, 117.65);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_8.setTransform(45.3363, 118.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_9.setTransform(38.5208, 117.65);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhcIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXgBgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgJIADgKQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_10.setTransform(30.388, 116.35);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_11.setTransform(20.7179, 116.7);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(14.6321, 117.525);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_13.setTransform(7.5708, 117.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_14.setTransform(-1.5429, 117.525);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_15.setTransform(-10.8137, 118.875);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_16.setTransform(-17.6529, 117.625);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_17.setTransform(-22.325, 116.35);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_18.setTransform(-27.6792, 117.65);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgMhDIAOAAIAHA3IAdg3IAMAAIgnBDg");
    this.shape_19.setTransform(-33.8, 117.6);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_20.setTransform(-41.3792, 117.65);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhcIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXgBgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgJIADgKQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_21.setTransform(-49.512, 116.35);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_22.setTransform(-59.025, 116.35);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_23.setTransform(-64.5688, 117.65);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgGgDgEQgCgFgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgKg",
      );
    this.shape_24.setTransform(-71.085, 117.6);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-75.575, 116.35);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_26.setTransform(-78.5821, 116.7);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAwIgDgBIACgKIAEABIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAcQgPAZgFAGQgFAGgKAAg",
      );
    this.shape_27.setTransform(-84.125, 119);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_28.setTransform(-88.525, 116.35);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_29.setTransform(-94.0688, 117.65);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_30.setTransform(-101.2179, 117.525);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p("AAcAuIgEgcIgjAAIgRAcIgMAAIA2hcIANAAIAPBcgAAXAIIgGgoIgXAoIAdAAg");
    this.shape_31.setTransform(-109.65, 116.35);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_32.setTransform(-65.6321, 100.9);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_33.setTransform(-71.2923, 101.825);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_34.setTransform(-75.575, 100.55);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_35.setTransform(-78.5821, 100.9);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_36.setTransform(-84.6679, 101.725);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgJAEgQQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_37.setTransform(-91.7292, 101.85);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_38.setTransform(-96.425, 100.55);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgLADgOQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgJg",
      );
    this.shape_39.setTransform(-101.285, 101.8);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAoQgIgIADgPIAMAAQgBAIACAEQAFAKAPAAQAHgBAGgBQAMgFACgKQACgHgEgEQgEgCgKgDIgLgDQgMgDgEgCQgIgGACgMQADgMAKgIQALgIAPAAQAOAAAJAHQAJAHgDAQIgMAAQAAgIgCgEQgEgHgOAAQgKAAgGAEQgGAFgBAGQgCAIAFACQAEACALAEIANACQAJADAEADQAIAGgDAMQgDAQgNAGQgNAHgOAAQgRAAgIgJg",
      );
    this.shape_40.setTransform(-108.7787, 100.55);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_41.setTransform(111.175, 71.65);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFAAgLIAMAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_42.setTransform(105.1, 70.225);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAHAAAKIAAAug",
      );
    this.shape_43.setTransform(97.625, 68.65);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_44.setTransform(92.175, 67.375);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAHAAAJIAAAvg",
      );
    this.shape_45.setTransform(86.775, 67.35);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_46.setTransform(80.9, 67.775);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFACIADAAIAEgCIADgDIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAGQgDAHgLAAg",
      );
    this.shape_47.setTransform(75.55, 70.25);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_48.setTransform(70.125, 68.65);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_49.setTransform(63.475, 68.775);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_50.setTransform(56.125, 68.75);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_51.setTransform(48.725, 68.775);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_52.setTransform(36.925, 67.475);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_53.setTransform(29.375, 68.775);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_54.setTransform(23.625, 68.65);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQADAHAJgBQAMABAEgMQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgOAAgGgLg",
      );
    this.shape_55.setTransform(16.95, 68.85);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_56.setTransform(11.15, 67.775);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_57.setTransform(5.575, 70.1);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_58.setTransform(-2.175, 68.775);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_59.setTransform(-9.675, 68.725);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_60.setTransform(-20.975, 68.775);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_61.setTransform(-28.325, 68.75);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBACgEQABgDAAgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_62.setTransform(-33, 64.125);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQABAGABADQADAHAJgBQAMABAEgMQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgOAAgGgLg",
      );
    this.shape_63.setTransform(-38.85, 68.85);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_64.setTransform(-46.6, 68.75);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFACIACAAIAFgCIADgDIADgFIADgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgEAGQgDAHgMAAg",
      );
    this.shape_65.setTransform(-53.9, 70.25);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_66.setTransform(-65.175, 68.775);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgEQgDgEgKAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_67.setTransform(-72.5, 68.8);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMABAEgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_68.setTransform(-79.95, 68.85);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_69.setTransform(-87.475, 68.775);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_70.setTransform(-94.975, 68.725);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_71.setTransform(-102.425, 68.775);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_72.setTransform(-109.975, 67.475);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_73.setTransform(73.275, 51.85);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_74.setTransform(66.625, 51.975);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_75.setTransform(61.225, 50.575);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgDAAgGQAAgFgDgCIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAGgBAIIgLAAQAAgEgEgDQgDgGgKAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_76.setTransform(56.2, 52);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_77.setTransform(48.975, 51.975);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_78.setTransform(41.025, 51.975);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAGAAAIIgMAAQABgEgDgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_79.setTransform(29.85, 52);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(22.425, 51.975);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_81.setTransform(12.775, 51.85);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_82.setTransform(3, 51.95);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_83.setTransform(-4.275, 51.925);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_84.setTransform(-11.725, 51.975);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_85.setTransform(-19.275, 50.675);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_86.setTransform(-31.075, 51.975);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgDABgGQAAgFgFgCIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAGAAAIIgLAAQAAgEgEgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_87.setTransform(-38.4, 52);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_88.setTransform(-43.45, 50.575);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_89.setTransform(-48.925, 51.975);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_90.setTransform(-60.525, 51.975);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_91.setTransform(-68.225, 51.85);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_92.setTransform(-76.05, 51.95);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_93.setTransform(-83.775, 51.975);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_94.setTransform(-93.425, 51.85);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_95.setTransform(-103.2, 51.95);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgDABgGQAAgFgFgCIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAGgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_96.setTransform(-110.5, 52);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_97.setTransform(97.35, 35.15);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_98.setTransform(91.55, 34.175);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_99.setTransform(81.725, 33.875);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_100.setTransform(74.15, 35.15);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_101.setTransform(66.475, 33.75);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_102.setTransform(60.6, 34.175);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_103.setTransform(54.825, 35.175);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_104.setTransform(45.175, 35.05);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_105.setTransform(33.575, 35.05);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIABALQgBAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_106.setTransform(26.9, 35.15);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_107.setTransform(15.325, 35.175);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_108.setTransform(7.35, 36.625);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_109.setTransform(-0.375, 33.875);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_110.setTransform(-7.925, 35.175);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_111.setTransform(-13.3, 33.775);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhHIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBHg");
    this.shape_112.setTransform(-19.95, 35.15);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_113.setTransform(-28.9, 35.15);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_114.setTransform(-36.575, 35.05);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_115.setTransform(-43.525, 33.775);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_116.setTransform(-53.225, 33.7);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_117.setTransform(-59.1, 35.15);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_118.setTransform(-68.675, 35.05);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_119.setTransform(-75.325, 35.175);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_120.setTransform(-81.075, 33.7);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgEQAGgDgBgGQAAgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgGQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgCgDQgEgEgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_121.setTransform(-86.5, 35.2);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_122.setTransform(-93.875, 35.05);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_123.setTransform(-101.475, 35.175);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_124.setTransform(-107.425, 35.05);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_125.setTransform(-112.15, 34.175);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_126.setTransform(109.525, 18.375);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAHAAAJIAAAvg",
      );
    this.shape_127.setTransform(101.825, 16.95);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p("AgGAyIAAhXIgiAAIAAgMIBQAAIAAAMIghAAIAABXg");
    this.shape_128.setTransform(93.7, 16.975);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_129.setTransform(83.875, 21.25);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_130.setTransform(77.825, 17.075);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAHAAAKIAAAug",
      );
    this.shape_131.setTransform(70.325, 18.25);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_132.setTransform(64.875, 16.975);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_133.setTransform(61.425, 16.9);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_134.setTransform(53.725, 18.25);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_135.setTransform(47.075, 18.375);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_136.setTransform(39.725, 18.35);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_137.setTransform(32.325, 18.375);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAHAAAKIAAAug",
      );
    this.shape_138.setTransform(24.625, 18.25);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_139.setTransform(15.35, 16.975);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_140.setTransform(12.25, 16.975);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_141.setTransform(9.125, 16.975);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_142.setTransform(2.5, 18.35);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgDgEQgFgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_143.setTransform(-9.85, 18.4);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_144.setTransform(-15.275, 18.25);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_145.setTransform(-21.925, 18.375);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAHAAAJIAAAvg",
      );
    this.shape_146.setTransform(-29.625, 16.95);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_147.setTransform(-35.5, 17.375);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_148.setTransform(-41.3, 18.35);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_149.setTransform(-50.95, 17.375);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_150.setTransform(-56.525, 18.375);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAHAAAJIAAAvg",
      );
    this.shape_151.setTransform(-64.425, 16.95);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_152.setTransform(-70.3, 17.375);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_153.setTransform(-79.925, 18.375);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_154.setTransform(-85.675, 18.25);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_155.setTransform(-92.325, 18.375);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAHAAAJIAAAvg",
      );
    this.shape_156.setTransform(-100.025, 16.95);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_157.setTransform(-109, 18.35);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics.f("#31353B").s().p("AgQAHIAAgNIAhAAIAAANg");
    this.shape_158.setTransform(102.85, 1.3);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_159.setTransform(96.625, 1.575);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_160.setTransform(86.975, 1.45);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_161.setTransform(77.2, 1.55);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAGAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_162.setTransform(69.9, 1.6);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_163.setTransform(58.625, 1.575);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_164.setTransform(53.25, 0.175);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_165.setTransform(50.125, 0.175);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_166.setTransform(46.675, 0.1);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_167.setTransform(39.35, 0.175);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_168.setTransform(33.875, 1.575);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_169.setTransform(26.575, 1.525);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgYgjIAPAAIAQAZIARgZIAQAAIgZAjIAaAlg");
    this.shape_170.setTransform(19.5, 1.55);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_171.setTransform(11.65, 0.175);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_172.setTransform(-0.975, 1.45);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_173.setTransform(-8.575, 1.575);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_174.setTransform(-20.325, 1.45);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_175.setTransform(-28.15, 1.55);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_176.setTransform(-37.725, 1.45);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_177.setTransform(-44.4, 1.55);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_178.setTransform(-56.175, 0.275);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_179.setTransform(-63.525, 1.575);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_180.setTransform(-71.475, 1.575);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_181.setTransform(-79.175, 0.15);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_182.setTransform(-88.825, 1.45);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_183.setTransform(-93.125, 0.175);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_184.setTransform(-98.575, 1.575);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_185.setTransform(-106.275, 0.15);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_186.setTransform(-112.15, 0.575);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_187.setTransform(87.375, -15.35);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_188.setTransform(81.925, -16.625);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAGgDgBgGQAAgEgDgDIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgFgCgDQgFgEgJgBQgHAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_189.setTransform(73.05, -15.2);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_190.setTransform(65.625, -15.225);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_191.setTransform(58.275, -15.25);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_192.setTransform(53.225, -16.625);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_193.setTransform(50.15, -16.625);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_194.setTransform(42.75, -16.225);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_195.setTransform(37.4, -15.2);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQAEAGAIAAQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_196.setTransform(29.95, -15.15);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDgBIAAgKQAIAAACgCQABgBAAgGIAAhSIAMAAIAABTQAAAIgDAFQgEAGgLAAgAAAgxIAAgPIAMAAIAAAPg",
      );
    this.shape_197.setTransform(24, -15.15);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_198.setTransform(15.325, -15.35);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_199.setTransform(7.5, -15.25);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_200.setTransform(2.125, -16.625);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_201.setTransform(-1.4, -16.225);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_202.setTransform(-6.975, -15.225);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_203.setTransform(-16.825, -15.35);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_204.setTransform(-24.575, -15.35);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_205.setTransform(-31.25, -15.25);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_206.setTransform(-36.975, -16.7);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_207.setTransform(-42.775, -15.35);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_208.setTransform(-48.225, -16.625);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_209.setTransform(-55.6, -16.225);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_210.setTransform(-61.175, -15.225);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_211.setTransform(-69.075, -16.65);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_212.setTransform(-74.95, -16.225);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgEQAGgDAAgGQgBgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgDgDQgDgEgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAHQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_213.setTransform(-84.15, -15.2);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_214.setTransform(-91.575, -15.225);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_215.setTransform(-101.225, -15.35);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_216.setTransform(-108.625, -16.625);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_217.setTransform(-112.15, -16.225);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_218.setTransform(100.925, -33.5);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_219.setTransform(95.05, -32.05);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_220.setTransform(85.4, -33.025);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_221.setTransform(79.6, -32.05);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_222.setTransform(74.25, -33.425);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_223.setTransform(65.125, -32.025);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_224.setTransform(53.3, -32.05);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAHALgBQAHAAAFgCQAGgDAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgMAAQAAgEgDgEQgDgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_225.setTransform(46, -32);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_226.setTransform(35.575, -33.425);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_227.setTransform(29.725, -32.15);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_228.setTransform(23.05, -32.05);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_229.setTransform(14.15, -32.05);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_230.setTransform(1.375, -32.025);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_231.setTransform(-6.325, -33.45);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_232.setTransform(-12.2, -33.025);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_233.setTransform(-22.05, -30.575);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_234.setTransform(-29.525, -32.15);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_235.setTransform(-34.975, -33.425);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_236.setTransform(-40.45, -32.05);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_237.setTransform(-48.375, -33.325);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_238.setTransform(-57.4, -33.425);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_239.setTransform(-62.675, -32.025);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALABAFgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgIAGgIABQgPAAgGgLg",
      );
    this.shape_240.setTransform(-70.65, -31.95);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_241.setTransform(-78.575, -33.325);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_242.setTransform(-83.775, -33.425);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_243.setTransform(-88.825, -32.05);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_244.setTransform(-93.875, -33.425);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_245.setTransform(-99.525, -33.325);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_246.setTransform(-107.025, -32.15);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_247.setTransform(-112.475, -33.425);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_248.setTransform(89.375, -48.825);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_249.setTransform(81.675, -50.25);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_250.setTransform(75.8, -49.825);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_251.setTransform(66.225, -48.95);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIABALQgBAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_252.setTransform(58.4, -48.85);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_253.setTransform(48.75, -49.825);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_254.setTransform(43.025, -48.95);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_255.setTransform(35.225, -48.825);

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_256.setTransform(27.275, -50.125);

    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_257.setTransform(19.775, -48.95);

    this.shape_258 = new cjs.Shape();
    this.shape_258.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_258.setTransform(11.975, -48.825);

    this.shape_259 = new cjs.Shape();
    this.shape_259.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAHgLAAQgHAAgGgEIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFALAMAAQAIAAAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_259.setTransform(4.425, -47.5);

    this.shape_260 = new cjs.Shape();
    this.shape_260.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_260.setTransform(-3.525, -48.825);

    this.shape_261 = new cjs.Shape();
    this.shape_261.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_261.setTransform(-11.475, -50.125);

    this.shape_262 = new cjs.Shape();
    this.shape_262.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgKIAFABIADAAIAEgBIADgEIACgFIADgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgKgBg",
      );
    this.shape_262.setTransform(-22.45, -47.35);

    this.shape_263 = new cjs.Shape();
    this.shape_263.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_263.setTransform(-27.5, -50.225);

    this.shape_264 = new cjs.Shape();
    this.shape_264.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_264.setTransform(-32.925, -50.25);

    this.shape_265 = new cjs.Shape();
    this.shape_265.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_265.setTransform(-40.95, -47.375);

    this.shape_266 = new cjs.Shape();
    this.shape_266.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_266.setTransform(-46.125, -50.225);

    this.shape_267 = new cjs.Shape();
    this.shape_267.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_267.setTransform(-51.525, -50.25);

    this.shape_268 = new cjs.Shape();
    this.shape_268.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgJgDQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAJQAEAGAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_268.setTransform(-62.75, -48.8);

    this.shape_269 = new cjs.Shape();
    this.shape_269.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBACgEQABgDAAgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_269.setTransform(-67.2, -53.475);

    this.shape_270 = new cjs.Shape();
    this.shape_270.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_270.setTransform(-71.1, -49.825);

    this.shape_271 = new cjs.Shape();
    this.shape_271.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_271.setTransform(-74.525, -50.225);

    this.shape_272 = new cjs.Shape();
    this.shape_272.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgKIAFABIADAAIAEgBIADgEIADgFIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAGQgEAHgKgBg",
      );
    this.shape_272.setTransform(-83.4, -47.35);

    this.shape_273 = new cjs.Shape();
    this.shape_273.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_273.setTransform(-90.625, -48.825);

    this.shape_274 = new cjs.Shape();
    this.shape_274.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_274.setTransform(-98.775, -50.125);

    this.shape_275 = new cjs.Shape();
    this.shape_275.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_275.setTransform(-106.35, -48.85);

    this.shape_276 = new cjs.Shape();
    this.shape_276.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_276.setTransform(-112.15, -49.825);

    this.shape_277 = new cjs.Shape();
    this.shape_277.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALAAQAHAAAFgEQAGgDgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgFgCgDQgFgEgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_277.setTransform(87.1, -65.6);

    this.shape_278 = new cjs.Shape();
    this.shape_278.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_278.setTransform(79.875, -65.625);

    this.shape_279 = new cjs.Shape();
    this.shape_279.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_279.setTransform(71.925, -65.625);

    this.shape_280 = new cjs.Shape();
    this.shape_280.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_280.setTransform(66.175, -65.75);

    this.shape_281 = new cjs.Shape();
    this.shape_281.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_281.setTransform(59.525, -65.625);

    this.shape_282 = new cjs.Shape();
    this.shape_282.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_282.setTransform(51.825, -67.05);

    this.shape_283 = new cjs.Shape();
    this.shape_283.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IAMAAIgVBIg");
    this.shape_283.setTransform(42.85, -65.65);

    this.shape_284 = new cjs.Shape();
    this.shape_284.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGALQAEAAACgHIABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAHgDAGQgEAGgGACg",
      );
    this.shape_284.setTransform(32.05, -61.7);

    this.shape_285 = new cjs.Shape();
    this.shape_285.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_285.setTransform(26.225, -65.625);

    this.shape_286 = new cjs.Shape();
    this.shape_286.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFAAgLIAMAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_286.setTransform(18.25, -64.175);

    this.shape_287 = new cjs.Shape();
    this.shape_287.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_287.setTransform(10.525, -66.925);

    this.shape_288 = new cjs.Shape();
    this.shape_288.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_288.setTransform(2.975, -65.625);

    this.shape_289 = new cjs.Shape();
    this.shape_289.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_289.setTransform(-2.4, -67.025);

    this.shape_290 = new cjs.Shape();
    this.shape_290.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgMAAIgVhIIANAAIAOA5IAOg5IANAAIAOA4IAPg4IAMAAIgVBIg");
    this.shape_290.setTransform(-9.05, -65.65);

    this.shape_291 = new cjs.Shape();
    this.shape_291.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_291.setTransform(-18, -65.65);

    this.shape_292 = new cjs.Shape();
    this.shape_292.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_292.setTransform(-25.675, -65.75);

    this.shape_293 = new cjs.Shape();
    this.shape_293.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_293.setTransform(-32.625, -67.025);

    this.shape_294 = new cjs.Shape();
    this.shape_294.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgEQAFgDABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAJQAGAHgBAHIgLAAQgBgFgDgDQgEgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_294.setTransform(-43.9, -65.6);

    this.shape_295 = new cjs.Shape();
    this.shape_295.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_295.setTransform(-48.975, -67.025);

    this.shape_296 = new cjs.Shape();
    this.shape_296.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_296.setTransform(-54.375, -67.05);

    this.shape_297 = new cjs.Shape();
    this.shape_297.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_297.setTransform(-60.25, -66.625);

    this.shape_298 = new cjs.Shape();
    this.shape_298.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAEAFAJAAQAOAAAEgKQACgGABgPQgEAFgFADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_298.setTransform(-70.1, -64.175);

    this.shape_299 = new cjs.Shape();
    this.shape_299.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_299.setTransform(-77.575, -65.75);

    this.shape_300 = new cjs.Shape();
    this.shape_300.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_300.setTransform(-83.025, -67.025);

    this.shape_301 = new cjs.Shape();
    this.shape_301.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_301.setTransform(-88.675, -66.925);

    this.shape_302 = new cjs.Shape();
    this.shape_302.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_302.setTransform(-93.85, -67.025);

    this.shape_303 = new cjs.Shape();
    this.shape_303.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_303.setTransform(-96.975, -67.025);

    this.shape_304 = new cjs.Shape();
    this.shape_304.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQAEAGAIAAQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgEADQgHAFgIAAQgQAAgFgKg",
      );
    this.shape_304.setTransform(-102.45, -65.55);

    this.shape_305 = new cjs.Shape();
    this.shape_305.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_305.setTransform(-109.975, -66.925);

    this.shape_306 = new cjs.Shape();
    this.shape_306.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_306.setTransform(100.525, -82.425);

    this.shape_307 = new cjs.Shape();
    this.shape_307.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_307.setTransform(94.775, -82.55);

    this.shape_308 = new cjs.Shape();
    this.shape_308.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_308.setTransform(88.325, -82.425);

    this.shape_309 = new cjs.Shape();
    this.shape_309.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALABAFgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgIAGgIABQgPAAgGgLg",
      );
    this.shape_309.setTransform(76.5, -82.35);

    this.shape_310 = new cjs.Shape();
    this.shape_310.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_310.setTransform(68.75, -82.45);

    this.shape_311 = new cjs.Shape();
    this.shape_311.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFACIACAAIAGgCIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgMAdQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_311.setTransform(61.45, -80.95);

    this.shape_312 = new cjs.Shape();
    this.shape_312.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_312.setTransform(49.975, -83.725);

    this.shape_313 = new cjs.Shape();
    this.shape_313.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_313.setTransform(42.475, -82.55);

    this.shape_314 = new cjs.Shape();
    this.shape_314.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_314.setTransform(34.875, -82.425);

    this.shape_315 = new cjs.Shape();
    this.shape_315.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_315.setTransform(22.875, -83.725);

    this.shape_316 = new cjs.Shape();
    this.shape_316.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_316.setTransform(15.3, -82.45);

    this.shape_317 = new cjs.Shape();
    this.shape_317.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_317.setTransform(7.625, -83.85);

    this.shape_318 = new cjs.Shape();
    this.shape_318.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_318.setTransform(1.75, -83.425);

    this.shape_319 = new cjs.Shape();
    this.shape_319.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_319.setTransform(-4.025, -82.425);

    this.shape_320 = new cjs.Shape();
    this.shape_320.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACADACAEQAEgGAGgDQAFgDAHAAQAPABAFAKQADAGAAAKIAAAvg",
      );
    this.shape_320.setTransform(-13.675, -82.55);

    this.shape_321 = new cjs.Shape();
    this.shape_321.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_321.setTransform(-27.275, -82.425);

    this.shape_322 = new cjs.Shape();
    this.shape_322.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_322.setTransform(-34.975, -83.85);

    this.shape_323 = new cjs.Shape();
    this.shape_323.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_323.setTransform(-40.85, -83.425);

    this.shape_324 = new cjs.Shape();
    this.shape_324.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_324.setTransform(-50.7, -80.975);

    this.shape_325 = new cjs.Shape();
    this.shape_325.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_325.setTransform(-58.175, -82.55);

    this.shape_326 = new cjs.Shape();
    this.shape_326.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_326.setTransform(-63.625, -83.825);

    this.shape_327 = new cjs.Shape();
    this.shape_327.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_327.setTransform(-68.875, -81.1);

    this.shape_328 = new cjs.Shape();
    this.shape_328.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_328.setTransform(-76.85, -82.45);

    this.shape_329 = new cjs.Shape();
    this.shape_329.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_329.setTransform(-82.2, -83.825);

    this.shape_330 = new cjs.Shape();
    this.shape_330.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_330.setTransform(-87.675, -82.425);

    this.shape_331 = new cjs.Shape();
    this.shape_331.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_331.setTransform(-95.025, -82.45);

    this.shape_332 = new cjs.Shape();
    this.shape_332.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_332.setTransform(-102.425, -82.425);

    this.shape_333 = new cjs.Shape();
    this.shape_333.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_333.setTransform(-110.375, -83.725);

    this.shape_334 = new cjs.Shape();
    this.shape_334.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_334.setTransform(106.775, -99.225);

    this.shape_335 = new cjs.Shape();
    this.shape_335.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_335.setTransform(101.025, -99.35);

    this.shape_336 = new cjs.Shape();
    this.shape_336.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_336.setTransform(94.575, -99.225);

    this.shape_337 = new cjs.Shape();
    this.shape_337.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAFABAEQADAGAJABQAMAAAEgMQACgGABgKIAAgjIAMAAIAABIIgMAAIABgLQgDAEgEACQgGAHgKgBQgPAAgFgKg",
      );
    this.shape_337.setTransform(82.75, -99.15);

    this.shape_338 = new cjs.Shape();
    this.shape_338.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_338.setTransform(75, -99.25);

    this.shape_339 = new cjs.Shape();
    this.shape_339.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgKIAFABIADAAIAEgBIADgEIADgFIACgIIgbhJIAPAAIASA6IAUg6IANAAIgLAfIgLAeQgLAcgEAGQgEAHgKgBg",
      );
    this.shape_339.setTransform(67.7, -97.75);

    this.shape_340 = new cjs.Shape();
    this.shape_340.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgKgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAEAGAAAIIgLAAQAAgEgDgDQgFgGgJAAQgHABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_340.setTransform(56.85, -99.2);

    this.shape_341 = new cjs.Shape();
    this.shape_341.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_341.setTransform(49.625, -99.225);

    this.shape_342 = new cjs.Shape();
    this.shape_342.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgDAAgGQgBgFgEgCIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAGAAAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_342.setTransform(38.25, -99.2);

    this.shape_343 = new cjs.Shape();
    this.shape_343.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFADACQAEAFAIAAQAOAAAEgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_343.setTransform(30.6, -97.775);

    this.shape_344 = new cjs.Shape();
    this.shape_344.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_344.setTransform(23.125, -99.35);

    this.shape_345 = new cjs.Shape();
    this.shape_345.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_345.setTransform(17.675, -100.625);

    this.shape_346 = new cjs.Shape();
    this.shape_346.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_346.setTransform(12.275, -99.35);

    this.shape_347 = new cjs.Shape();
    this.shape_347.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_347.setTransform(6.475, -99.35);

    this.shape_348 = new cjs.Shape();
    this.shape_348.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_348.setTransform(0.025, -99.225);

    this.shape_349 = new cjs.Shape();
    this.shape_349.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_349.setTransform(-7.925, -99.225);

    this.shape_350 = new cjs.Shape();
    this.shape_350.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_350.setTransform(-13.3, -100.625);

    this.shape_351 = new cjs.Shape();
    this.shape_351.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_351.setTransform(-22.625, -99.225);

    this.shape_352 = new cjs.Shape();
    this.shape_352.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgDABgGQAAgFgFgCIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAGgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_352.setTransform(-29.95, -99.2);

    this.shape_353 = new cjs.Shape();
    this.shape_353.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_353.setTransform(-37.4, -99.25);

    this.shape_354 = new cjs.Shape();
    this.shape_354.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_354.setTransform(-45.075, -100.65);

    this.shape_355 = new cjs.Shape();
    this.shape_355.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_355.setTransform(-50.95, -100.225);

    this.shape_356 = new cjs.Shape();
    this.shape_356.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_356.setTransform(-60.8, -97.775);

    this.shape_357 = new cjs.Shape();
    this.shape_357.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_357.setTransform(-68.275, -99.35);

    this.shape_358 = new cjs.Shape();
    this.shape_358.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_358.setTransform(-73.725, -100.625);

    this.shape_359 = new cjs.Shape();
    this.shape_359.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_359.setTransform(-77.175, -99.35);

    this.shape_360 = new cjs.Shape();
    this.shape_360.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAFABAEQADAGAJABQAMAAAEgMQADgGAAgKIAAgjIAMAAIAABIIgMAAIABgLQgDAEgEACQgGAHgKgBQgOAAgGgKg",
      );
    this.shape_360.setTransform(-83.85, -99.15);

    this.shape_361 = new cjs.Shape();
    this.shape_361.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_361.setTransform(-89.65, -100.225);

    this.shape_362 = new cjs.Shape();
    this.shape_362.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAHgLAAQgHAAgGgEIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFALAMAAQAIAAAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_362.setTransform(-95.225, -97.9);

    this.shape_363 = new cjs.Shape();
    this.shape_363.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_363.setTransform(-102.975, -99.225);

    this.shape_364 = new cjs.Shape();
    this.shape_364.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_364.setTransform(-110.475, -99.275);

    this.shape_365 = new cjs.Shape();
    this.shape_365.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_365.setTransform(85.275, -116.025);

    this.shape_366 = new cjs.Shape();
    this.shape_366.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_366.setTransform(79.525, -116.15);

    this.shape_367 = new cjs.Shape();
    this.shape_367.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQABgDABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_367.setTransform(75.6, -120.675);

    this.shape_368 = new cjs.Shape();
    this.shape_368.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAFABAEQAEAGAIAAQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_368.setTransform(69.75, -115.95);

    this.shape_369 = new cjs.Shape();
    this.shape_369.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_369.setTransform(62, -116.05);

    this.shape_370 = new cjs.Shape();
    this.shape_370.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgMAdQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_370.setTransform(54.7, -114.55);

    this.shape_371 = new cjs.Shape();
    this.shape_371.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHALQAFAAACgHIABgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQgBAHgDAGQgDAGgIACg",
      );
    this.shape_371.setTransform(45.4, -112.1);

    this.shape_372 = new cjs.Shape();
    this.shape_372.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_372.setTransform(41.5, -117.025);

    this.shape_373 = new cjs.Shape();
    this.shape_373.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQAEAGAIAAQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgEADQgHAFgIAAQgQAAgFgKg",
      );
    this.shape_373.setTransform(35.7, -115.95);

    this.shape_374 = new cjs.Shape();
    this.shape_374.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgEgGQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_374.setTransform(27.95, -116.05);

    this.shape_375 = new cjs.Shape();
    this.shape_375.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_375.setTransform(17.225, -117.425);

    this.shape_376 = new cjs.Shape();
    this.shape_376.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_376.setTransform(11.375, -116.15);

    this.shape_377 = new cjs.Shape();
    this.shape_377.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_377.setTransform(4.7, -116.05);

    this.shape_378 = new cjs.Shape();
    this.shape_378.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_378.setTransform(-4.2, -116.05);

    this.shape_379 = new cjs.Shape();
    this.shape_379.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_379.setTransform(-15.05, -117.025);

    this.shape_380 = new cjs.Shape();
    this.shape_380.graphics.f("#31353B").s().p("AgDAUIgCgnIALAAIgCAng");
    this.shape_380.setTransform(-17.875, -120.425);

    this.shape_381 = new cjs.Shape();
    this.shape_381.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_381.setTransform(-23.425, -116.15);

    this.shape_382 = new cjs.Shape();
    this.shape_382.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_382.setTransform(-31.425, -117.325);

    this.shape_383 = new cjs.Shape();
    this.shape_383.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_383.setTransform(-36.625, -117.425);

    this.shape_384 = new cjs.Shape();
    this.shape_384.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_384.setTransform(-42.275, -117.325);

    this.shape_385 = new cjs.Shape();
    this.shape_385.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_385.setTransform(-51.75, -117.025);

    this.shape_386 = new cjs.Shape();
    this.shape_386.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_386.setTransform(-57.325, -116.025);

    this.shape_387 = new cjs.Shape();
    this.shape_387.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_387.setTransform(-65.225, -117.45);

    this.shape_388 = new cjs.Shape();
    this.shape_388.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_388.setTransform(-71.1, -117.025);

    this.shape_389 = new cjs.Shape();
    this.shape_389.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALAAQAHAAAFgEQAGgDgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgFgCgDQgFgEgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_389.setTransform(-80.3, -116);

    this.shape_390 = new cjs.Shape();
    this.shape_390.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_390.setTransform(-87.95, -114.575);

    this.shape_391 = new cjs.Shape();
    this.shape_391.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_391.setTransform(-95.425, -116.15);

    this.shape_392 = new cjs.Shape();
    this.shape_392.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_392.setTransform(-100.875, -117.425);

    this.shape_393 = new cjs.Shape();
    this.shape_393.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_393.setTransform(-106.275, -117.45);

    this.shape_394 = new cjs.Shape();
    this.shape_394.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_394.setTransform(-112.15, -117.025);

    this.shape_395 = new cjs.Shape();
    this.shape_395.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_395.setTransform(116.425, -132.95);

    this.shape_396 = new cjs.Shape();
    this.shape_396.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_396.setTransform(109.75, -132.85);

    this.shape_397 = new cjs.Shape();
    this.shape_397.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgDgEQgFgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_397.setTransform(98.6, -132.8);

    this.shape_398 = new cjs.Shape();
    this.shape_398.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_398.setTransform(91.175, -132.825);

    this.shape_399 = new cjs.Shape();
    this.shape_399.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_399.setTransform(85.425, -132.95);

    this.shape_400 = new cjs.Shape();
    this.shape_400.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALABAFgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgIAGgIABQgPAAgGgLg",
      );
    this.shape_400.setTransform(78.75, -132.75);

    this.shape_401 = new cjs.Shape();
    this.shape_401.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_401.setTransform(73.4, -134.225);

    this.shape_402 = new cjs.Shape();
    this.shape_402.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_402.setTransform(70.275, -134.225);

    this.shape_403 = new cjs.Shape();
    this.shape_403.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_403.setTransform(65.025, -132.825);

    this.shape_404 = new cjs.Shape();
    this.shape_404.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_404.setTransform(59.075, -134.3);

    this.shape_405 = new cjs.Shape();
    this.shape_405.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_405.setTransform(51.375, -132.95);

    this.shape_406 = new cjs.Shape();
    this.shape_406.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_406.setTransform(44.725, -132.825);

    this.shape_407 = new cjs.Shape();
    this.shape_407.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_407.setTransform(38.9, -133.825);

    this.shape_408 = new cjs.Shape();
    this.shape_408.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_408.setTransform(33.175, -132.95);

    this.shape_409 = new cjs.Shape();
    this.shape_409.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMABAEgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEACQgHAGgIABQgQAAgFgLg",
      );
    this.shape_409.setTransform(25.35, -132.75);

    this.shape_410 = new cjs.Shape();
    this.shape_410.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_410.setTransform(17.6, -132.85);

    this.shape_411 = new cjs.Shape();
    this.shape_411.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_411.setTransform(10.325, -132.875);

    this.shape_412 = new cjs.Shape();
    this.shape_412.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_412.setTransform(2.925, -132.95);

    this.shape_413 = new cjs.Shape();
    this.shape_413.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_413.setTransform(-4.875, -132.825);

    this.shape_414 = new cjs.Shape();
    this.shape_414.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMABAEgMQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEACQgHAGgIABQgQAAgFgLg",
      );
    this.shape_414.setTransform(-16.5, -132.75);

    this.shape_415 = new cjs.Shape();
    this.shape_415.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_415.setTransform(-24.25, -132.85);

    this.shape_416 = new cjs.Shape();
    this.shape_416.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFACIADAAIAEgCIADgDIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAGQgDAHgLAAg",
      );
    this.shape_416.setTransform(-31.55, -131.35);

    this.shape_417 = new cjs.Shape();
    this.shape_417.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_417.setTransform(-42.775, -132.95);

    this.shape_418 = new cjs.Shape();
    this.shape_418.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_418.setTransform(-50.575, -132.825);

    this.shape_419 = new cjs.Shape();
    this.shape_419.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_419.setTransform(-58.275, -134.25);

    this.shape_420 = new cjs.Shape();
    this.shape_420.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_420.setTransform(-67.25, -132.85);

    this.shape_421 = new cjs.Shape();
    this.shape_421.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_421.setTransform(-79.975, -132.95);

    this.shape_422 = new cjs.Shape();
    this.shape_422.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_422.setTransform(-87.775, -132.825);

    this.shape_423 = new cjs.Shape();
    this.shape_423.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_423.setTransform(-95.125, -132.85);

    this.shape_424 = new cjs.Shape();
    this.shape_424.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_425 = new cjs.Shape();
    this.shape_425.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_425 },
            { t: this.shape_424 },
            { t: this.shape_423 },
            { t: this.shape_422 },
            { t: this.shape_421 },
            { t: this.shape_420 },
            { t: this.shape_419 },
            { t: this.shape_418 },
            { t: this.shape_417 },
            { t: this.shape_416 },
            { t: this.shape_415 },
            { t: this.shape_414 },
            { t: this.shape_413 },
            { t: this.shape_412 },
            { t: this.shape_411 },
            { t: this.shape_410 },
            { t: this.shape_409 },
            { t: this.shape_408 },
            { t: this.shape_407 },
            { t: this.shape_406 },
            { t: this.shape_405 },
            { t: this.shape_404 },
            { t: this.shape_403 },
            { t: this.shape_402 },
            { t: this.shape_401 },
            { t: this.shape_400 },
            { t: this.shape_399 },
            { t: this.shape_398 },
            { t: this.shape_397 },
            { t: this.shape_396 },
            { t: this.shape_395 },
            { t: this.shape_394 },
            { t: this.shape_393 },
            { t: this.shape_392 },
            { t: this.shape_391 },
            { t: this.shape_390 },
            { t: this.shape_389 },
            { t: this.shape_388 },
            { t: this.shape_387 },
            { t: this.shape_386 },
            { t: this.shape_385 },
            { t: this.shape_384 },
            { t: this.shape_383 },
            { t: this.shape_382 },
            { t: this.shape_381 },
            { t: this.shape_380 },
            { t: this.shape_379 },
            { t: this.shape_378 },
            { t: this.shape_377 },
            { t: this.shape_376 },
            { t: this.shape_375 },
            { t: this.shape_374 },
            { t: this.shape_373 },
            { t: this.shape_372 },
            { t: this.shape_371 },
            { t: this.shape_370 },
            { t: this.shape_369 },
            { t: this.shape_368 },
            { t: this.shape_367 },
            { t: this.shape_366 },
            { t: this.shape_365 },
            { t: this.shape_364 },
            { t: this.shape_363 },
            { t: this.shape_362 },
            { t: this.shape_361 },
            { t: this.shape_360 },
            { t: this.shape_359 },
            { t: this.shape_358 },
            { t: this.shape_357 },
            { t: this.shape_356 },
            { t: this.shape_355 },
            { t: this.shape_354 },
            { t: this.shape_353 },
            { t: this.shape_352 },
            { t: this.shape_351 },
            { t: this.shape_350 },
            { t: this.shape_349 },
            { t: this.shape_348 },
            { t: this.shape_347 },
            { t: this.shape_346 },
            { t: this.shape_345 },
            { t: this.shape_344 },
            { t: this.shape_343 },
            { t: this.shape_342 },
            { t: this.shape_341 },
            { t: this.shape_340 },
            { t: this.shape_339 },
            { t: this.shape_338 },
            { t: this.shape_337 },
            { t: this.shape_336 },
            { t: this.shape_335 },
            { t: this.shape_334 },
            { t: this.shape_333 },
            { t: this.shape_332 },
            { t: this.shape_331 },
            { t: this.shape_330 },
            { t: this.shape_329 },
            { t: this.shape_328 },
            { t: this.shape_327 },
            { t: this.shape_326 },
            { t: this.shape_325 },
            { t: this.shape_324 },
            { t: this.shape_323 },
            { t: this.shape_322 },
            { t: this.shape_321 },
            { t: this.shape_320 },
            { t: this.shape_319 },
            { t: this.shape_318 },
            { t: this.shape_317 },
            { t: this.shape_316 },
            { t: this.shape_315 },
            { t: this.shape_314 },
            { t: this.shape_313 },
            { t: this.shape_312 },
            { t: this.shape_311 },
            { t: this.shape_310 },
            { t: this.shape_309 },
            { t: this.shape_308 },
            { t: this.shape_307 },
            { t: this.shape_306 },
            { t: this.shape_305 },
            { t: this.shape_304 },
            { t: this.shape_303 },
            { t: this.shape_302 },
            { t: this.shape_301 },
            { t: this.shape_300 },
            { t: this.shape_299 },
            { t: this.shape_298 },
            { t: this.shape_297 },
            { t: this.shape_296 },
            { t: this.shape_295 },
            { t: this.shape_294 },
            { t: this.shape_293 },
            { t: this.shape_292 },
            { t: this.shape_291 },
            { t: this.shape_290 },
            { t: this.shape_289 },
            { t: this.shape_288 },
            { t: this.shape_287 },
            { t: this.shape_286 },
            { t: this.shape_285 },
            { t: this.shape_284 },
            { t: this.shape_283 },
            { t: this.shape_282 },
            { t: this.shape_281 },
            { t: this.shape_280 },
            { t: this.shape_279 },
            { t: this.shape_278 },
            { t: this.shape_277 },
            { t: this.shape_276 },
            { t: this.shape_275 },
            { t: this.shape_274 },
            { t: this.shape_273 },
            { t: this.shape_272 },
            { t: this.shape_271 },
            { t: this.shape_270 },
            { t: this.shape_269 },
            { t: this.shape_268 },
            { t: this.shape_267 },
            { t: this.shape_266 },
            { t: this.shape_265 },
            { t: this.shape_264 },
            { t: this.shape_263 },
            { t: this.shape_262 },
            { t: this.shape_261 },
            { t: this.shape_260 },
            { t: this.shape_259 },
            { t: this.shape_258 },
            { t: this.shape_257 },
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.instance_1 },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_426 = new cjs.Shape();
    this.shape_426.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_426.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_426).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote09testimonialBiogen03,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote08testimonialConsumergoods04 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AAlBNIgmh0IgoB0IgJAAIgWhNIgPg2IgDgGIgFgFIgHgCIgGgCIAAgHIA+AAIAAAHIgOACQgGABAAADIABADIAAADIAJAfIATBAIAlhwIAKAAIAnBzIANguIAJgiIADgOIABgGQAAgEgFgCQgFgDgLgBIAAgHIA3AAIAAAHIgGACIgHADQgDACgDADQgCADgCAGIgSA5IgVBGg",
      );
    this.shape.setTransform(-98.125, -135.025);

    this.instance_1 = new lib.Logo_ConsumerGoodsCompanyLogo();
    this.instance_1.setTransform(56.7, 99.05, 0.7684, 0.7684);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_1.setTransform(3.4321, 118.375);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_2.setTransform(-3.6529, 118.475);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_3.setTransform(-8.325, 117.2);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(-13.3923, 118.475);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_5.setTransform(-17.675, 117.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p("AgUAiIgLhDIAOAAIAGA2IAeg2IAMAAIgmBDg");
    this.shape_6.setTransform(-21.95, 118.45);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_7.setTransform(-27.025, 117.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhcIAkAAQAUAAAHANQAHAMgEAUQgDAOgIAMQgPAUgXABgAgcAkIAWAAIAKgBQAIgDAGgHQAFgGAEgIIADgKQADgQgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_8.setTransform(-33.312, 117.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgJAEgQQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_9.setTransform(-45.3292, 118.5);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAKAAIgCAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgBgBIgCAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_10.setTransform(-50.65, 118.375);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgJQACgKAHgFQAHgEAKgBIASgDQAEAAACgDIABgFQACgFgEgDQgEgCgHgBQgIAAgFAGQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgDQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHACQgGAAgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_11.setTransform(-57.0188, 118.5);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgLADgOQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgJg",
      );
    this.shape_12.setTransform(-63.535, 118.45);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_13.setTransform(-70.6679, 117.175);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-75.3821, 117.55);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f("#949EA7").s().p("AgPAvIAThcIAMAAIgTBcg");
    this.shape_15.setTransform(-78.825, 117.2);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgJQACgKAHgFQAHgEAKgBIASgDQAEAAACgDIABgFQACgFgEgDQgEgCgHgBQgIAAgFAGQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgDQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHACQgGAAgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_16.setTransform(-84.3688, 118.5);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgJAEgQQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_17.setTransform(-91.3792, 118.5);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p("AAPAvIAJgsIgwAAIgJAsIgNAAIAUhcIANAAIgIAmIAvAAIAIgmIANAAIgUBcg");
    this.shape_18.setTransform(-99.3, 117.2);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_19.setTransform(-56.6321, 101.75);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_20.setTransform(-62.2923, 102.675);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_21.setTransform(-66.575, 101.4);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_22.setTransform(-69.5821, 101.75);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_23.setTransform(-75.6679, 102.575);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_24.setTransform(-82.7292, 102.7);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-87.425, 101.4);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgGgDgEQgCgFgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgKg",
      );
    this.shape_26.setTransform(-92.285, 102.65);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiApQgIgKADgPIAMAAQgBAJACAEQAFAJAPAAQAHAAAGgCQAMgEACgJQACgIgEgEQgEgCgKgDIgLgDQgMgCgEgDQgIgGACgLQADgNAKgIQALgIAPAAQAOAAAJAHQAJAHgDAPIgMAAQAAgHgCgEQgEgHgOAAQgKAAgGAEQgGAFgBAHQgCAHAFADQAEACALACIANAEQAJACAEACQAIAHgDAMQgDAQgNAHQgNAGgOAAQgRAAgIgIg",
      );
    this.shape_27.setTransform(-99.7787, 101.4);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_28.setTransform(74.525, 55.7);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_29.setTransform(68.475, 51.525);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_30.setTransform(62.925, 52.7);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_31.setTransform(56.475, 52.825);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_32.setTransform(48.325, 51.525);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_33.setTransform(40.825, 52.7);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_34.setTransform(33.225, 52.825);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_35.setTransform(27.2, 51.825);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_36.setTransform(21.85, 52.85);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_37.setTransform(10.375, 51.525);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_38.setTransform(5.2, 51.425);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_39.setTransform(-0.3, 52.8);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgIgFgBgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_40.setTransform(-8.25, 54.275);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_41.setTransform(-19.625, 52.825);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_42.setTransform(-27.325, 51.4);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_43.setTransform(-33.2, 51.825);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEgBgGQAAgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_44.setTransform(-42.4, 52.85);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAEgBADgEQAAgDAAgEIAAgBIAAgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_45.setTransform(-46.85, 48.175);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_46.setTransform(-50.75, 51.825);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_47.setTransform(-56.325, 52.825);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_48.setTransform(-64.225, 51.4);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p("AgGAyIAAhXIgiAAIAAgMIBQAAIAAAMIghAAIAABXg");
    this.shape_49.setTransform(-72.35, 51.425);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_50.setTransform(-82.175, 55.7);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgDQAGgEgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_51.setTransform(-87.6, 52.85);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_52.setTransform(-92.675, 51.425);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_53.setTransform(-100.05, 51.825);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_54.setTransform(-103.475, 51.425);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_55.setTransform(100.375, 36.025);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_56.setTransform(94.625, 35.9);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_57.setTransform(87.975, 36.025);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p("AAaAyIAAgvIgzAAIAAAvIgNAAIAAhjIANAAIAAApIAzAAIAAgpIAOAAIAABjg");
    this.shape_58.setTransform(79.1, 34.625);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AAEASIAAgOQAAgHADgGQAEgHAIgBIAAAHQgEAAgCAEQgCAEAAADIAAABIAAABIAIAAIAAAPgAgSASIAAgOQAAgJAEgFQAEgGAHgBIAAAHQgFABgCAGIgBAEIAAABIAAABIAIAAIAAAPg",
      );
    this.shape_59.setTransform(71.825, 31.275);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGABgPQgFAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_60.setTransform(61.4, 37.475);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_61.setTransform(53.925, 35.9);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_62.setTransform(48.475, 34.625);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgLIAFABIACAAIAGgBIACgEIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAgIgMAeQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_63.setTransform(43.45, 37.5);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_64.setTransform(36.225, 36.025);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgCQAGgDgBgHQAAgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAEACQAIAEAAALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_65.setTransform(28.7, 36.05);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgFgEgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_66.setTransform(17.85, 36.05);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_67.setTransform(10.625, 36.025);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgLIAFABIACAAIAGgBIACgEIACgFIADgHIgbhLIAOAAIATA7IAUg7IAOAAIgMAgIgMAeQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_68.setTransform(-0.75, 37.5);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgCQAGgDgBgHQAAgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_69.setTransform(-7.75, 36.05);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_70.setTransform(-14.975, 36.025);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_71.setTransform(-22.925, 36.025);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgCQAGgDAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgMAAQAAgFgDgDQgDgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_72.setTransform(-34.1, 36.05);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_73.setTransform(-41.325, 36.025);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgEgDQgDgEgKAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_74.setTransform(-52.7, 36.05);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_75.setTransform(-57.775, 34.625);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_76.setTransform(-65.075, 35.9);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_77.setTransform(-71.725, 36.025);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_78.setTransform(-77.55, 35.025);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_79.setTransform(-83.275, 35.9);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(-91.075, 36.025);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcAqQgPgOAAgcQAAgWAMgOQAMgQAWAAQASAAALAKQAKAKABANIgNAAQgCgKgHgFQgGgGgMAAQgOAAgJAKQgJALAAAUQAAASAIALQAIALAQAAQAOAAAIgMQAEgGACgKIANAAQgBAQgLALQgLANgVAAQgQAAgMgLg",
      );
    this.shape_81.setTransform(-100, 34.625);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_82.setTransform(83.875, 17.925);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_83.setTransform(76.375, 19.1);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_84.setTransform(68.775, 19.225);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_85.setTransform(58.925, 19.1);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_86.setTransform(47.275, 19.1);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_87.setTransform(37.5, 19.2);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcAqQgPgOAAgcQAAgWAMgOQAMgQAWAAQASAAALAKQAKAKABANIgNAAQgCgKgHgFQgHgGgLAAQgOAAgJAKQgJALAAAUQAAASAIALQAIALAQAAQAOAAAIgMQAEgGACgKIANAAQgBAQgKALQgMANgVAAQgPAAgNgLg",
      );
    this.shape_88.setTransform(28.6, 17.825);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_89.setTransform(15.825, 19.225);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_90.setTransform(8.125, 17.8);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_91.setTransform(2.25, 18.225);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_92.setTransform(-7.4, 19.2);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_93.setTransform(-13.2, 18.225);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_94.setTransform(-22.4, 19.25);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_95.setTransform(-29.4, 19.25);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_96.setTransform(-36.825, 19.225);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_97.setTransform(-44.125, 19.175);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_98.setTransform(-51.125, 19.175);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_99.setTransform(-58.375, 19.225);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_100.setTransform(-69.75, 19.25);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_101.setTransform(-75.175, 19.1);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_102.setTransform(-81.825, 19.225);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_103.setTransform(-89.525, 17.8);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_104.setTransform(-95.4, 18.225);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_105.setTransform(-101.2, 19.2);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgIgFgBgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgEAMg",
      );
    this.shape_106.setTransform(79.05, 3.875);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAALIAAAtg",
      );
    this.shape_107.setTransform(71.575, 2.3);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_108.setTransform(66.125, 1.025);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_109.setTransform(61.075, 2.4);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_110.setTransform(56.025, 1.025);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgeApQgOgOAAgZQAAgZANgPQANgOATAAQAOAAAKAGQAPAIADATIgNAAQgCgLgIgFQgIgFgLAAQgMAAgKALQgJAKAAAUQgBASAJALQAHALAQAAQAOAAAJgIQAJgIAAgRIggAAIAAgKIAsAAIAAA0IgJAAIgDgNQgGAIgGADQgJAFgNAAQgRAAgMgMg",
      );
    this.shape_111.setTransform(48.85, 1.025);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_112.setTransform(37.875, 5.3);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_113.setTransform(32.025, 2.425);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_114.setTransform(26.275, 2.3);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_115.setTransform(19.825, 2.425);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAKIAAAug",
      );
    this.shape_116.setTransform(11.925, 1);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_117.setTransform(4.55, 2.45);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAHQAFAIAKAAQAMAAAEgJQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_118.setTransform(-6.75, 2.4);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_119.setTransform(-12.55, 1.425);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_120.setTransform(-20.25, 1.425);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAALIAAAtg",
      );
    this.shape_121.setTransform(-25.975, 2.3);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_122.setTransform(-33.575, 2.425);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAOA4IAPg4IAMAAIgVBIg");
    this.shape_123.setTransform(-42.7, 2.4);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAFABAEQADAGAJAAQAMAAAEgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKAAQgOABgGgLg",
      );
    this.shape_124.setTransform(-55.5, 2.5);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAHQAFAIAKAAQAMAAAFgJQAEgJAAgKQAAgLgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_125.setTransform(-63.25, 2.4);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgCIAAgLIAFABIACAAIAFgBIADgCIADgGIADgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgEAHQgDAFgMABg",
      );
    this.shape_126.setTransform(-70.55, 3.9);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_127.setTransform(-81.625, 2.425);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_128.setTransform(-87.65, 1.425);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_129.setTransform(-93.225, 2.425);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_130.setTransform(-101.375, 1.125);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgLIAFABIACAAIAGgBIACgEIACgFIADgHIgbhLIAOAAIATA7IAUg7IAOAAIgMAgIgMAeQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_131.setTransform(76.65, -12.9);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_132.setTransform(69.275, -14.5);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_133.setTransform(61.675, -14.375);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgyQAAgIgDgCQgEgDgFAAQgHAAgGAEQgFAFAAAMIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAFAAAOIAAAnIgMAAIAAhJIAMAAIAAALIAIgIQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgDQAFgEAHAAQAPABAFAKQADAGAAAKIAAAwg",
      );
    this.shape_134.setTransform(47.975, -14.5);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_135.setTransform(40.225, -14.5);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_136.setTransform(33.55, -14.4);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_137.setTransform(27.825, -15.85);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgJgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAHAKQAEAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAFACQAHAEAAALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_138.setTransform(22.4, -14.35);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_139.setTransform(15.025, -14.5);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_140.setTransform(7.425, -14.375);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_141.setTransform(1.475, -14.5);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_142.setTransform(-3.25, -15.375);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_143.setTransform(-12.9, -14.4);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_144.setTransform(-18.7, -15.375);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQAEAHAIAAQALAAAFgMQACgGAAgKIAAgkIANAAIAABJIgMAAIAAgMQgCAFgDACQgIAHgIAAQgPAAgGgLg",
      );
    this.shape_145.setTransform(-28.35, -14.3);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_146.setTransform(-36.1, -14.4);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgLIAFABIACAAIAGgBIACgEIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAgIgMAeQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_147.setTransform(-43.4, -12.9);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_148.setTransform(-54.9, -12.925);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_149.setTransform(-62.375, -14.5);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_150.setTransform(-67.825, -15.775);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_151.setTransform(-71.275, -14.5);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_152.setTransform(-75.575, -15.775);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQABAGABADQADAHAJAAQAMAAAEgMQACgGABgKIAAgkIAMAAIAABJIgMAAIABgMQgDAFgEACQgGAHgKAAQgPAAgFgLg",
      );
    this.shape_153.setTransform(-81.05, -14.3);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AAUA0IAAgmQgDAFgGADQgFADgHAAQgMAAgJgJQgJgJAAgSQAAgRAIgMQAJgLAOAAQAIAAAGAEIAHAIIAAgKIALAAIAABlgAgNghQgFAHAAAOQAAAKACAGQAFALALgBQANABAFgMQACgGAAgKQAAgKgCgGQgFgLgNAAQgHAAgGAHg",
      );
    this.shape_154.setTransform(-88.975, -13.05);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_155.setTransform(-96.525, -14.375);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_156.setTransform(-102.275, -14.5);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHALQAFAAACgHIABgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAHgEAGQgDAHgIABg",
      );
    this.shape_157.setTransform(98.85, -27.25);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_158.setTransform(93.45, -31.15);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_159.setTransform(84.125, -31.3);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_160.setTransform(74.375, -31.175);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_161.setTransform(68.55, -32.175);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_162.setTransform(63.2, -31.15);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgKIAFAAIADAAIAEAAIADgDIADgGIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAHQgDAFgLAAg",
      );
    this.shape_163.setTransform(56.2, -29.7);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALABQAHgBAFgDQAGgDgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_164.setTransform(49.2, -31.15);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_165.setTransform(37.725, -32.475);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_166.setTransform(30.225, -31.3);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_167.setTransform(22.625, -31.175);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_168.setTransform(11.25, -31.15);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAJgLAPAAQANAAAKAKQAKAJAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_169.setTransform(3.8, -31.2);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_170.setTransform(-1.55, -32.575);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_171.setTransform(-4.675, -32.575);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_172.setTransform(-9.7, -31.15);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_173.setTransform(-19.05, -32.175);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_174.setTransform(-24.775, -31.3);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_175.setTransform(-32.575, -31.175);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_176.setTransform(-38.325, -31.3);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_177.setTransform(-44.975, -31.175);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_178.setTransform(-50.725, -32.65);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_179.setTransform(-54.325, -32.65);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_180.setTransform(-57.825, -32.575);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_181.setTransform(-63.475, -32.475);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_182.setTransform(-74.825, -31.3);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_183.setTransform(-80.275, -32.575);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_184.setTransform(-87.65, -32.175);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAFACAEQAEAGAIABQAMAAAEgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgEACQgHAHgIgBQgQAAgFgKg",
      );
    this.shape_185.setTransform(-93.45, -31.1);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_186.setTransform(-100.975, -32.475);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHALQAFgBACgFIAAgFIAAgBIAAgBIgHAAIAAgPIAPAAIAAAOQgBAHgDAGQgDAGgIACg",
      );
    this.shape_187.setTransform(86.8, -44.05);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgEgDQgDgEgKAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_188.setTransform(81.4, -47.95);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_189.setTransform(75.9, -48.975);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAHAJQAEAHAAAHIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAFACQAHAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_190.setTransform(70.55, -47.95);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_191.setTransform(65.475, -49.375);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p("AASAkIgSgbIgRAbIgPAAIAZgkIgZgkIARAAIAQAaIARgaIAOAAIgZAkIAaAkg");
    this.shape_192.setTransform(60.4, -48);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_193.setTransform(53.025, -47.975);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_194.setTransform(41.225, -49.275);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_195.setTransform(33.675, -47.975);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_196.setTransform(25.925, -47.975);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_197.setTransform(18.225, -48.1);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_198.setTransform(6.575, -47.975);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA4IAOg4IANAAIgWBIg");
    this.shape_199.setTransform(-2.35, -48);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_200.setTransform(-15.35, -46.525);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_201.setTransform(-22.825, -48.1);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_202.setTransform(-28.275, -49.375);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_203.setTransform(-33.675, -49.4);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_204.setTransform(-39.55, -48.975);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgCIAAgLIAFABIACAAIAFgBIADgCIADgGIADgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgEAHQgDAFgMABg",
      );
    this.shape_205.setTransform(-44.9, -46.5);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_206.setTransform(-50.325, -48.1);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_207.setTransform(-56.975, -47.975);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_208.setTransform(-64.325, -48);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_209.setTransform(-71.725, -47.975);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_210.setTransform(-84.5, -48);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_211.setTransform(-93.45, -48);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_212.setTransform(-101.125, -48.1);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_213.setTransform(91.35, -65.775);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAgvQAAgHgCgEQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQABAGAKQADAHAAAJIAAAwg",
      );
    this.shape_214.setTransform(85.625, -66.2);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGABgPQgFAFgEADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_215.setTransform(77.6, -63.325);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_216.setTransform(72.425, -66.175);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AAYAyIgBgDIAAgIIgBgRQgBgKgHgDQgEgCgHAAIgeAAIAAArIgNAAIAAhjIAsAAQAMAAAHADQAOAHAAARQAAAJgEAGQgEAFgGADQAGACACAEQADAEABAJIAAANIACAJQAAAFAEABIAAACgAgbgDIAeAAQAKAAAEgEQAGgEAAgKQAAgLgIgDQgDgCgIAAIgfAAg",
      );
    this.shape_217.setTransform(66.15, -66.175);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics.f("#31353B").s().p("AgGAIIAAgOIANAAIAAAOg");
    this.shape_218.setTransform(55.025, -61.9);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgCQAGgDAAgHQAAgEgFgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgMAAQAAgFgDgDQgDgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_219.setTransform(49.6, -64.75);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_220.setTransform(44.175, -64.9);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_221.setTransform(37.5, -64.8);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_222.setTransform(31.7, -65.775);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_223.setTransform(26.125, -64.775);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_224.setTransform(20.55, -66.175);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQgBAGACADQADAHAJAAQALAAAFgMQADgGAAgKIAAgkIAMAAIAABJIgMAAIABgMQgDAFgEACQgHAHgJAAQgOAAgGgLg",
      );
    this.shape_225.setTransform(15.05, -64.7);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgyQAAgIgDgCQgEgDgFAAQgHAAgGAEQgFAFAAAMIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAFAAAOIAAAnIgMAAIAAhJIAMAAIAAALIAIgIQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgDQAFgEAHAAQAPABAFAKQADAGAAAKIAAAwg",
      );
    this.shape_226.setTransform(5.425, -64.9);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_227.setTransform(-2.325, -64.9);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_228.setTransform(-9, -64.8);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_229.setTransform(-14.725, -66.25);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_230.setTransform(-24.625, -66.075);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_231.setTransform(-32.125, -64.9);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_232.setTransform(-39.725, -64.775);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_233.setTransform(-51.1, -64.75);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_234.setTransform(-56.6, -65.775);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_235.setTransform(-61.95, -64.75);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_236.setTransform(-67.025, -66.175);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_237.setTransform(-70.55, -65.775);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_238.setTransform(-76.275, -64.9);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_239.setTransform(-84.075, -64.775);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_240.setTransform(-89.475, -66.175);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_241.setTransform(-94.475, -64.825);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_242.setTransform(-101.5, -64.75);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_243.setTransform(53.875, -81.575);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_244.setTransform(47.85, -82.575);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_245.setTransform(42.275, -81.575);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_246.setTransform(34.125, -82.875);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_247.setTransform(22.775, -83);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_248.setTransform(16.9, -82.575);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_249.setTransform(13.475, -82.975);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgMAAIgWhIIAOAAIAOA4IAOg4IANAAIAPA3IAPg3IALAAIgUBIg");
    this.shape_250.setTransform(6.85, -81.6);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_251.setTransform(-5.925, -81.575);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_252.setTransform(-13.225, -81.625);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_253.setTransform(-20.475, -81.575);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_254.setTransform(-26.425, -83.05);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_255.setTransform(-30.275, -81.7);

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_256.setTransform(-36.925, -81.575);

    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_257.setTransform(-42.75, -82.575);

    this.shape_258 = new cjs.Shape();
    this.shape_258.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_258.setTransform(-48.475, -81.7);

    this.shape_259 = new cjs.Shape();
    this.shape_259.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_259.setTransform(-53.925, -82.975);

    this.shape_260 = new cjs.Shape();
    this.shape_260.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_260.setTransform(-63.25, -81.6);

    this.shape_261 = new cjs.Shape();
    this.shape_261.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_261.setTransform(-69.05, -82.575);

    this.shape_262 = new cjs.Shape();
    this.shape_262.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_262.setTransform(-78.675, -81.575);

    this.shape_263 = new cjs.Shape();
    this.shape_263.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_263.setTransform(-86.025, -81.6);

    this.shape_264 = new cjs.Shape();
    this.shape_264.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_264.setTransform(-93.225, -81.575);

    this.shape_265 = new cjs.Shape();
    this.shape_265.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_265.setTransform(-101.125, -83);

    this.shape_266 = new cjs.Shape();
    this.shape_266.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_266.setTransform(86.35, -98.4);

    this.shape_267 = new cjs.Shape();
    this.shape_267.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_267.setTransform(79.05, -98.35);

    this.shape_268 = new cjs.Shape();
    this.shape_268.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_268.setTransform(74, -99.775);

    this.shape_269 = new cjs.Shape();
    this.shape_269.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_269.setTransform(68.725, -98.375);

    this.shape_270 = new cjs.Shape();
    this.shape_270.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_270.setTransform(56.925, -98.375);

    this.shape_271 = new cjs.Shape();
    this.shape_271.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_271.setTransform(48, -98.4);

    this.shape_272 = new cjs.Shape();
    this.shape_272.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_272.setTransform(37.15, -99.375);

    this.shape_273 = new cjs.Shape();
    this.shape_273.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAFABAEQADAGAJAAQAMAAAEgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKAAQgOABgGgLg",
      );
    this.shape_273.setTransform(31.35, -98.3);

    this.shape_274 = new cjs.Shape();
    this.shape_274.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_274.setTransform(23.825, -99.675);

    this.shape_275 = new cjs.Shape();
    this.shape_275.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHALQAGgBABgFIAAgFIAAgBIAAgBIgHAAIAAgPIAPAAIAAAOQgBAHgDAGQgDAGgIACg",
      );
    this.shape_275.setTransform(14, -94.45);

    this.shape_276 = new cjs.Shape();
    this.shape_276.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_276.setTransform(8.6, -98.35);

    this.shape_277 = new cjs.Shape();
    this.shape_277.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_277.setTransform(3.1, -99.375);

    this.shape_278 = new cjs.Shape();
    this.shape_278.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgDgDQgDgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAKgHAGQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_278.setTransform(-2.25, -98.35);

    this.shape_279 = new cjs.Shape();
    this.shape_279.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_279.setTransform(-7.325, -99.775);

    this.shape_280 = new cjs.Shape();
    this.shape_280.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgHgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIAAQAIAAAGAEQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_280.setTransform(-14.675, -98.5);

    this.shape_281 = new cjs.Shape();
    this.shape_281.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_281.setTransform(-24.425, -98.375);

    this.shape_282 = new cjs.Shape();
    this.shape_282.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_282.setTransform(-32.125, -99.8);

    this.shape_283 = new cjs.Shape();
    this.shape_283.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_283.setTransform(-39.475, -98.425);

    this.shape_284 = new cjs.Shape();
    this.shape_284.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_284.setTransform(-48.4, -99.775);

    this.shape_285 = new cjs.Shape();
    this.shape_285.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_285.setTransform(-53.675, -98.375);

    this.shape_286 = new cjs.Shape();
    this.shape_286.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_286.setTransform(-61.175, -98.425);

    this.shape_287 = new cjs.Shape();
    this.shape_287.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_287.setTransform(-66.275, -99.775);

    this.shape_288 = new cjs.Shape();
    this.shape_288.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_288.setTransform(-69.8, -99.375);

    this.shape_289 = new cjs.Shape();
    this.shape_289.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgCIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgEAHQgDAFgMABg",
      );
    this.shape_289.setTransform(-75.15, -96.9);

    this.shape_290 = new cjs.Shape();
    this.shape_290.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_290.setTransform(-80.2, -99.775);

    this.shape_291 = new cjs.Shape();
    this.shape_291.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_291.setTransform(-85.475, -98.375);

    this.shape_292 = new cjs.Shape();
    this.shape_292.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_292.setTransform(-93.375, -98.5);

    this.shape_293 = new cjs.Shape();
    this.shape_293.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_293.setTransform(-100.975, -98.375);

    this.shape_294 = new cjs.Shape();
    this.shape_294.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_294.setTransform(97.525, -116.65);

    this.shape_295 = new cjs.Shape();
    this.shape_295.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_295.setTransform(91.65, -115.2);

    this.shape_296 = new cjs.Shape();
    this.shape_296.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_296.setTransform(82, -116.175);

    this.shape_297 = new cjs.Shape();
    this.shape_297.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_297.setTransform(76.2, -115.2);

    this.shape_298 = new cjs.Shape();
    this.shape_298.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_298.setTransform(70.85, -116.575);

    this.shape_299 = new cjs.Shape();
    this.shape_299.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_299.setTransform(61.725, -115.175);

    this.shape_300 = new cjs.Shape();
    this.shape_300.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGAAgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_300.setTransform(49.7, -113.725);

    this.shape_301 = new cjs.Shape();
    this.shape_301.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_301.setTransform(42.225, -115.3);

    this.shape_302 = new cjs.Shape();
    this.shape_302.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_302.setTransform(36.775, -116.575);

    this.shape_303 = new cjs.Shape();
    this.shape_303.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_303.setTransform(31.125, -116.475);

    this.shape_304 = new cjs.Shape();
    this.shape_304.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQAEAHAIAAQAMAAAEgMQACgGAAgKIAAgkIANAAIAABJIgMAAIAAgMQgCAFgEACQgHAHgIAAQgQAAgFgLg",
      );
    this.shape_304.setTransform(23.55, -115.1);

    this.shape_305 = new cjs.Shape();
    this.shape_305.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_305.setTransform(18.2, -116.575);

    this.shape_306 = new cjs.Shape();
    this.shape_306.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_306.setTransform(13.175, -115.225);

    this.shape_307 = new cjs.Shape();
    this.shape_307.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_307.setTransform(5.775, -115.3);

    this.shape_308 = new cjs.Shape();
    this.shape_308.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_308.setTransform(0.325, -116.575);

    this.shape_309 = new cjs.Shape();
    this.shape_309.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQAFgCABgFIABgGIAAAAIgBgBIgGAAIAAgPIAOAAIAAAOQAAAHgEAGQgEAGgGACg",
      );
    this.shape_309.setTransform(-7, -111.25);

    this.shape_310 = new cjs.Shape();
    this.shape_310.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_310.setTransform(-12.4, -115.15);

    this.shape_311 = new cjs.Shape();
    this.shape_311.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_311.setTransform(-17.825, -115.3);

    this.shape_312 = new cjs.Shape();
    this.shape_312.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_312.setTransform(-24.475, -115.175);

    this.shape_313 = new cjs.Shape();
    this.shape_313.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgCQAGgDgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_313.setTransform(-31.8, -115.15);

    this.shape_314 = new cjs.Shape();
    this.shape_314.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQADAHAJAAQALAAAFgMQADgGgBgKIAAgkIANAAIAABJIgMAAIAAgMQgCAFgDACQgHAHgJAAQgQAAgFgLg",
      );
    this.shape_314.setTransform(-39.25, -115.1);

    this.shape_315 = new cjs.Shape();
    this.shape_315.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_315.setTransform(-48.825, -116.65);

    this.shape_316 = new cjs.Shape();
    this.shape_316.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_316.setTransform(-54.7, -115.2);

    this.shape_317 = new cjs.Shape();
    this.shape_317.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDABgHQAAgEgFgDIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgFgEgDQgEgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_317.setTransform(-65.85, -115.15);

    this.shape_318 = new cjs.Shape();
    this.shape_318.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_318.setTransform(-73.075, -113.85);

    this.shape_319 = new cjs.Shape();
    this.shape_319.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQABAGABADQADAHAJAAQAMAAAEgMQACgGABgKIAAgkIAMAAIAABJIgMAAIABgMQgDAFgEACQgGAHgKAAQgPAAgFgLg",
      );
    this.shape_319.setTransform(-81.05, -115.1);

    this.shape_320 = new cjs.Shape();
    this.shape_320.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_320.setTransform(-88.8, -115.2);

    this.shape_321 = new cjs.Shape();
    this.shape_321.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_321.setTransform(-94.525, -115.3);

    this.shape_322 = new cjs.Shape();
    this.shape_322.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgIgFgBgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_322.setTransform(-101.4, -113.725);

    this.shape_323 = new cjs.Shape();
    this.shape_323.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_323.setTransform(68.775, -132.1);

    this.shape_324 = new cjs.Shape();
    this.shape_324.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_324.setTransform(62.1, -132);

    this.shape_325 = new cjs.Shape();
    this.shape_325.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDgBIAAgKQAIAAACgBQABgBAAgHIAAhRIAMAAIAABSQAAAJgDADQgEAHgLAAgAAAgyIAAgOIAMAAIAAAOg",
      );
    this.shape_325.setTransform(56.15, -131.9);

    this.shape_326 = new cjs.Shape();
    this.shape_326.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_326.setTransform(51.475, -131.975);

    this.shape_327 = new cjs.Shape();
    this.shape_327.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_327.setTransform(41.625, -132.1);

    this.shape_328 = new cjs.Shape();
    this.shape_328.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_328.setTransform(30.025, -132.1);

    this.shape_329 = new cjs.Shape();
    this.shape_329.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAFABAEQADAGAJABQAMAAAEgMQACgGABgKIAAgjIAMAAIAABIIgMAAIABgLQgDAEgEACQgGAHgKgBQgPAAgFgKg",
      );
    this.shape_329.setTransform(23.35, -131.9);

    this.shape_330 = new cjs.Shape();
    this.shape_330.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJAMQgJALgQAAQgPAAgJgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_330.setTransform(15.6, -132);

    this.shape_331 = new cjs.Shape();
    this.shape_331.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGAAgBAEQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_331.setTransform(9.875, -133.45);

    this.shape_332 = new cjs.Shape();
    this.shape_332.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_332.setTransform(2.175, -132.1);

    this.shape_333 = new cjs.Shape();
    this.shape_333.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_333.setTransform(-4.5, -132);

    this.shape_334 = new cjs.Shape();
    this.shape_334.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_334.setTransform(-16.075, -131.975);

    this.shape_335 = new cjs.Shape();
    this.shape_335.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_335.setTransform(-23.825, -131.975);

    this.shape_336 = new cjs.Shape();
    this.shape_336.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_336.setTransform(-29.575, -132.1);

    this.shape_337 = new cjs.Shape();
    this.shape_337.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_337.setTransform(-36.175, -133.4);

    this.shape_338 = new cjs.Shape();
    this.shape_338.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_338.setTransform(-42.05, -132.975);

    this.shape_339 = new cjs.Shape();
    this.shape_339.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_339.setTransform(-51.675, -131.975);

    this.shape_340 = new cjs.Shape();
    this.shape_340.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_340.setTransform(-59.025, -132);

    this.shape_341 = new cjs.Shape();
    this.shape_341.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_341.setTransform(-66.225, -131.975);

    this.shape_342 = new cjs.Shape();
    this.shape_342.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_342.setTransform(-74.125, -133.4);

    this.shape_343 = new cjs.Shape();
    this.shape_343.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_343.setTransform(-85.775, -131.975);

    this.shape_344 = new cjs.Shape();
    this.shape_344.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_345 = new cjs.Shape();
    this.shape_345.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_345 },
            { t: this.shape_344 },
            { t: this.shape_343 },
            { t: this.shape_342 },
            { t: this.shape_341 },
            { t: this.shape_340 },
            { t: this.shape_339 },
            { t: this.shape_338 },
            { t: this.shape_337 },
            { t: this.shape_336 },
            { t: this.shape_335 },
            { t: this.shape_334 },
            { t: this.shape_333 },
            { t: this.shape_332 },
            { t: this.shape_331 },
            { t: this.shape_330 },
            { t: this.shape_329 },
            { t: this.shape_328 },
            { t: this.shape_327 },
            { t: this.shape_326 },
            { t: this.shape_325 },
            { t: this.shape_324 },
            { t: this.shape_323 },
            { t: this.shape_322 },
            { t: this.shape_321 },
            { t: this.shape_320 },
            { t: this.shape_319 },
            { t: this.shape_318 },
            { t: this.shape_317 },
            { t: this.shape_316 },
            { t: this.shape_315 },
            { t: this.shape_314 },
            { t: this.shape_313 },
            { t: this.shape_312 },
            { t: this.shape_311 },
            { t: this.shape_310 },
            { t: this.shape_309 },
            { t: this.shape_308 },
            { t: this.shape_307 },
            { t: this.shape_306 },
            { t: this.shape_305 },
            { t: this.shape_304 },
            { t: this.shape_303 },
            { t: this.shape_302 },
            { t: this.shape_301 },
            { t: this.shape_300 },
            { t: this.shape_299 },
            { t: this.shape_298 },
            { t: this.shape_297 },
            { t: this.shape_296 },
            { t: this.shape_295 },
            { t: this.shape_294 },
            { t: this.shape_293 },
            { t: this.shape_292 },
            { t: this.shape_291 },
            { t: this.shape_290 },
            { t: this.shape_289 },
            { t: this.shape_288 },
            { t: this.shape_287 },
            { t: this.shape_286 },
            { t: this.shape_285 },
            { t: this.shape_284 },
            { t: this.shape_283 },
            { t: this.shape_282 },
            { t: this.shape_281 },
            { t: this.shape_280 },
            { t: this.shape_279 },
            { t: this.shape_278 },
            { t: this.shape_277 },
            { t: this.shape_276 },
            { t: this.shape_275 },
            { t: this.shape_274 },
            { t: this.shape_273 },
            { t: this.shape_272 },
            { t: this.shape_271 },
            { t: this.shape_270 },
            { t: this.shape_269 },
            { t: this.shape_268 },
            { t: this.shape_267 },
            { t: this.shape_266 },
            { t: this.shape_265 },
            { t: this.shape_264 },
            { t: this.shape_263 },
            { t: this.shape_262 },
            { t: this.shape_261 },
            { t: this.shape_260 },
            { t: this.shape_259 },
            { t: this.shape_258 },
            { t: this.shape_257 },
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_346 = new cjs.Shape();
    this.shape_346.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_346.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_346).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote08testimonialConsumergoods04,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote07testimonialDarpa01 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.instance_1 = new lib.Logo_Darpa();
    this.instance_1.setTransform(
      72.7,
      150.9,
      0.5158,
      0.5149,
      0,
      0,
      0,
      22.6,
      24.4,
    );

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AAQBMIAAgHIAHgBIAGgBQAEgCACgCQABgDAAgEIAAg2IhHAAIAAA1IABAGQACADAEACIAGACIAHABIAAAHIg/AAIAAgHIAHgBIAHgBQAEgCABgCQACgDAAgEIAAhtIgCgGQgBgDgEgCIgHgCIgHgCIAAgHIA/AAIAAAHIgHABIgGACQgEABgCADIgBAHIAAAvIBHAAIAAguIgBgGQgCgDgEgCIgGgCIgHgCIAAgHIA/AAIAAAHIgIABIgGACQgDABgCADIgBAHIAABtIABAGQACADADACIAGACIAIABIAAAHg",
      );
    this.shape.setTransform(-106.6, -136.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAwIgDgBIACgLIAEABIADABIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA2IAeg2IAMAAIgRAeIgQAbQgPAagFAGQgFAGgKAAg",
      );
    this.shape_1.setTransform(29.275, 118.15);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgIAmg",
      );
    this.shape_2.setTransform(24.25, 116.675);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_3.setTransform(20.4179, 115.85);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(14.7577, 116.775);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_5.setTransform(10.475, 115.5);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_6.setTransform(3.2071, 116.675);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAGgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_7.setTransform(-5.6792, 116.8);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_8.setTransform(-13.0179, 115.475);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_9.setTransform(-20.7132, 115.475);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics.f("#949EA7").s().p("AgPAvIAThcIAMAAIgTBcg");
    this.shape_10.setTransform(-30.525, 115.5);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgDQAEAAACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHAEQgHADgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_11.setTransform(-36.0688, 116.8);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(-43.2179, 116.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_13.setTransform(-50.3029, 116.775);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgMIAMAAIgDAMg");
    this.shape_14.setTransform(-54.975, 115.5);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_15.setTransform(-57.9821, 115.85);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgDQAEAAACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHAEQgHADgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_16.setTransform(-64.1188, 116.8);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_17.setTransform(-68.7821, 115.85);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAGABADQABAFAJABQALAAAGgLQAEgGACgIIAHgiIAMAAIgPBDIgLAAIADgKIgHAGQgHAGgJAAQgPAAgDgKg",
      );
    this.shape_18.setTransform(-74.5375, 116.85);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_19.setTransform(-82.3137, 118.025);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_20.setTransform(-91.0429, 116.675);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_21.setTransform(-99.9529, 116.775);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgjAnQgMgNAGgaQAEgUAOgOQAPgOAUAAQARAAAIAJQAIAKgBALIgNAAQAAgJgFgFQgFgFgLAAQgNAAgLAKQgKAJgFATQgDARAGAKQAFAKAPAAQANAAAKgLQAFgFAEgKIAMAAQgFAPgLAKQgOAMgSAAQgQAAgJgKg",
      );
    this.shape_22.setTransform(-107.7632, 115.475);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAGgFAHAAIACAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_23.setTransform(5.55, 100.875);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_24.setTransform(-0.6529, 100.975);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_25.setTransform(-5.4821, 100.05);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgJQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHAAQgGABgEACQgFADgCAGQgBAGADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_26.setTransform(-11.6188, 101);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgeAsQgHgFABgKIAMAAQAAAEACADQADADAIAAQAMAAAGgJQAEgGADgNQgFAFgFADQgFACgHAAQgMAAgGgIQgHgIAEgRQAEgRAKgKQAKgJALAAQAIAAAFAEIAGAGIABgJIALAAIgNA9QgDAOgFAHQgKAOgTAAQgLAAgGgFgAgMgbQgDAGgCAKQgDALAEAFQADAHAIAAQALAAAIgLQAEgGABgJQADgMgEgGQgEgGgIAAQgLAAgHALg",
      );
    this.shape_27.setTransform(-18.8067, 102.35);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_28.setTransform(-23.325, 99.7);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_29.setTransform(-26.3321, 100.05);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_30.setTransform(-31.9923, 100.975);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_31.setTransform(-38.7792, 101);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p("AgUAiIgLhDIAOAAIAGA3IAeg3IAMAAIgmBDg");
    this.shape_32.setTransform(-44.9, 100.95);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_33.setTransform(-52.6179, 100.875);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics.f("#949EA7").s().p("AgPAuIAShcIANAAIgTBcg");
    this.shape_34.setTransform(-57.425, 99.7);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_35.setTransform(-66.8792, 101);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics.f("#949EA7").s().p("AgPAuIAThcIAMAAIgTBcg");
    this.shape_36.setTransform(-71.575, 99.7);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_37.setTransform(-77.3137, 102.225);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_38.setTransform(-81.625, 99.7);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgGgDgEQgCgFgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgKg",
      );
    this.shape_39.setTransform(-86.485, 100.95);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_40.setTransform(-93.6179, 100.875);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_41.setTransform(-98.175, 99.7);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgCgBIgCAAQgIAAgGAGQgFAFgBAIIgIAmg",
      );
    this.shape_42.setTransform(-101.65, 100.875);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAuIAUhcIApAAQAMAAAGAIQAGAGgCANQgDALgIAIQgJAHgOAAIgcAAIgJAngAgSgCIAYAAQAJgBAGgDQAGgEACgJQACgKgHgEQgEgCgHAAIgYAAg",
      );
    this.shape_43.setTransform(-108.2132, 99.7);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p("AAoAHIAAgNIAOAAIAAANgAgGAHIAAgNIANAAIAAANgAg1AHIAAgNIAPAAIAAANg");
    this.shape_44.setTransform(33.775, 54);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFABIACAAIAGgBIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgDAGQgEAGgMABg",
      );
    this.shape_45.setTransform(23.3, 52.6);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_46.setTransform(17.875, 51);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_47.setTransform(13.15, 50.125);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgDQAGgEgBgGQAAgEgDgDIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgJAAQgHAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_48.setTransform(7.8, 51.15);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_49.setTransform(2.725, 49.725);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgHgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_50.setTransform(-4.625, 51);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_51.setTransform(-14.375, 51.125);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_52.setTransform(-22.075, 49.7);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_53.setTransform(-29.425, 51.075);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_54.setTransform(-40.3, 51.15);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAGABADQADAHAJgBQAMAAAEgLQACgGABgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgPAAgFgLg",
      );
    this.shape_55.setTransform(-47.75, 51.2);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_56.setTransform(-55.5, 51.1);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgHgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_57.setTransform(-65.125, 51);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_58.setTransform(-74.9, 51.1);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_59.setTransform(-82.575, 51);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_60.setTransform(-90.4, 51.1);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_61.setTransform(-96.2, 50.125);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_62.setTransform(-102, 51.2);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_63.setTransform(-109.525, 51.125);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_64.setTransform(78.175, 32.85);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_65.setTransform(72.3, 34.3);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_66.setTransform(60.775, 34.2);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_67.setTransform(52.95, 34.3);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_68.setTransform(47.575, 32.925);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgJgDQgKgCgEgCQgJgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_69.setTransform(42.55, 34.35);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_70.setTransform(37.475, 32.925);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_71.setTransform(32.425, 34.3);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_72.setTransform(23.175, 34.2);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_73.setTransform(16.525, 34.325);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_74.setTransform(8.575, 33.025);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_75.setTransform(1.225, 34.325);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_76.setTransform(-6.75, 34.3);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_77.setTransform(-12.475, 34.2);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_78.setTransform(-18.925, 33.025);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_79.setTransform(-30.525, 34.325);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_80.setTransform(-42.275, 34.2);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_81.setTransform(-47.725, 32.925);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_82.setTransform(-57.025, 34.325);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_83.setTransform(-64.325, 34.275);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_84.setTransform(-71.775, 34.325);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_85.setTransform(-77.175, 32.925);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAFQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_86.setTransform(-82.425, 35.65);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_87.setTransform(-94.225, 34.325);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_88.setTransform(-101.925, 34.2);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgIALgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgEgHQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_89.setTransform(-109.75, 34.3);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_90.setTransform(95.95, 17.55);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_91.setTransform(90.875, 16.125);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_92.setTransform(81.375, 16.225);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_93.setTransform(76.2, 16.125);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_94.setTransform(70.925, 17.525);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_95.setTransform(64.975, 17.4);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_96.setTransform(58.325, 17.525);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAApIgLAAIAAguQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAvg",
      );
    this.shape_97.setTransform(48.675, 17.4);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_98.setTransform(38.45, 16.125);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_99.setTransform(27.775, 20.4);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_100.setTransform(21.725, 16.225);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_101.setTransform(16.55, 16.125);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_102.setTransform(13.075, 17.4);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJAMQgIALgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_103.setTransform(6.4, 17.5);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhHIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBHg");
    this.shape_104.setTransform(-2.5, 17.5);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_105.setTransform(-12.9, 16.125);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_106.setTransform(-18.175, 17.525);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_107.setTransform(-26.125, 17.525);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_108.setTransform(-31.875, 17.4);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_109.setTransform(-42.375, 17.525);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_110.setTransform(-50.075, 16.1);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_111.setTransform(-55.95, 16.525);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_112.setTransform(-65.525, 17.4);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_113.setTransform(-70.975, 16.125);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgFgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_114.setTransform(-79.85, 17.55);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_115.setTransform(-87.5, 18.975);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_116.setTransform(-94.975, 17.4);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_117.setTransform(-100.425, 16.125);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_118.setTransform(-105.825, 16.1);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_119.setTransform(-111.7, 16.525);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_120.setTransform(90.85, 0.7);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_121.setTransform(82.925, -0.575);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFABIADAAIAEgBIADgDIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAHQgDAFgLABg",
      );
    this.shape_122.setTransform(71.95, 2.2);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_123.setTransform(66.9, -0.675);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_124.setTransform(63.8, -0.675);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_125.setTransform(58.525, 0.725);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMAAAEgLQACgGABgKIAAgkIAMAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_126.setTransform(50.55, 0.8);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_127.setTransform(44.75, -0.275);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_128.setTransform(39.425, 0.675);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_129.setTransform(32.175, 0.725);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_130.setTransform(20.35, 0.7);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_131.setTransform(14.55, -0.275);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_132.setTransform(7.05, -0.675);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p("AAeAyIgKgeIgnAAIgLAeIgOAAIAmhjIAOAAIAlBjgAAPAJIgPgrIgPArIAeAAg");
    this.shape_133.setTransform(0.375, -0.675);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_134.setTransform(-10.9, 0.75);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_135.setTransform(-18.325, 0.725);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_136.setTransform(-23.7, -0.675);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_137.setTransform(-28.975, -0.575);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_138.setTransform(-36.725, 0.725);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_139.setTransform(-44.625, 0.6);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_140.setTransform(-52.425, 0.725);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_141.setTransform(-64.025, 0.725);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_142.setTransform(-71.325, 0.675);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_143.setTransform(-78.575, 0.725);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_144.setTransform(-84.525, -0.75);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_145.setTransform(-88.375, 0.6);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_146.setTransform(-95.025, 0.725);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_147.setTransform(-100.85, -0.275);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_148.setTransform(-106.575, 0.6);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_149.setTransform(-112.025, -0.675);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_150.setTransform(106.175, -16.125);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_151.setTransform(101.075, -17.475);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_152.setTransform(97.55, -17.075);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_153.setTransform(91.975, -16.075);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_154.setTransform(82.125, -16.2);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_155.setTransform(70.475, -16.2);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_156.setTransform(60.925, -16.075);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_157.setTransform(54.975, -16.2);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_158.setTransform(48.1, -14.625);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgIALgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgEgHQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_159.setTransform(40.55, -16.1);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_160.setTransform(34.825, -16.2);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_161.setTransform(28.375, -14.75);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_162.setTransform(16.775, -16.075);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_163.setTransform(5.025, -17.5);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_164.setTransform(-3, -14.625);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_165.setTransform(-10.55, -16);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_166.setTransform(-18.3, -16.1);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_167.setTransform(-25.975, -17.5);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_168.setTransform(-31.85, -17.075);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgCgDQgEgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_169.setTransform(-41.05, -16.05);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_170.setTransform(-46.55, -17.075);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_171.setTransform(-52.275, -16.2);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_172.setTransform(-60.075, -16.075);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_173.setTransform(-69.725, -16.2);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_174.setTransform(-77.125, -17.475);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_175.setTransform(-80.575, -16.2);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_176.setTransform(-87.225, -16.075);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_177.setTransform(-94.775, -14.75);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgPAAIAZglIgYgjIAPAAIAQAZIARgZIAQAAIgaAjIAaAlg");
    this.shape_178.setTransform(-102.35, -16.1);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_179.setTransform(-109.725, -16.075);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgLAeQgLAcgEAHQgEAFgKAAg",
      );
    this.shape_180.setTransform(92.1, -31.4);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_181.setTransform(86.675, -34.35);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_182.setTransform(83.175, -34.275);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_183.setTransform(78.175, -32.925);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_184.setTransform(70.725, -32.875);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_185.setTransform(63.175, -31.55);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_186.setTransform(55.65, -32.85);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_187.setTransform(44.35, -32.9);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_188.setTransform(38.55, -33.875);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_189.setTransform(28.925, -32.875);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_190.setTransform(23.55, -34.275);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_191.setTransform(18.275, -34.175);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_192.setTransform(10.525, -32.875);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgIgFgBgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_193.setTransform(-1.5, -31.425);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_194.setTransform(-8.975, -33);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_195.setTransform(-14.425, -34.275);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_196.setTransform(-19.875, -32.875);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_197.setTransform(-27.425, -34.175);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_198.setTransform(-39.425, -34.175);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_199.setTransform(-46.925, -33);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p("AAeAyIgKgeIgnAAIgLAeIgOAAIAmhjIAOAAIAlBjgAAPAJIgPgrIgPArIAeAAg");
    this.shape_200.setTransform(-55.425, -34.275);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_201.setTransform(-65.125, -30);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_202.setTransform(-70.925, -34.3);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_203.setTransform(-78.95, -31.425);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQAAAGABADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgHAFgJAAQgQAAgFgKg",
      );
    this.shape_204.setTransform(-86.5, -32.8);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_205.setTransform(-94.25, -32.9);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_206.setTransform(-101.925, -33);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_207.setTransform(-109.725, -32.875);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_208.setTransform(115.2, -50.675);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_209.setTransform(109.4, -49.7);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_210.setTransform(101.725, -49.8);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_211.setTransform(90.5, -49.65);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_212.setTransform(85.425, -51.075);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_213.setTransform(75.925, -50.975);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_214.setTransform(68.375, -49.675);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_215.setTransform(60.675, -51.1);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_216.setTransform(53.3, -49.65);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_217.setTransform(48.225, -51.075);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_218.setTransform(45.15, -51.075);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_219.setTransform(39.875, -50.975);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAGABADQADAHAJgBQAMAAAEgLQACgGABgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgPAAgFgLg",
      );
    this.shape_220.setTransform(31.9, -49.6);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_221.setTransform(24.375, -48.35);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_222.setTransform(12.575, -49.675);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_223.setTransform(6.825, -49.8);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_224.setTransform(0.375, -49.675);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_225.setTransform(-9.5, -50.675);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_226.setTransform(-15.075, -49.675);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_227.setTransform(-22.975, -51.1);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_228.setTransform(-28.85, -50.675);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_229.setTransform(-38.05, -49.65);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_230.setTransform(-45.475, -49.675);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_231.setTransform(-53.175, -49.8);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_232.setTransform(-61, -49.7);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_233.setTransform(-72.575, -49.675);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_234.setTransform(-80.275, -51.1);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_235.setTransform(-86.15, -50.675);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_236.setTransform(-93.85, -50.675);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_237.setTransform(-99.2, -49.65);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAGABADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgIAFgIABQgPAAgGgLg",
      );
    this.shape_238.setTransform(-106.65, -49.6);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDAAIAAgLQAIAAACgCQABgBAAgGIAAhSIAMAAIAABUQAAAIgDAEQgEAGgLAAgAAAgxIAAgPIAMAAIAAAPg",
      );
    this.shape_239.setTransform(-112.6, -49.6);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_240.setTransform(103.375, -66.475);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgDQAFgCABgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_241.setTransform(96.05, -66.45);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAGABADQADAHAJAAQAMAAAEgMQACgGABgKIAAgjIAMAAIAABIIgMAAIABgMQgDAFgEACQgGAHgKAAQgPAAgFgLg",
      );
    this.shape_242.setTransform(88.6, -66.4);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_243.setTransform(81.075, -66.475);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_244.setTransform(73.575, -66.525);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_245.setTransform(66.125, -66.475);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_246.setTransform(58.575, -67.775);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAGgCABgGIAAgFIAAAAIAAgBIgHAAIAAgPIAPAAIAAAOQgBAHgDAGQgDAHgIABg",
      );
    this.shape_247.setTransform(48.75, -62.55);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgQAAQgPAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_248.setTransform(42.9, -66.5);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgIALgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgEgHQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_249.setTransform(35.15, -66.5);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_250.setTransform(29.35, -67.475);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQAEgCACgGIABgFIAAAAIgBgBIgGAAIAAgPIANAAIAAAOQAAAHgDAGQgEAHgGABg",
      );
    this.shape_251.setTransform(21.7, -62.55);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgDQAGgCAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_252.setTransform(16.3, -66.45);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_253.setTransform(10.8, -67.475);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_254.setTransform(5.075, -66.6);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_255.setTransform(-2.725, -66.475);

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_256.setTransform(-12.375, -66.6);

    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_257.setTransform(-19.775, -67.875);

    this.shape_258 = new cjs.Shape();
    this.shape_258.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_258.setTransform(-23.225, -66.6);

    this.shape_259 = new cjs.Shape();
    this.shape_259.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_259.setTransform(-29.875, -66.475);

    this.shape_260 = new cjs.Shape();
    this.shape_260.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_260.setTransform(-37.425, -65.15);

    this.shape_261 = new cjs.Shape();
    this.shape_261.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgPAAIAZglIgYgjIAQAAIAQAZIAQgZIAPAAIgZAjIAaAlg");
    this.shape_261.setTransform(-45, -66.5);

    this.shape_262 = new cjs.Shape();
    this.shape_262.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_262.setTransform(-52.375, -66.475);

    this.shape_263 = new cjs.Shape();
    this.shape_263.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_263.setTransform(-61.6, -67.875);

    this.shape_264 = new cjs.Shape();
    this.shape_264.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_264.setTransform(-66.875, -66.475);

    this.shape_265 = new cjs.Shape();
    this.shape_265.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_265.setTransform(-74.775, -66.6);

    this.shape_266 = new cjs.Shape();
    this.shape_266.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_266.setTransform(-80.225, -67.875);

    this.shape_267 = new cjs.Shape();
    this.shape_267.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_267.setTransform(-85.9, -65.025);

    this.shape_268 = new cjs.Shape();
    this.shape_268.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_268.setTransform(-91.425, -66.6);

    this.shape_269 = new cjs.Shape();
    this.shape_269.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_269.setTransform(-97.875, -66.475);

    this.shape_270 = new cjs.Shape();
    this.shape_270.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_270.setTransform(-107.725, -66.6);

    this.shape_271 = new cjs.Shape();
    this.shape_271.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_271.setTransform(113.875, -84.575);

    this.shape_272 = new cjs.Shape();
    this.shape_272.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_272.setTransform(106.375, -83.4);

    this.shape_273 = new cjs.Shape();
    this.shape_273.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_273.setTransform(98.775, -83.275);

    this.shape_274 = new cjs.Shape();
    this.shape_274.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_274.setTransform(87.4, -83.25);

    this.shape_275 = new cjs.Shape();
    this.shape_275.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_275.setTransform(81.9, -84.275);

    this.shape_276 = new cjs.Shape();
    this.shape_276.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_276.setTransform(76.175, -83.4);

    this.shape_277 = new cjs.Shape();
    this.shape_277.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_277.setTransform(68.375, -83.275);

    this.shape_278 = new cjs.Shape();
    this.shape_278.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAApIgLAAIAAguQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAvg",
      );
    this.shape_278.setTransform(58.725, -83.4);

    this.shape_279 = new cjs.Shape();
    this.shape_279.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_279.setTransform(51.325, -84.675);

    this.shape_280 = new cjs.Shape();
    this.shape_280.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_280.setTransform(47.875, -83.4);

    this.shape_281 = new cjs.Shape();
    this.shape_281.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_281.setTransform(41.225, -83.275);

    this.shape_282 = new cjs.Shape();
    this.shape_282.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_282.setTransform(33.675, -81.95);

    this.shape_283 = new cjs.Shape();
    this.shape_283.graphics
      .f("#31353B")
      .s()
      .p("AARAkIgRgbIgRAbIgPAAIAZgkIgYgjIAQAAIAQAZIAQgZIAPAAIgZAjIAaAkg");
    this.shape_283.setTransform(26.1, -83.3);

    this.shape_284 = new cjs.Shape();
    this.shape_284.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_284.setTransform(18.725, -83.275);

    this.shape_285 = new cjs.Shape();
    this.shape_285.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_285.setTransform(6.925, -84.575);

    this.shape_286 = new cjs.Shape();
    this.shape_286.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_286.setTransform(-0.625, -83.275);

    this.shape_287 = new cjs.Shape();
    this.shape_287.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_287.setTransform(-6, -84.675);

    this.shape_288 = new cjs.Shape();
    this.shape_288.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_288.setTransform(-9.125, -84.675);

    this.shape_289 = new cjs.Shape();
    this.shape_289.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_289.setTransform(-14.375, -83.275);

    this.shape_290 = new cjs.Shape();
    this.shape_290.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_290.setTransform(-20.325, -84.75);

    this.shape_291 = new cjs.Shape();
    this.shape_291.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_291.setTransform(-30.025, -83.275);

    this.shape_292 = new cjs.Shape();
    this.shape_292.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_292.setTransform(-37.725, -84.7);

    this.shape_293 = new cjs.Shape();
    this.shape_293.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_293.setTransform(-43.6, -84.275);

    this.shape_294 = new cjs.Shape();
    this.shape_294.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_294.setTransform(-51.225, -84.75);

    this.shape_295 = new cjs.Shape();
    this.shape_295.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_295.setTransform(-57.1, -83.3);

    this.shape_296 = new cjs.Shape();
    this.shape_296.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_296.setTransform(-66.3, -84.675);

    this.shape_297 = new cjs.Shape();
    this.shape_297.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_297.setTransform(-69.4, -84.675);

    this.shape_298 = new cjs.Shape();
    this.shape_298.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_298.setTransform(-74.675, -83.275);

    this.shape_299 = new cjs.Shape();
    this.shape_299.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_299.setTransform(-86.675, -84.575);

    this.shape_300 = new cjs.Shape();
    this.shape_300.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_300.setTransform(-94.225, -83.275);

    this.shape_301 = new cjs.Shape();
    this.shape_301.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_301.setTransform(-101.975, -83.275);

    this.shape_302 = new cjs.Shape();
    this.shape_302.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_302.setTransform(-109.675, -83.4);

    this.shape_303 = new cjs.Shape();
    this.shape_303.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFABIACAAIAGgBIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgDAGQgEAGgMABg",
      );
    this.shape_303.setTransform(106.2, -98.6);

    this.shape_304 = new cjs.Shape();
    this.shape_304.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_304.setTransform(101.15, -101.475);

    this.shape_305 = new cjs.Shape();
    this.shape_305.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_305.setTransform(98.05, -101.475);

    this.shape_306 = new cjs.Shape();
    this.shape_306.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_306.setTransform(92.775, -100.075);

    this.shape_307 = new cjs.Shape();
    this.shape_307.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_307.setTransform(84.825, -100.075);

    this.shape_308 = new cjs.Shape();
    this.shape_308.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_308.setTransform(79.075, -100.2);

    this.shape_309 = new cjs.Shape();
    this.shape_309.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_309.setTransform(68.55, -100);

    this.shape_310 = new cjs.Shape();
    this.shape_310.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_310.setTransform(60.8, -100.1);

    this.shape_311 = new cjs.Shape();
    this.shape_311.graphics
      .f("#31353B")
      .s()
      .p("AgGAyIAAgoIgmg7IAQAAIAcAwIAdgwIAQAAIgmA7IAAAog");
    this.shape_311.setTransform(53.725, -101.475);

    this.shape_312 = new cjs.Shape();
    this.shape_312.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_312.setTransform(43.425, -97.2);

    this.shape_313 = new cjs.Shape();
    this.shape_313.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgLAAQgBgFgDgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_313.setTransform(38, -100.05);

    this.shape_314 = new cjs.Shape();
    this.shape_314.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_314.setTransform(32.95, -101.475);

    this.shape_315 = new cjs.Shape();
    this.shape_315.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_315.setTransform(27.475, -100.075);

    this.shape_316 = new cjs.Shape();
    this.shape_316.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_316.setTransform(19.525, -101.375);

    this.shape_317 = new cjs.Shape();
    this.shape_317.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_317.setTransform(11.95, -100.1);

    this.shape_318 = new cjs.Shape();
    this.shape_318.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_318.setTransform(2.325, -100.2);

    this.shape_319 = new cjs.Shape();
    this.shape_319.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGAAgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_319.setTransform(-11.5, -98.625);

    this.shape_320 = new cjs.Shape();
    this.shape_320.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_320.setTransform(-18.975, -100.2);

    this.shape_321 = new cjs.Shape();
    this.shape_321.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_321.setTransform(-24.425, -101.475);

    this.shape_322 = new cjs.Shape();
    this.shape_322.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_322.setTransform(-29.825, -100.2);

    this.shape_323 = new cjs.Shape();
    this.shape_323.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_323.setTransform(-35.625, -100.2);

    this.shape_324 = new cjs.Shape();
    this.shape_324.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_324.setTransform(-42.075, -100.075);

    this.shape_325 = new cjs.Shape();
    this.shape_325.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_325.setTransform(-50.025, -100.075);

    this.shape_326 = new cjs.Shape();
    this.shape_326.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_326.setTransform(-55.4, -101.475);

    this.shape_327 = new cjs.Shape();
    this.shape_327.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_327.setTransform(-64.725, -100.075);

    this.shape_328 = new cjs.Shape();
    this.shape_328.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_328.setTransform(-72.425, -100.2);

    this.shape_329 = new cjs.Shape();
    this.shape_329.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_329.setTransform(-77.875, -101.475);

    this.shape_330 = new cjs.Shape();
    this.shape_330.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_330.setTransform(-83.275, -101.5);

    this.shape_331 = new cjs.Shape();
    this.shape_331.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_331.setTransform(-90.625, -100.125);

    this.shape_332 = new cjs.Shape();
    this.shape_332.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_332.setTransform(-97.875, -100.075);

    this.shape_333 = new cjs.Shape();
    this.shape_333.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_333.setTransform(-107.725, -100.2);

    this.shape_334 = new cjs.Shape();
    this.shape_334.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_334.setTransform(106.925, -118.175);

    this.shape_335 = new cjs.Shape();
    this.shape_335.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_335.setTransform(101.75, -118.275);

    this.shape_336 = new cjs.Shape();
    this.shape_336.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_336.setTransform(98.625, -118.275);

    this.shape_337 = new cjs.Shape();
    this.shape_337.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAGABADQAEAHAIAAQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgPAAgGgLg",
      );
    this.shape_337.setTransform(93.15, -116.8);

    this.shape_338 = new cjs.Shape();
    this.shape_338.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_338.setTransform(85.625, -118.175);

    this.shape_339 = new cjs.Shape();
    this.shape_339.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_339.setTransform(73.8, -116.9);

    this.shape_340 = new cjs.Shape();
    this.shape_340.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_340.setTransform(68, -117.875);

    this.shape_341 = new cjs.Shape();
    this.shape_341.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_341.setTransform(58.375, -116.875);

    this.shape_342 = new cjs.Shape();
    this.shape_342.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_342.setTransform(53, -118.275);

    this.shape_343 = new cjs.Shape();
    this.shape_343.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_343.setTransform(47.725, -115.55);

    this.shape_344 = new cjs.Shape();
    this.shape_344.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_344.setTransform(39.75, -116.9);

    this.shape_345 = new cjs.Shape();
    this.shape_345.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_345.setTransform(32.025, -116.875);

    this.shape_346 = new cjs.Shape();
    this.shape_346.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_346.setTransform(24.475, -115.55);

    this.shape_347 = new cjs.Shape();
    this.shape_347.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgDgDQgFgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_347.setTransform(13.1, -116.85);

    this.shape_348 = new cjs.Shape();
    this.shape_348.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_348.setTransform(5.675, -116.875);

    this.shape_349 = new cjs.Shape();
    this.shape_349.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_349.setTransform(0.3, -118.275);

    this.shape_350 = new cjs.Shape();
    this.shape_350.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_350.setTransform(-4.975, -118.175);

    this.shape_351 = new cjs.Shape();
    this.shape_351.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_351.setTransform(-12.725, -116.875);

    this.shape_352 = new cjs.Shape();
    this.shape_352.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_352.setTransform(-20.625, -117);

    this.shape_353 = new cjs.Shape();
    this.shape_353.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_353.setTransform(-28.425, -116.875);

    this.shape_354 = new cjs.Shape();
    this.shape_354.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_354.setTransform(-40.025, -116.875);

    this.shape_355 = new cjs.Shape();
    this.shape_355.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_355.setTransform(-45.775, -117);

    this.shape_356 = new cjs.Shape();
    this.shape_356.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAGACADQADAHAJAAQALAAAFgMQADgGAAgKIAAgjIAMAAIAABIIgMAAIABgMQgDAFgEACQgHAHgJAAQgOAAgGgLg",
      );
    this.shape_356.setTransform(-52.45, -116.8);

    this.shape_357 = new cjs.Shape();
    this.shape_357.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_357.setTransform(-58.25, -117.875);

    this.shape_358 = new cjs.Shape();
    this.shape_358.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_358.setTransform(-63.825, -115.55);

    this.shape_359 = new cjs.Shape();
    this.shape_359.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_359.setTransform(-71.575, -116.875);

    this.shape_360 = new cjs.Shape();
    this.shape_360.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_360.setTransform(-79.075, -116.925);

    this.shape_361 = new cjs.Shape();
    this.shape_361.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_361.setTransform(-90.175, -116.875);

    this.shape_362 = new cjs.Shape();
    this.shape_362.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_362.setTransform(-96.2, -117.875);

    this.shape_363 = new cjs.Shape();
    this.shape_363.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_363.setTransform(-101.775, -116.875);

    this.shape_364 = new cjs.Shape();
    this.shape_364.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_364.setTransform(-109.925, -118.175);

    this.shape_365 = new cjs.Shape();
    this.shape_365.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_365.setTransform(93.075, -133.675);

    this.shape_366 = new cjs.Shape();
    this.shape_366.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_366.setTransform(85.725, -133.7);

    this.shape_367 = new cjs.Shape();
    this.shape_367.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_367.setTransform(80.675, -135.075);

    this.shape_368 = new cjs.Shape();
    this.shape_368.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAGALABQAHAAAFgEQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgDgDQgFgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_368.setTransform(75.65, -133.65);

    this.shape_369 = new cjs.Shape();
    this.shape_369.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_369.setTransform(68.275, -133.8);

    this.shape_370 = new cjs.Shape();
    this.shape_370.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_370.setTransform(60.475, -133.675);

    this.shape_371 = new cjs.Shape();
    this.shape_371.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_371.setTransform(52.775, -135.1);

    this.shape_372 = new cjs.Shape();
    this.shape_372.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_372.setTransform(44.975, -133.675);

    this.shape_373 = new cjs.Shape();
    this.shape_373.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_373.setTransform(39.225, -133.8);

    this.shape_374 = new cjs.Shape();
    this.shape_374.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_374.setTransform(32.775, -132.35);

    this.shape_375 = new cjs.Shape();
    this.shape_375.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAApIgLAAIAAguQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAvg",
      );
    this.shape_375.setTransform(22.925, -133.8);

    this.shape_376 = new cjs.Shape();
    this.shape_376.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_376.setTransform(13.15, -133.7);

    this.shape_377 = new cjs.Shape();
    this.shape_377.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_377.setTransform(5.875, -133.725);

    this.shape_378 = new cjs.Shape();
    this.shape_378.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgEgDQgDgFgKgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_378.setTransform(-5, -133.65);

    this.shape_379 = new cjs.Shape();
    this.shape_379.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQABgDABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_379.setTransform(-9.45, -138.325);

    this.shape_380 = new cjs.Shape();
    this.shape_380.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_380.setTransform(-14.1, -135.075);

    this.shape_381 = new cjs.Shape();
    this.shape_381.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAqQgQgOAAgcQAAgWAMgOQANgQAUAAQAUAAAJAKQALAKABANIgNAAQgCgKgHgFQgHgGgMAAQgNAAgJAKQgJALAAAUQAAASAIALQAJALAOAAQAPAAAIgMQAEgGACgKIANAAQgCAQgJALQgMANgVAAQgPAAgMgLg",
      );
    this.shape_381.setTransform(-23.45, -135.075);

    this.shape_382 = new cjs.Shape();
    this.shape_382.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_382.setTransform(-32.85, -135.075);

    this.shape_383 = new cjs.Shape();
    this.shape_383.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_383.setTransform(-45.525, -133.675);

    this.shape_384 = new cjs.Shape();
    this.shape_384.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_384.setTransform(-53.225, -135.1);

    this.shape_385 = new cjs.Shape();
    this.shape_385.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_385.setTransform(-59.1, -134.675);

    this.shape_386 = new cjs.Shape();
    this.shape_386.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFADACQAEAFAIAAQAOAAAEgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgIgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgEAMg",
      );
    this.shape_386.setTransform(-68.95, -132.225);

    this.shape_387 = new cjs.Shape();
    this.shape_387.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_387.setTransform(-76.425, -133.8);

    this.shape_388 = new cjs.Shape();
    this.shape_388.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_388.setTransform(-81.875, -135.075);

    this.shape_389 = new cjs.Shape();
    this.shape_389.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_389.setTransform(-86.925, -133.7);

    this.shape_390 = new cjs.Shape();
    this.shape_390.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_390.setTransform(-94.125, -133.675);

    this.shape_391 = new cjs.Shape();
    this.shape_391.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AV49EMAAAA6JMgrvAAAMAAAg6Jg");
    this.shape_391.setTransform(0, 0.016, 1.0643, 1.0323);

    this.shape_392 = new cjs.Shape();
    this.shape_392.graphics.f("#FFFFFF").s().p("A13dFMAAAg6JMArvAAAMAAAA6Jg");
    this.shape_392.setTransform(0, 0.016, 1.0643, 1.0323);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_392 },
            { t: this.shape_391 },
            { t: this.shape_390 },
            { t: this.shape_389 },
            { t: this.shape_388 },
            { t: this.shape_387 },
            { t: this.shape_386 },
            { t: this.shape_385 },
            { t: this.shape_384 },
            { t: this.shape_383 },
            { t: this.shape_382 },
            { t: this.shape_381 },
            { t: this.shape_380 },
            { t: this.shape_379 },
            { t: this.shape_378 },
            { t: this.shape_377 },
            { t: this.shape_376 },
            { t: this.shape_375 },
            { t: this.shape_374 },
            { t: this.shape_373 },
            { t: this.shape_372 },
            { t: this.shape_371 },
            { t: this.shape_370 },
            { t: this.shape_369 },
            { t: this.shape_368 },
            { t: this.shape_367 },
            { t: this.shape_366 },
            { t: this.shape_365 },
            { t: this.shape_364 },
            { t: this.shape_363 },
            { t: this.shape_362 },
            { t: this.shape_361 },
            { t: this.shape_360 },
            { t: this.shape_359 },
            { t: this.shape_358 },
            { t: this.shape_357 },
            { t: this.shape_356 },
            { t: this.shape_355 },
            { t: this.shape_354 },
            { t: this.shape_353 },
            { t: this.shape_352 },
            { t: this.shape_351 },
            { t: this.shape_350 },
            { t: this.shape_349 },
            { t: this.shape_348 },
            { t: this.shape_347 },
            { t: this.shape_346 },
            { t: this.shape_345 },
            { t: this.shape_344 },
            { t: this.shape_343 },
            { t: this.shape_342 },
            { t: this.shape_341 },
            { t: this.shape_340 },
            { t: this.shape_339 },
            { t: this.shape_338 },
            { t: this.shape_337 },
            { t: this.shape_336 },
            { t: this.shape_335 },
            { t: this.shape_334 },
            { t: this.shape_333 },
            { t: this.shape_332 },
            { t: this.shape_331 },
            { t: this.shape_330 },
            { t: this.shape_329 },
            { t: this.shape_328 },
            { t: this.shape_327 },
            { t: this.shape_326 },
            { t: this.shape_325 },
            { t: this.shape_324 },
            { t: this.shape_323 },
            { t: this.shape_322 },
            { t: this.shape_321 },
            { t: this.shape_320 },
            { t: this.shape_319 },
            { t: this.shape_318 },
            { t: this.shape_317 },
            { t: this.shape_316 },
            { t: this.shape_315 },
            { t: this.shape_314 },
            { t: this.shape_313 },
            { t: this.shape_312 },
            { t: this.shape_311 },
            { t: this.shape_310 },
            { t: this.shape_309 },
            { t: this.shape_308 },
            { t: this.shape_307 },
            { t: this.shape_306 },
            { t: this.shape_305 },
            { t: this.shape_304 },
            { t: this.shape_303 },
            { t: this.shape_302 },
            { t: this.shape_301 },
            { t: this.shape_300 },
            { t: this.shape_299 },
            { t: this.shape_298 },
            { t: this.shape_297 },
            { t: this.shape_296 },
            { t: this.shape_295 },
            { t: this.shape_294 },
            { t: this.shape_293 },
            { t: this.shape_292 },
            { t: this.shape_291 },
            { t: this.shape_290 },
            { t: this.shape_289 },
            { t: this.shape_288 },
            { t: this.shape_287 },
            { t: this.shape_286 },
            { t: this.shape_285 },
            { t: this.shape_284 },
            { t: this.shape_283 },
            { t: this.shape_282 },
            { t: this.shape_281 },
            { t: this.shape_280 },
            { t: this.shape_279 },
            { t: this.shape_278 },
            { t: this.shape_277 },
            { t: this.shape_276 },
            { t: this.shape_275 },
            { t: this.shape_274 },
            { t: this.shape_273 },
            { t: this.shape_272 },
            { t: this.shape_271 },
            { t: this.shape_270 },
            { t: this.shape_269 },
            { t: this.shape_268 },
            { t: this.shape_267 },
            { t: this.shape_266 },
            { t: this.shape_265 },
            { t: this.shape_264 },
            { t: this.shape_263 },
            { t: this.shape_262 },
            { t: this.shape_261 },
            { t: this.shape_260 },
            { t: this.shape_259 },
            { t: this.shape_258 },
            { t: this.shape_257 },
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.instance_1 },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_393 = new cjs.Shape();
    this.shape_393.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_393.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_393).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote07testimonialDarpa01,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote06testimonialGSK02 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-98.725, -79.225);

    this.instance_1 = new lib.Logo_GSK();
    this.instance_1.setTransform(85.7, 142.8, 0.3553, 0.3553);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhbIAkAAQAUAAAHANQAHAMgEAUQgDAOgIAMQgPAUgXAAgAgcAkIAWAAIAKgBQAIgDAGgHQAFgGAEgJIADgJQADgRgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_1.setTransform(-16.912, 38.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AggAoQgFgIACgKQACgLAIgGQAFgFAMgGQgEgGgCgFQgBgFABgEQACgJAIgGQAGgFAKAAQAKgBAEAGQAFAFgCAIQgCAJgHAHIgNAJIANATIAEgIIADgHIAKAAQgDAKgFAIIgEAHIAAAAIAAAAIAMATIgPAAIgGgKIgLAIQgIAFgKgBQgOABgFgIgAgRAKQgFAGgCAGQgBAHAEAFQAFADAGAAQAHAAAFgCQAGgEADgEIgOgaQgLAHgDACgAAAghQgCADAAADQgBADABAFIAEAJIAKgIQAFgDABgGQABgEgCgDQgCgDgFAAQgHAAgDAEg",
      );
    this.shape_2.setTransform(-26.3536, 38.75);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AARAuIAAgCIABgIIACgQQACgIgGgEQgDgBgIAAIgcAAIgIAnIgNAAIAUhbIAqAAQALAAAGACQAMAGgDARQgCAIgFAFQgEAGgHACQAFACACAEQACADgCAJIgCAMIgBAHQAAAFADACIAAABgAgUgDIAcAAQAJAAAGgEQAFgDACgJQADgLgHgDQgDgCgHAAIgeAAg",
      );
    this.shape_3.setTransform(-34.794, 38.65);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgIALQAEgBADgGIACgEIAAgBIAAgBIgGAAIACgOIAOAAIgEANQgBAHgEAGQgEAFgIACg",
      );
    this.shape_4.setTransform(-45.9, 43.575);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_5.setTransform(-52.4429, 39.825);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgIAmg",
      );
    this.shape_6.setTransform(-59.45, 39.825);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAEQgDADgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHAEQgHADgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_7.setTransform(-65.8188, 39.95);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_8.setTransform(-72.9679, 38.625);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_9.setTransform(-80.4137, 41.175);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_10.setTransform(-87.2529, 39.925);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_11.setTransform(-91.925, 38.65);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAuIAUhbIAoAAQAQAAAEAJQADAGgBAHQgCAJgGAGIgJAGQAGACADACQAGAHgCAKQgCAJgIAIQgLALgRgBgAgaAkIAbAAQALgBAHgGQAEgFABgFQACgLgIgDQgFgCgIAAIgYAAgAgQgHIAVAAQAIAAAGgBQAHgEACgJQACgKgHgDQgDgBgJAAIgWAAg",
      );
    this.shape_12.setTransform(-97.9, 38.65);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_13.setTransform(-10.5, 24.025);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_14.setTransform(-16.7029, 24.125);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_15.setTransform(-21.5321, 23.2);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgHgDgDQgCgEgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_16.setTransform(-26.985, 24.1);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_17.setTransform(-33.9792, 24.15);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_18.setTransform(-39.3, 24.025);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_19.setTransform(-42.975, 22.85);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgLQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_20.setTransform(-49.262, 22.85);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACAAIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_21.setTransform(-58.9321, 23.2);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgHgDgDQgCgEgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_22.setTransform(-64.385, 24.1);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAFABADQABAHAJgBQALAAAGgKQAEgFACgKIAHghIAMAAIgPBDIgLAAIADgKIgHAHQgHAFgJAAQgPAAgDgKg",
      );
    this.shape_23.setTransform(-71.1875, 24.2);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AggAnQgGgKADgQQADgOAKgLQAKgKANAAQAIAAAFACIAFAIIAHgjIALAAIgTBdIgLAAIACgKQgFAGgFADQgGADgHAAQgMAAgGgJgAgNgGQgHAGgDANQgCAKADAIQADAHAKAAQAIAAAGgHQAGgGADgNQADgNgEgFQgEgHgIABQgHAAgHAGg",
      );
    this.shape_24.setTransform(-78.2113, 22.95);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_25.setTransform(-85.8029, 24.125);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_26.setTransform(-91.1, 24.025);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAvIAUhdIApAAQAMAAAGAHQAGAIgCAMQgDALgIAIQgJAHgOAAIgcAAIgJAogAgSgDIAYAAQAJAAAGgDQAGgEACgJQACgKgHgEQgEgCgHAAIgYAAg",
      );
    this.shape_27.setTransform(-97.6632, 22.85);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_28.setTransform(96.025, -22.85);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_29.setTransform(92.1, -26.725);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_30.setTransform(88.325, -25.85);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_31.setTransform(81.65, -25.75);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_32.setTransform(75.925, -27.2);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_33.setTransform(72.325, -27.2);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_34.setTransform(66.475, -25.725);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_35.setTransform(56.875, -27.2);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_36.setTransform(51, -25.75);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_37.setTransform(41.35, -26.725);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_38.setTransform(35.625, -25.85);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQAAAGABADQADAHAJgBQALABAFgMQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgHAGgJABQgQAAgFgLg",
      );
    this.shape_39.setTransform(27.8, -25.65);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_40.setTransform(20.05, -25.75);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACADACAEQAEgGAGgDQAFgDAHAAQAPABAFAKQADAGAAAKIAAAvg",
      );
    this.shape_41.setTransform(10.425, -25.85);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_42.setTransform(0.875, -25.725);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_43.setTransform(-10.925, -25.725);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_44.setTransform(-18.625, -27.15);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_45.setTransform(-24.5, -26.725);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_46.setTransform(-34.125, -25.725);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_47.setTransform(-39.95, -26.725);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_48.setTransform(-45.525, -25.725);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_49.setTransform(-51.125, -27.125);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_50.setTransform(-56.125, -25.775);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_51.setTransform(-63.575, -25.725);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_52.setTransform(-69.325, -25.85);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_53.setTransform(-75.775, -24.4);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_54.setTransform(-83.525, -24.4);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_55.setTransform(-91.275, -25.725);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_56.setTransform(-100.95, -27.125);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_57.setTransform(102.525, -39.65);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_58.setTransform(96.675, -42.525);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_59.setTransform(90.925, -42.65);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_60.setTransform(84.275, -42.525);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_61.setTransform(76.575, -43.95);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_62.setTransform(70.7, -43.525);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_63.setTransform(63.075, -42.65);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_64.setTransform(56.425, -42.525);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_65.setTransform(49.075, -42.55);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_66.setTransform(41.65, -42.55);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_67.setTransform(30.275, -43.825);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_68.setTransform(22.525, -42.525);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_69.setTransform(15, -43.925);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_70.setTransform(2.975, -42.525);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_71.setTransform(-4.725, -43.95);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_72.setTransform(-10.6, -43.525);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAHgLAAQgHAAgGgEIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFALAMAAQAIAAAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_73.setTransform(-20.025, -41.2);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAFABAEQADAGAJABQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgDACQgHAHgJgBQgQAAgFgKg",
      );
    this.shape_74.setTransform(-28, -42.45);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_75.setTransform(-39.8, -41.075);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_76.setTransform(-47.275, -42.65);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_77.setTransform(-52.725, -43.925);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_78.setTransform(-56.25, -43.525);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_79.setTransform(-60.1, -43.525);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(-65.875, -42.525);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgDgBgGQAAgFgDgCIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAGAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_81.setTransform(-73.2, -42.5);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_82.setTransform(-84.5, -42.55);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_83.setTransform(-90.3, -43.525);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_84.setTransform(-96.025, -42.65);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_85.setTransform(-101.475, -43.925);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_86.setTransform(82.075, -59.325);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_87.setTransform(74.375, -59.45);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_88.setTransform(66.55, -59.35);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAEAFAJAAQAOAAAEgKQACgGABgPQgEAFgFADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_89.setTransform(58.6, -57.875);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_90.setTransform(47.225, -59.325);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_91.setTransform(39.875, -59.35);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_92.setTransform(32.675, -59.325);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_93.setTransform(24.775, -60.75);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_94.setTransform(13.55, -59.3);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgMAdQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_95.setTransform(6.55, -57.85);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAFABAEQAEAGAIAAQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_96.setTransform(-0.9, -59.25);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_97.setTransform(-8.85, -57.875);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAFABAEQAEAGAIAAQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_98.setTransform(-20.25, -59.25);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_99.setTransform(-28, -59.35);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhKIANAAIATA7IAUg7IANAAIgLAhIgMAdQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_100.setTransform(-35.3, -57.85);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_101.setTransform(-44.65, -60.325);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_102.setTransform(-50.225, -59.325);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_103.setTransform(-58.125, -60.75);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_104.setTransform(-64, -60.325);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_105.setTransform(-71.25, -60.725);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_106.setTransform(-74.375, -60.725);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_107.setTransform(-79.625, -59.325);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_108.setTransform(-85.65, -60.325);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_109.setTransform(-91.425, -59.325);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_110.setTransform(-99.375, -60.625);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_111.setTransform(101.875, -77.425);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_112.setTransform(94.375, -76.25);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_113.setTransform(86.775, -76.125);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_114.setTransform(76.9, -77.125);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_115.setTransform(71.175, -77.55);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_116.setTransform(63.15, -74.675);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQADAHAJgBQALABAFgMQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgIAGgIABQgQAAgFgLg",
      );
    this.shape_117.setTransform(55.6, -76.05);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgPAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_118.setTransform(47.85, -76.15);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_119.setTransform(40.175, -77.55);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_120.setTransform(34.3, -77.125);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_121.setTransform(26.675, -77.6);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_122.setTransform(20.8, -76.15);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_123.setTransform(11.6, -77.525);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_124.setTransform(6.125, -76.125);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_125.setTransform(-1.225, -76.15);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_126.setTransform(-8.625, -76.125);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_127.setTransform(-14, -77.525);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_128.setTransform(-23.325, -76.125);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_129.setTransform(-31.025, -77.55);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_130.setTransform(-36.9, -77.125);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_131.setTransform(-46.725, -77.425);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_132.setTransform(-54.275, -76.125);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFACIADAAIAEgCIADgDIACgFIADgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgDAGQgFAHgKAAg",
      );
    this.shape_133.setTransform(-61.6, -74.65);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_134.setTransform(-69.05, -76.15);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDAAIAAgLQAIAAACgCQABgBAAgGIAAhSIAMAAIAABUQAAAHgDAEQgEAHgLAAgAAAgxIAAgPIAMAAIAAAPg",
      );
    this.shape_135.setTransform(-75, -76.05);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_136.setTransform(-79.825, -76.25);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_137.setTransform(-87.625, -76.125);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_140.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_140).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote06testimonialGSK02,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote05testimonialConsumergoods03 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-99.725, -109.475);

    this.instance_1 = new lib.Logo_ConsumerGoodsCompanyLogo();
    this.instance_1.setTransform(56.7, 99.05, 0.7684, 0.7684);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_1.setTransform(4.4321, 77.075);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_2.setTransform(-2.6529, 77.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_3.setTransform(-7.325, 75.9);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(-12.3923, 77.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_5.setTransform(-16.675, 75.9);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p("AgUAiIgLhDIAOAAIAGA2IAeg2IAMAAIgmBDg");
    this.shape_6.setTransform(-20.95, 77.15);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_7.setTransform(-26.025, 75.9);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhbIAkAAQAUAAAHANQAHAMgEAUQgDAOgIAMQgPAUgXAAgAgcAkIAWAAIAKgBQAIgDAGgHQAFgGAEgJIADgJQADgQgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_8.setTransform(-32.312, 75.9);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_9.setTransform(-44.3292, 77.2);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_10.setTransform(-49.65, 77.075);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgJQACgKAHgFQAHgEAKgBIASgDQAEAAACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgDQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_11.setTransform(-56.0188, 77.2);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgJg",
      );
    this.shape_12.setTransform(-62.535, 77.15);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_13.setTransform(-69.6679, 75.875);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-74.3821, 76.25);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f("#949EA7").s().p("AgPAuIAThbIAMAAIgTBbg");
    this.shape_15.setTransform(-77.825, 75.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgJQACgKAHgFQAHgEAKgBIASgDQAEAAACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgDQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAHQgBAEADADQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_16.setTransform(-83.3688, 77.2);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_17.setTransform(-90.3792, 77.2);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p("AAPAuIAJgrIgwAAIgJArIgNAAIAUhbIANAAIgIAmIAvAAIAIgmIANAAIgUBbg");
    this.shape_18.setTransform(-98.3, 75.9);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_19.setTransform(-55.6321, 60.45);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_20.setTransform(-61.2923, 61.375);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_21.setTransform(-65.575, 60.1);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIArQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_22.setTransform(-68.5821, 60.45);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_23.setTransform(-74.6679, 61.275);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgPALgLQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgJgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_24.setTransform(-81.7292, 61.4);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-86.425, 60.1);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgGgDgEQgCgFgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgKg",
      );
    this.shape_26.setTransform(-91.285, 61.35);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiApQgIgKADgPIAMAAQgBAIACAGQAFAIAPABQAHgBAGgCQAMgDACgKQACgIgEgDQgEgDgKgDIgLgDQgMgCgEgDQgIgGACgMQADgMAKgIQALgIAPAAQAOAAAJAHQAJAHgDAPIgMAAQAAgHgCgEQgEgHgOAAQgKAAgGAFQgGAEgBAHQgCAGAFAEQAEABALADIANAEQAJABAEADQAIAHgDANQgDAPgNAGQgNAHgOAAQgRAAgIgIg",
      );
    this.shape_27.setTransform(-98.7787, 60.1);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_28.setTransform(100.525, 14.4);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFABIADAAIAEgBIADgDIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAGQgEAGgKABg",
      );
    this.shape_29.setTransform(96.15, 13);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_30.setTransform(90.725, 11.4);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJABALQgBAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_31.setTransform(84.05, 11.5);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_32.setTransform(78.25, 10.525);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_33.setTransform(72.675, 11.525);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_34.setTransform(66.725, 11.4);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_35.setTransform(60.05, 11.5);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_36.setTransform(52.525, 10.225);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_37.setTransform(44.775, 11.525);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_38.setTransform(39.2, 10.125);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_39.setTransform(29.65, 12.975);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGABQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_40.setTransform(22.175, 11.4);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_41.setTransform(16.725, 10.125);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_42.setTransform(12.125, 10.125);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_43.setTransform(6.275, 11.4);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_44.setTransform(-0.4, 11.5);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_45.setTransform(-9.3, 11.5);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_46.setTransform(-21.875, 11.525);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_47.setTransform(-31.675, 10.05);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_48.setTransform(-37.55, 11.5);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_49.setTransform(-49.125, 11.525);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_50.setTransform(-54.875, 11.4);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIABgLQgDAFgDADQgIAFgJABQgOAAgGgLg",
      );
    this.shape_51.setTransform(-61.55, 11.6);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_52.setTransform(-67.35, 10.525);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQADAHAJgBQALAAAFgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgHAFgJABQgOAAgGgLg",
      );
    this.shape_53.setTransform(-73.15, 11.6);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_54.setTransform(-78.875, 10.05);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_55.setTransform(-88.575, 11.525);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIABQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_56.setTransform(-96.275, 10.1);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_57.setTransform(-102.15, 10.525);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_58.setTransform(97.075, -6.75);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_59.setTransform(91.2, -5.3);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_60.setTransform(79.675, -5.4);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgPAAgJgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_61.setTransform(71.85, -5.3);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_62.setTransform(66.475, -6.675);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgJgDQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_63.setTransform(61.45, -5.25);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_64.setTransform(56.375, -6.675);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_65.setTransform(51.325, -5.3);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCAAgHQgBgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_66.setTransform(40.5, -5.25);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_67.setTransform(35.425, -6.675);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_68.setTransform(30.025, -6.7);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_69.setTransform(24.15, -6.275);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_70.setTransform(14.575, -5.4);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_71.setTransform(9.125, -6.675);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgLIAFABIACAAIAGgBIACgEIACgFIAEgHIgbhKIANAAIATA6IAUg6IANAAIgLAfIgMAeQgKAcgDAGQgFAHgLAAg",
      );
    this.shape_72.setTransform(0.25, -3.8);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_73.setTransform(-5.175, -5.4);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_74.setTransform(-11.625, -5.275);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_75.setTransform(-17.2, -6.675);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_76.setTransform(-22.475, -3.95);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_77.setTransform(-32.325, -5.4);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_78.setTransform(-42.075, -5.275);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgZgjIAQAAIAQAZIARgZIAQAAIgZAjIAaAlg");
    this.shape_79.setTransform(-49.45, -5.3);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(-56.825, -5.275);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgDQgDgGgKAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_81.setTransform(-68, -5.25);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_82.setTransform(-73.075, -6.675);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_83.setTransform(-80.45, -6.275);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_84.setTransform(-83.85, -6.675);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_85.setTransform(-86.975, -6.675);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_86.setTransform(-92.45, -5.2);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_87.setTransform(-99.975, -6.575);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_88.setTransform(78.075, -22.075);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_89.setTransform(70.725, -22.1);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_90.setTransform(63.525, -22.075);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_91.setTransform(55.625, -23.5);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_92.setTransform(44.4, -22.05);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgKAAg",
      );
    this.shape_93.setTransform(37.4, -20.6);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQAEAGAIAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_94.setTransform(29.95, -22);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_95.setTransform(22, -20.625);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQAEAGAIAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgQAAgFgKg",
      );
    this.shape_96.setTransform(10.6, -22);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgQAAQgPAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_97.setTransform(2.85, -22.1);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIACgGIADgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgKAAg",
      );
    this.shape_98.setTransform(-4.45, -20.6);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_99.setTransform(-13.8, -23.075);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_100.setTransform(-19.375, -22.075);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_101.setTransform(-27.275, -23.5);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p("AAXAyIgXhSIgXBSIgOAAIgahjIAPAAIASBQIAYhQIANAAIAXBRIAThRIAPAAIgaBjg");
    this.shape_102.setTransform(-37.7, -23.475);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_103.setTransform(-50.125, -19.2);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_104.setTransform(-55.125, -23.475);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_105.setTransform(-62.525, -22.125);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_106.setTransform(-69.775, -22.075);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_107.setTransform(-77.525, -23.375);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_108.setTransform(-87.4, -23.075);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_109.setTransform(-93.175, -22.075);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_110.setTransform(-100.5, -22.05);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_111.setTransform(103.575, -38.875);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_112.setTransform(96.025, -40.175);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_113.setTransform(86.6, -40.275);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_114.setTransform(83.5, -40.275);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_115.setTransform(80.375, -40.275);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgMAAIgVhIIANAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_116.setTransform(73.75, -38.9);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_117.setTransform(60.975, -38.875);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_118.setTransform(53.675, -38.925);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_119.setTransform(46.425, -38.875);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_120.setTransform(38.675, -37.55);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_121.setTransform(28.8, -39.875);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_122.setTransform(23.225, -38.875);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_123.setTransform(11.425, -38.875);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_124.setTransform(4.125, -38.925);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_125.setTransform(-3.275, -39);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_126.setTransform(-11.075, -38.875);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_127.setTransform(-16.475, -40.275);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_128.setTransform(-21.475, -38.925);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_129.setTransform(-28.5, -38.85);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_130.setTransform(-37.775, -40.35);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_131.setTransform(-43.65, -38.9);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_132.setTransform(-55.175, -39);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_133.setTransform(-63, -38.9);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_134.setTransform(-68.375, -40.275);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_135.setTransform(-71.9, -39.875);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_136.setTransform(-77.225, -38.925);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_137.setTransform(-84.675, -38.875);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_138.setTransform(-90.425, -39);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_139.setTransform(-94.725, -40.275);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_140.setTransform(-100.375, -40.175);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_141.setTransform(96.475, -55.675);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_142.setTransform(88.775, -57.1);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_143.setTransform(82.9, -56.675);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_144.setTransform(73.325, -55.8);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_145.setTransform(65.525, -55.675);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_146.setTransform(57.825, -57.1);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_147.setTransform(51.95, -56.675);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQAFgCABgGIABgFIAAAAIgBgBIgGAAIAAgPIAOAAIAAAOQAAAHgEAGQgEAHgGABg",
      );
    this.shape_148.setTransform(44.3, -51.75);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_149.setTransform(38.9, -55.65);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_150.setTransform(33.475, -55.8);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_151.setTransform(27.025, -55.675);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_152.setTransform(19.075, -55.675);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgKgBg",
      );
    this.shape_153.setTransform(11.75, -54.2);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_154.setTransform(0.475, -56.825);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p("AAFAxIAAhFIgWAAIAAgJQANgBAEgDQAGgDACgMIAKAAIAABhg");
    this.shape_155.setTransform(-7.95, -56.925);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_156.setTransform(-16.95, -56.675);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgYgjIAPAAIAQAZIARgZIAQAAIgaAjIAbAlg");
    this.shape_157.setTransform(-22.35, -55.7);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_158.setTransform(-29.725, -55.675);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_159.setTransform(-37.425, -55.8);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_160.setTransform(-49.075, -55.675);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_161.setTransform(-56.775, -57.1);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_162.setTransform(-62.65, -56.675);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_163.setTransform(-72.225, -55.8);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_164.setTransform(-77.675, -57.075);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_165.setTransform(-83.075, -57.1);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_166.setTransform(-88.95, -56.675);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_167.setTransform(-92.375, -57.075);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgNAAIgVhIIAOAAIAOA4IAOg4IANAAIAPA4IAPg4IAMAAIgVBIg");
    this.shape_168.setTransform(-99, -55.7);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQAOAAAEgKQACgGABgPQgFAFgEADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_169.setTransform(70.85, -71.025);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_170.setTransform(63.375, -72.6);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_171.setTransform(57.925, -73.875);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhJIANAAIATA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_172.setTransform(52.9, -71);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_173.setTransform(45.675, -71.15);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_174.setTransform(37.7, -72.5);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_175.setTransform(30.425, -72.525);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhJIAPAAIASA6IAUg6IANAAIgLAfIgLAeQgLAcgEAHQgEAFgKAAg",
      );
    this.shape_176.setTransform(19.55, -71);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_177.setTransform(14.5, -73.875);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_178.setTransform(10.95, -73.475);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_179.setTransform(5.225, -72.6);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_180.setTransform(-2.375, -72.475);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_181.setTransform(-8.4, -73.475);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_182.setTransform(-13.975, -72.475);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_183.setTransform(-19.55, -73.875);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_184.setTransform(-24.825, -73.775);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_185.setTransform(-34.7, -73.475);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAHQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_186.setTransform(-40.05, -72.45);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQgBAGACADQADAGAJAAQALAAAFgLQADgGAAgKIAAgjIAMAAIAABHIgMAAIABgKQgDAEgEADQgHAFgJAAQgOAAgGgKg",
      );
    this.shape_187.setTransform(-47.5, -72.4);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDgBIAAgKQAIAAACgBQABgCAAgGIAAhRIAMAAIAABSQAAAIgDAFQgEAGgLAAgAAAgyIAAgOIAMAAIAAAOg",
      );
    this.shape_188.setTransform(-53.45, -72.4);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_189.setTransform(-60.175, -72.6);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_190.setTransform(-66.85, -72.5);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgEgEgDQgEgFgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_191.setTransform(-78, -72.45);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIACgGIADgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgKAAg",
      );
    this.shape_192.setTransform(-85, -71);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgQAAgFgKg",
      );
    this.shape_193.setTransform(-92.45, -72.4);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_194.setTransform(-100.4, -71.025);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQADAHAJgBQALAAAFgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgDADQgIAFgJABQgOAAgGgLg",
      );
    this.shape_195.setTransform(98.75, -89.2);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_196.setTransform(91, -89.3);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFABIACAAIAGgBIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgDAGQgEAGgMABg",
      );
    this.shape_197.setTransform(83.7, -87.8);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_198.setTransform(72.425, -89.275);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_199.setTransform(66.6, -90.275);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_200.setTransform(61.025, -89.275);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_201.setTransform(55, -90.275);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_202.setTransform(51.575, -90.675);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_203.setTransform(44.225, -89.4);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_204.setTransform(36.825, -90.675);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_205.setTransform(27.5, -89.3);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_206.setTransform(21.7, -90.275);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_207.setTransform(11.85, -87.825);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_208.setTransform(4.375, -89.4);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_209.setTransform(-1.075, -90.675);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFABIADAAIAEgBIADgDIADgFIACgHIgbhLIAPAAIASA7IAUg7IANAAIgLAhIgLAdQgLAcgEAGQgEAGgKABg",
      );
    this.shape_210.setTransform(-6.1, -87.8);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_211.setTransform(-11.525, -89.4);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_212.setTransform(-16.25, -90.275);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_213.setTransform(-23.95, -90.275);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_214.setTransform(-29.75, -89.3);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_215.setTransform(-37.425, -89.4);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_216.setTransform(-47.15, -90.275);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgKAHgHQAIgGAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_217.setTransform(-52.5, -89.25);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_218.setTransform(-59.725, -89.275);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_219.setTransform(-67.675, -89.275);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_220.setTransform(-73.05, -90.675);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_221.setTransform(-80.45, -90.275);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_222.setTransform(-86.025, -89.275);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_223.setTransform(-97.4, -89.25);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_224.setTransform(-102.475, -90.675);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_225.setTransform(106.725, -107.375);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_226.setTransform(98.975, -106.075);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_227.setTransform(93.4, -107.475);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEAAIAAgLIAFABIACAAIAGgBIACgEIACgFIAEgHIgbhKIANAAIATA6IAUg6IANAAIgLAfIgLAeQgLAcgDAGQgEAHgMgBg",
      );
    this.shape_228.setTransform(84.5, -104.6);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_229.setTransform(79.075, -106.2);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_230.setTransform(72.425, -106.075);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_231.setTransform(65.075, -106.1);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_232.setTransform(57.675, -106.075);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_233.setTransform(48, -107.075);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_234.setTransform(42.2, -106.1);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_235.setTransform(34.525, -106.2);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_236.setTransform(24.875, -107.55);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_237.setTransform(21.375, -107.475);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_238.setTransform(14, -107.075);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_239.setTransform(8.425, -106.075);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_240.setTransform(0.525, -107.5);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_241.setTransform(-5.35, -107.075);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_242.setTransform(-14.975, -106.075);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_243.setTransform(-22.325, -106.1);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_244.setTransform(-29.725, -106.075);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_245.setTransform(-35.125, -107.475);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_246.setTransform(-38.2, -107.475);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_247.setTransform(-43.675, -106.075);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_248.setTransform(-51.225, -107.375);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAGQgDAHgLgBg",
      );
    this.shape_249.setTransform(-62.6, -104.6);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_250.setTransform(-67.65, -107.475);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_251.setTransform(-75.025, -106.2);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_252.setTransform(-82.775, -106.2);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_253.setTransform(-87.075, -107.475);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_254.setTransform(-90.525, -107.55);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_257.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_257).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote05testimonialConsumergoods03,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote04testimonialBiogen02 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_3
    this.instance_1 = new lib.Logo_Biogenbw();
    this.instance_1.setTransform(54.45, 144.55, 0.9023, 0.9006);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-101.975, -132.325);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_1.setTransform(99.9679, 103.85);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_2.setTransform(93.8821, 104.675);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_3.setTransform(86.8208, 104.8);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_4.setTransform(77.7071, 104.675);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_5.setTransform(71.1679, 103.85);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgCgBIgCAAQgIAAgGAGQgFAFgBAIIgIAmg",
      );
    this.shape_6.setTransform(67.1, 104.675);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHAAQgIgBgFAGQgDACgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_7.setTransform(60.7312, 104.8);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_8.setTransform(53.3363, 106.025);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_9.setTransform(46.5208, 104.8);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgKQADgRgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_10.setTransform(38.388, 103.5);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_11.setTransform(28.7179, 103.85);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(22.6321, 104.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_13.setTransform(15.5708, 104.8);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_14.setTransform(6.4571, 104.675);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_15.setTransform(-2.8138, 106.025);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_16.setTransform(-9.6529, 104.775);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_17.setTransform(-14.325, 103.5);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_18.setTransform(-19.6792, 104.8);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgMhDIAOAAIAHA3IAdg3IAMAAIgmBDg");
    this.shape_19.setTransform(-25.8, 104.75);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_20.setTransform(-33.3792, 104.8);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgKQADgRgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_21.setTransform(-41.512, 103.5);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_22.setTransform(-51.025, 103.5);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHAAQgIgBgFAGQgDACgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_23.setTransform(-56.5688, 104.8);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgJADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgHgDgEQgCgDgIAAQgKgBgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgEADgIIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_24.setTransform(-63.085, 104.75);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-67.575, 103.5);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_26.setTransform(-70.5821, 103.85);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAvIgDAAIACgLIAEABIADABIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAbQgPAbgFAFQgFAGgKAAg",
      );
    this.shape_27.setTransform(-76.125, 106.15);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_28.setTransform(-80.525, 103.5);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgCgHAAQgIgBgFAGQgDACgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAJIgIAnIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHAEQgHADgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgCQALgGACgKIACgIIgGABg",
      );
    this.shape_29.setTransform(-86.0688, 104.8);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_30.setTransform(-93.2179, 104.675);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p("AAcAvIgEgcIgjAAIgQAcIgOAAIA3hdIANAAIAPBdgAAXAIIgGgoIgXAoIAdAAg");
    this.shape_31.setTransform(-101.65, 103.5);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_32.setTransform(-57.6321, 88.05);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_33.setTransform(-63.2923, 88.975);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_34.setTransform(-67.575, 87.7);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_35.setTransform(-70.5821, 88.05);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_36.setTransform(-76.6679, 88.875);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_37.setTransform(-83.7292, 89);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_38.setTransform(-88.425, 87.7);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgEgIABQgKgBgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgJg",
      );
    this.shape_39.setTransform(-93.285, 88.95);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAoQgIgIADgPIAMAAQgBAHACAFQAFAKAPgBQAHAAAGgCQAMgDACgLQACgHgEgEQgEgDgKgCIgLgDQgMgCgEgDQgIgGACgLQADgNAKgIQALgIAPAAQAOAAAJAHQAJAHgDAQIgMAAQAAgIgCgEQgEgHgOAAQgKAAgGAEQgGAFgBAGQgCAHAFAEQAEACALACIANADQAJADAEACQAIAHgDAMQgDAQgNAHQgNAGgOAAQgRAAgIgJg",
      );
    this.shape_40.setTransform(-100.7787, 87.7);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_41.setTransform(70.175, 58.8);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_42.setTransform(64.125, 54.625);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_43.setTransform(56.55, 55.9);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_44.setTransform(48.875, 54.5);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_45.setTransform(43, 54.925);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_46.setTransform(37.225, 55.925);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgyQAAgIgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_47.setTransform(27.575, 55.8);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_48.setTransform(15.9, 54.925);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAGACADQADAHAJAAQALAAAFgMQADgGAAgKIAAgjIAMAAIAABIIgMAAIABgMQgDAFgDACQgIAHgJAAQgOAAgGgLg",
      );
    this.shape_49.setTransform(10.1, 56);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_50.setTransform(2.575, 57.25);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_51.setTransform(-5.325, 54.5);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_52.setTransform(-13.35, 57.375);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_53.setTransform(-20.9, 56);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_54.setTransform(-28.65, 55.9);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_55.setTransform(-34.375, 55.8);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_56.setTransform(-40.975, 54.5);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_57.setTransform(-46.85, 54.925);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_58.setTransform(-56.425, 54.5);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFADACQAEAFAIAAQAOAAAEgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgIgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgEAMg",
      );
    this.shape_59.setTransform(-64.45, 57.375);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_60.setTransform(-69.625, 54.525);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_61.setTransform(-75.025, 54.5);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_62.setTransform(-86.875, 54.625);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_63.setTransform(-94.375, 55.8);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_64.setTransform(-101.975, 55.925);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_65.setTransform(102.325, 39.125);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_66.setTransform(96.95, 37.725);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_67.setTransform(91.675, 37.825);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_68.setTransform(83.925, 39.125);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_69.setTransform(77.9, 38.125);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_70.setTransform(72.325, 39.125);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_71.setTransform(64.375, 39.125);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_72.setTransform(56.825, 40.45);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_73.setTransform(48.875, 39.125);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_74.setTransform(43.125, 39);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhJIAPAAIASA6IAUg6IANAAIgLAfIgLAeQgLAcgEAHQgEAFgKAAg",
      );
    this.shape_75.setTransform(33.05, 40.6);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_76.setTransform(28, 37.725);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_77.setTransform(22.575, 37.7);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_78.setTransform(14.55, 40.575);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_79.setTransform(9.375, 37.725);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_80.setTransform(3.975, 37.7);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_81.setTransform(-7.475, 39.125);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_82.setTransform(-19.3, 39.1);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_83.setTransform(-25.1, 38.125);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgGAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_84.setTransform(-30.825, 39);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_85.setTransform(-36.275, 37.725);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAEAFAJAAQAOAAAEgKQACgGABgPQgEAFgFADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_86.setTransform(-45.8, 40.575);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgGAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_87.setTransform(-53.275, 39);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_88.setTransform(-58.725, 37.725);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_89.setTransform(-64.125, 37.7);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_90.setTransform(-70, 38.125);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_91.setTransform(-75.775, 39.125);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_92.setTransform(-85.425, 39);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_93.setTransform(-95.2, 39.1);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_94.setTransform(-102.5, 39.15);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_95.setTransform(86.025, 22.2);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_96.setTransform(80.225, 22.2);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQADAHAJgBQALAAAFgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgHAFgJABQgOAAgGgLg",
      );
    this.shape_97.setTransform(73.55, 22.4);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_98.setTransform(67.75, 21.325);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_99.setTransform(58.1, 22.3);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_100.setTransform(52.3, 21.325);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_101.setTransform(42.675, 22.325);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_102.setTransform(34.725, 21.025);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgQAAQgPAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_103.setTransform(27.15, 22.3);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_104.setTransform(19.875, 22.275);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_105.setTransform(10.575, 20.85);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_106.setTransform(4.7, 22.3);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEABgGQAAgEgFgDIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAKQAFAFAAAIIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_107.setTransform(-6.45, 22.35);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_108.setTransform(-13.875, 22.325);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_109.setTransform(-21.575, 22.2);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_110.setTransform(-27.025, 20.925);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_111.setTransform(-30.1, 20.925);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_112.setTransform(-40.6, 22.3);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_113.setTransform(-49.525, 22.325);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_114.setTransform(-55.275, 20.85);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_115.setTransform(-64.775, 22.325);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_116.setTransform(-76.15, 22.35);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_117.setTransform(-83.575, 22.325);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_118.setTransform(-90.475, 20.925);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_119.setTransform(-98.125, 22.325);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_120.setTransform(-104.15, 21.325);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_121.setTransform(96.4, 4.525);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgJABQgHAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_122.setTransform(91.05, 5.55);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAGABADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgHAHgJAAQgQAAgFgLg",
      );
    this.shape_123.setTransform(83.6, 5.6);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgIBBIgDAAIAAgLQAIAAACgBQABgCAAgGIAAhRIAMAAIAABTQAAAHgDAEQgEAHgLAAgAAAgyIAAgOIAMAAIAAAOg",
      );
    this.shape_124.setTransform(77.65, 5.6);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_125.setTransform(70.85, 4.525);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_126.setTransform(67.2, 4.125);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics.f("#31353B").s().p("AgGAIIAAgOIANAAIAAAOg");
    this.shape_127.setTransform(59.375, 8.4);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgDQgDgGgKABQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_128.setTransform(53.95, 5.55);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_129.setTransform(48.875, 4.125);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgCABgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgLAAQgBgEgDgDQgEgGgJABQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_130.setTransform(43.85, 5.55);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAGQgDAHgLgBg",
      );
    this.shape_131.setTransform(36.85, 7);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_132.setTransform(31.8, 4.125);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_133.setTransform(26.525, 5.525);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_134.setTransform(18.625, 5.4);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_135.setTransform(11.025, 5.525);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_136.setTransform(-0.575, 5.525);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_137.setTransform(-6.6, 4.525);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_138.setTransform(-12.175, 5.525);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_139.setTransform(-20.325, 4.225);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_140.setTransform(-31.925, 4.225);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_141.setTransform(-39.425, 5.4);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_142.setTransform(-47.025, 5.525);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_143.setTransform(-58.625, 6.85);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_144.setTransform(-66.575, 5.525);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_145.setTransform(-72.325, 5.4);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_146.setTransform(-78.775, 6.85);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_147.setTransform(-90.575, 5.525);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_148.setTransform(-98.275, 4.1);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_149.setTransform(-104.15, 4.525);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_150.setTransform(102.775, -11.4);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_151.setTransform(96.1, -11.3);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_152.setTransform(90.375, -12.75);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_153.setTransform(81.1, -11.25);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_154.setTransform(73.725, -11.4);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAJgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_155.setTransform(65.9, -11.3);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_156.setTransform(60.525, -12.675);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_157.setTransform(57, -12.275);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_158.setTransform(51.675, -11.325);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_159.setTransform(44.275, -11.4);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQAAAGABADQAEAGAIAAQALAAAFgLQACgGAAgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_160.setTransform(36.45, -11.2);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_161.setTransform(30.725, -12.75);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAEAFAJAAQAOAAAEgKQACgGABgPQgEAFgFADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_162.setTransform(20.8, -9.825);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_163.setTransform(13.325, -11.4);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_164.setTransform(7.875, -12.675);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAHAAAHIgLAAQgBgEgCgDQgFgFgJgBQgHAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_165.setTransform(2.85, -11.25);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQAAAGABADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgHAFgJAAQgQAAgFgKg",
      );
    this.shape_166.setTransform(-4.6, -11.2);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_167.setTransform(-16.175, -11.275);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAGALABQAHAAAFgEQAGgDgBgGQAAgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgCgDQgEgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_168.setTransform(-23.5, -11.25);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_169.setTransform(-30.725, -11.275);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_170.setTransform(-38.675, -11.275);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_171.setTransform(-50.225, -12.7);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_172.setTransform(-56.1, -12.275);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_173.setTransform(-59.525, -12.675);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhHIAOAAIAOA4IAOg4IANAAIAPA3IAPg3IAMAAIgVBHg");
    this.shape_174.setTransform(-66.15, -11.3);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_175.setTransform(-78.925, -11.275);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_176.setTransform(-86.625, -11.4);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_177.setTransform(-94.45, -11.3);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_178.setTransform(-102.375, -12.575);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_179.setTransform(93.025, -28.075);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_180.setTransform(85.475, -29.375);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_181.setTransform(73.725, -28.2);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_182.setTransform(66.125, -28.075);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_183.setTransform(58.625, -28.125);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_184.setTransform(47.75, -28.05);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_185.setTransform(40.375, -28.2);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMAAAEgLQACgGABgKIAAgkIAMAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_186.setTransform(32.55, -28);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_187.setTransform(26.825, -28.2);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_188.setTransform(18.25, -29.075);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_189.setTransform(12.525, -28.2);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_190.setTransform(4.725, -28.075);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQAEAHAIgBQALAAAFgLQACgGAAgKIAAgkIANAAIAABIIgMAAIABgLQgDAFgDADQgIAFgJABQgOAAgGgLg",
      );
    this.shape_191.setTransform(-3.05, -28);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p(
        "AAUA0IAAglQgDAFgGADQgFACgHAAQgMAAgJgJQgJgJAAgSQAAgRAIgLQAJgMAOAAQAIAAAGAEIAHAIIAAgKIALAAIAABlgAgNghQgFAHAAAPQAAAJACAGQAFAKALABQANgBAFgLQACgGAAgKQAAgKgCgGQgFgLgNAAQgHAAgGAHg",
      );
    this.shape_192.setTransform(-10.975, -26.75);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_193.setTransform(-18.525, -28.075);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_194.setTransform(-25.85, -28.05);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_195.setTransform(-33.075, -29.375);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQAAAGABADQADAHAJgBQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgHAFgJABQgQAAgFgLg",
      );
    this.shape_196.setTransform(-41.05, -28);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_197.setTransform(-48.35, -28.05);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_198.setTransform(-59.575, -28.2);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_199.setTransform(-67.375, -28.075);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_200.setTransform(-75.075, -29.5);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_201.setTransform(-80.95, -29.075);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_202.setTransform(-88.65, -29.075);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAGABADQAEAHAIgBQAMAAAEgLQACgGABgKIAAgkIAMAAIAABIIgMAAIAAgLQgCAFgEADQgGAFgKABQgPAAgFgLg",
      );
    this.shape_203.setTransform(-94.45, -28);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_204.setTransform(-101.975, -29.375);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgJgDQgKgCgEgCQgJgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_205.setTransform(94.3, -44.85);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_206.setTransform(88.8, -45.875);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_207.setTransform(83.075, -45);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_208.setTransform(75.275, -44.875);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_209.setTransform(65.625, -45);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_210.setTransform(58.225, -46.275);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_211.setTransform(54.775, -45);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_212.setTransform(48.125, -44.875);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_213.setTransform(40.575, -43.55);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p("AARAlIgRgcIgRAcIgQAAIAaglIgYgjIAPAAIAQAZIARgZIAQAAIgZAjIAaAlg");
    this.shape_214.setTransform(33, -44.9);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_215.setTransform(25.625, -44.875);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_216.setTransform(14.025, -44.875);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_217.setTransform(6.325, -46.3);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_218.setTransform(0.45, -45.875);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_219.setTransform(-9.175, -44.875);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_220.setTransform(-15, -45.875);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_221.setTransform(-20.575, -44.875);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_222.setTransform(-28.075, -44.925);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_223.setTransform(-33.175, -46.275);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_224.setTransform(-36.25, -46.275);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAHgLgBQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAJACAEQAFAMAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_225.setTransform(-41.525, -43.55);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_226.setTransform(-49.475, -44.875);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_227.setTransform(-55.225, -45);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_228.setTransform(-65.725, -44.875);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgNAAIgUhIIANAAIAOA4IAOg4IANAAIAOA4IAPg4IAMAAIgVBIg");
    this.shape_229.setTransform(-74.65, -44.9);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_230.setTransform(-87.375, -45);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_231.setTransform(-94.975, -44.875);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_232.setTransform(-102.475, -44.925);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgLIAFABIADAAIAEgBIADgCIACgGIADgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgKAAg",
      );
    this.shape_233.setTransform(82.4, -60.2);

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_234.setTransform(77.35, -63.075);

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_235.setTransform(71.925, -61.8);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_236.setTransform(64.1, -61.7);

    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_237.setTransform(54.45, -62.675);

    this.shape_238 = new cjs.Shape();
    this.shape_238.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_238.setTransform(48.65, -61.7);

    this.shape_239 = new cjs.Shape();
    this.shape_239.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_239.setTransform(40.975, -61.8);

    this.shape_240 = new cjs.Shape();
    this.shape_240.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_240.setTransform(31.25, -62.675);

    this.shape_241 = new cjs.Shape();
    this.shape_241.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_241.setTransform(25.675, -61.675);

    this.shape_242 = new cjs.Shape();
    this.shape_242.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_242.setTransform(17.775, -63.1);

    this.shape_243 = new cjs.Shape();
    this.shape_243.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_243.setTransform(11.9, -62.675);

    this.shape_244 = new cjs.Shape();
    this.shape_244.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_244.setTransform(2.325, -61.8);

    this.shape_245 = new cjs.Shape();
    this.shape_245.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhHIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBHg");
    this.shape_245.setTransform(-6.65, -61.7);

    this.shape_246 = new cjs.Shape();
    this.shape_246.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_246.setTransform(-15.6, -61.7);

    this.shape_247 = new cjs.Shape();
    this.shape_247.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_247.setTransform(-23.275, -63.1);

    this.shape_248 = new cjs.Shape();
    this.shape_248.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAGALABQAHAAAFgEQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgEgDQgDgFgKgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_248.setTransform(-30.65, -61.65);

    this.shape_249 = new cjs.Shape();
    this.shape_249.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_249.setTransform(-41.95, -61.7);

    this.shape_250 = new cjs.Shape();
    this.shape_250.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgFgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_250.setTransform(-49.25, -61.65);

    this.shape_251 = new cjs.Shape();
    this.shape_251.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_251.setTransform(-54.3, -63.075);

    this.shape_252 = new cjs.Shape();
    this.shape_252.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_252.setTransform(-59.575, -61.675);

    this.shape_253 = new cjs.Shape();
    this.shape_253.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_253.setTransform(-71.375, -61.675);

    this.shape_254 = new cjs.Shape();
    this.shape_254.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_254.setTransform(-78.725, -61.7);

    this.shape_255 = new cjs.Shape();
    this.shape_255.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBACgEQABgDAAgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_255.setTransform(-83.4, -66.325);

    this.shape_256 = new cjs.Shape();
    this.shape_256.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_256.setTransform(-89.225, -61.675);

    this.shape_257 = new cjs.Shape();
    this.shape_257.graphics
      .f("#31353B")
      .s()
      .p("AAXAyIgXhSIgXBSIgOAAIgahjIAPAAIASBQIAYhQIANAAIAXBRIAThRIAPAAIgaBjg");
    this.shape_257.setTransform(-99.35, -63.075);

    this.shape_258 = new cjs.Shape();
    this.shape_258.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_258.setTransform(100.325, -75.6);

    this.shape_259 = new cjs.Shape();
    this.shape_259.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_259.setTransform(96.475, -75.6);

    this.shape_260 = new cjs.Shape();
    this.shape_260.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_260.setTransform(92.625, -75.6);

    this.shape_261 = new cjs.Shape();
    this.shape_261.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_261.setTransform(84.875, -78.6);

    this.shape_262 = new cjs.Shape();
    this.shape_262.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_262.setTransform(77.125, -78.6);

    this.shape_263 = new cjs.Shape();
    this.shape_263.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_263.setTransform(70.45, -78.5);

    this.shape_264 = new cjs.Shape();
    this.shape_264.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_264.setTransform(64.725, -79.95);

    this.shape_265 = new cjs.Shape();
    this.shape_265.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_265.setTransform(60.8, -79.475);

    this.shape_266 = new cjs.Shape();
    this.shape_266.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_266.setTransform(55.225, -78.475);

    this.shape_267 = new cjs.Shape();
    this.shape_267.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_267.setTransform(49.65, -79.875);

    this.shape_268 = new cjs.Shape();
    this.shape_268.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_268.setTransform(44.375, -77.15);

    this.shape_269 = new cjs.Shape();
    this.shape_269.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_269.setTransform(34.575, -79.95);

    this.shape_270 = new cjs.Shape();
    this.shape_270.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_270.setTransform(28.7, -78.5);

    this.shape_271 = new cjs.Shape();
    this.shape_271.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_271.setTransform(17.125, -78.475);

    this.shape_272 = new cjs.Shape();
    this.shape_272.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAXgMAKQgIAGgLAAQgHAAgGgDIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFAKAMABQAIAAAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_272.setTransform(9.575, -77.15);

    this.shape_273 = new cjs.Shape();
    this.shape_273.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFABIACAAIAGgBIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IAOAAIgMAhIgMAdQgKAcgDAGQgFAGgLABg",
      );
    this.shape_273.setTransform(2.05, -77);

    this.shape_274 = new cjs.Shape();
    this.shape_274.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_274.setTransform(-3.45, -79.475);

    this.shape_275 = new cjs.Shape();
    this.shape_275.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgEgDQgDgEgKAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_275.setTransform(-12.65, -78.45);

    this.shape_276 = new cjs.Shape();
    this.shape_276.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_276.setTransform(-17.725, -79.875);

    this.shape_277 = new cjs.Shape();
    this.shape_277.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_277.setTransform(-23.125, -79.9);

    this.shape_278 = new cjs.Shape();
    this.shape_278.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_278.setTransform(-29, -79.475);

    this.shape_279 = new cjs.Shape();
    this.shape_279.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_279.setTransform(-38.575, -78.6);

    this.shape_280 = new cjs.Shape();
    this.shape_280.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_280.setTransform(-44.025, -79.875);

    this.shape_281 = new cjs.Shape();
    this.shape_281.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_281.setTransform(-53.525, -79.775);

    this.shape_282 = new cjs.Shape();
    this.shape_282.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_282.setTransform(-61.075, -78.475);

    this.shape_283 = new cjs.Shape();
    this.shape_283.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_283.setTransform(-66.9, -79.475);

    this.shape_284 = new cjs.Shape();
    this.shape_284.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIANAAIAAAwQgBAGACADQADAHAJgBQALAAAFgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgHAFgJABQgOAAgGgLg",
      );
    this.shape_284.setTransform(-72.7, -78.4);

    this.shape_285 = new cjs.Shape();
    this.shape_285.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_285.setTransform(-79.975, -78.525);

    this.shape_286 = new cjs.Shape();
    this.shape_286.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_286.setTransform(-87.425, -78.475);

    this.shape_287 = new cjs.Shape();
    this.shape_287.graphics
      .f("#31353B")
      .s()
      .p("AARAkIgRgbIgRAbIgQAAIAagkIgYgkIAPAAIAQAaIARgaIAQAAIgaAkIAbAkg");
    this.shape_287.setTransform(-94.8, -78.5);

    this.shape_288 = new cjs.Shape();
    this.shape_288.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_288.setTransform(-102.175, -78.475);

    this.shape_289 = new cjs.Shape();
    this.shape_289.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIACgFIADgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAGQgFAHgKgBg",
      );
    this.shape_289.setTransform(76.55, -93.8);

    this.shape_290 = new cjs.Shape();
    this.shape_290.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_290.setTransform(71.5, -96.675);

    this.shape_291 = new cjs.Shape();
    this.shape_291.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_291.setTransform(68.4, -96.675);

    this.shape_292 = new cjs.Shape();
    this.shape_292.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAGABADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgHAHgJAAQgQAAgFgLg",
      );
    this.shape_292.setTransform(62.9, -95.2);

    this.shape_293 = new cjs.Shape();
    this.shape_293.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_293.setTransform(57.175, -96.75);

    this.shape_294 = new cjs.Shape();
    this.shape_294.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIAMAAQABAGADAEQAEAFALAAQAHAAAFgDQAGgCAAgHQgBgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgHAHgPAAQgQAAgHgHg",
      );
    this.shape_294.setTransform(51.75, -95.25);

    this.shape_295 = new cjs.Shape();
    this.shape_295.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgDQAFgCABgHQAAgEgFgDIgLgDIgJgDQgJgCgFgCQgHgFAAgJQgBgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgLAAQgBgEgDgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_295.setTransform(44.75, -95.25);

    this.shape_296 = new cjs.Shape();
    this.shape_296.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_296.setTransform(37.325, -95.275);

    this.shape_297 = new cjs.Shape();
    this.shape_297.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_297.setTransform(30.025, -95.325);

    this.shape_298 = new cjs.Shape();
    this.shape_298.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_298.setTransform(23.025, -95.325);

    this.shape_299 = new cjs.Shape();
    this.shape_299.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQAEAHAIAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_299.setTransform(15.55, -95.2);

    this.shape_300 = new cjs.Shape();
    this.shape_300.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAGgCgBgHQAAgEgDgDIgLgDIgKgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAKQAEAFAAAIIgMAAQAAgEgCgDQgFgGgKAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_300.setTransform(8.25, -95.25);

    this.shape_301 = new cjs.Shape();
    this.shape_301.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_301.setTransform(-3.025, -95.275);

    this.shape_302 = new cjs.Shape();
    this.shape_302.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_302.setTransform(-10.575, -96.575);

    this.shape_303 = new cjs.Shape();
    this.shape_303.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_303.setTransform(-22.325, -95.4);

    this.shape_304 = new cjs.Shape();
    this.shape_304.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_304.setTransform(-29.925, -95.275);

    this.shape_305 = new cjs.Shape();
    this.shape_305.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_305.setTransform(-37.425, -95.325);

    this.shape_306 = new cjs.Shape();
    this.shape_306.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDAAIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhKIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAGQgEAHgKgBg",
      );
    this.shape_306.setTransform(-48.3, -93.8);

    this.shape_307 = new cjs.Shape();
    this.shape_307.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_307.setTransform(-53.35, -96.675);

    this.shape_308 = new cjs.Shape();
    this.shape_308.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_308.setTransform(-56.9, -96.275);

    this.shape_309 = new cjs.Shape();
    this.shape_309.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_309.setTransform(-62.625, -95.4);

    this.shape_310 = new cjs.Shape();
    this.shape_310.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_310.setTransform(-70.425, -95.275);

    this.shape_311 = new cjs.Shape();
    this.shape_311.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAGACADQAEAHAIAAQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIABgMQgDAFgDACQgIAHgJAAQgOAAgGgLg",
      );
    this.shape_311.setTransform(-78.2, -95.2);

    this.shape_312 = new cjs.Shape();
    this.shape_312.graphics
      .f("#31353B")
      .s()
      .p(
        "AAUA0IAAgmQgDAGgGACQgFADgHAAQgMABgJgKQgJgJAAgSQAAgRAIgMQAJgLAOAAQAIAAAGAEIAHAIIAAgKIALAAIAABlgAgNghQgFAHAAAOQAAAKACAFQAFAMALgBQANABAFgMQACgGAAgLQAAgJgCgGQgFgLgNAAQgHAAgGAHg",
      );
    this.shape_312.setTransform(-86.125, -93.95);

    this.shape_313 = new cjs.Shape();
    this.shape_313.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_313.setTransform(-93.675, -95.275);

    this.shape_314 = new cjs.Shape();
    this.shape_314.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_314.setTransform(-99.425, -95.4);

    this.shape_315 = new cjs.Shape();
    this.shape_315.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_315.setTransform(-104.075, -96.75);

    this.shape_316 = new cjs.Shape();
    this.shape_316.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhJIANAAIATA6IAUg6IANAAIgLAfIgLAeQgLAcgEAHQgDAFgMAAg",
      );
    this.shape_316.setTransform(78.75, -110.6);

    this.shape_317 = new cjs.Shape();
    this.shape_317.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_317.setTransform(73.325, -112.2);

    this.shape_318 = new cjs.Shape();
    this.shape_318.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_318.setTransform(66.675, -112.075);

    this.shape_319 = new cjs.Shape();
    this.shape_319.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhHIAOAAIATA6IAUg6IAOAAIgcBHg");
    this.shape_319.setTransform(59.325, -112.1);

    this.shape_320 = new cjs.Shape();
    this.shape_320.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_320.setTransform(48.125, -112.2);

    this.shape_321 = new cjs.Shape();
    this.shape_321.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIAMAAIAAAvQAAAGACADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgIAFgIAAQgPAAgGgKg",
      );
    this.shape_321.setTransform(40.3, -112);

    this.shape_322 = new cjs.Shape();
    this.shape_322.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_322.setTransform(34.575, -112.2);

    this.shape_323 = new cjs.Shape();
    this.shape_323.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_323.setTransform(24.075, -112.075);

    this.shape_324 = new cjs.Shape();
    this.shape_324.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhHIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBHg");
    this.shape_324.setTransform(15.15, -112.1);

    this.shape_325 = new cjs.Shape();
    this.shape_325.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_325.setTransform(4.3, -113.075);

    this.shape_326 = new cjs.Shape();
    this.shape_326.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_326.setTransform(-1.275, -112.075);

    this.shape_327 = new cjs.Shape();
    this.shape_327.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_327.setTransform(-9.175, -113.5);

    this.shape_328 = new cjs.Shape();
    this.shape_328.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_328.setTransform(-15.05, -113.075);

    this.shape_329 = new cjs.Shape();
    this.shape_329.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_329.setTransform(-24.675, -112.075);

    this.shape_330 = new cjs.Shape();
    this.shape_330.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_330.setTransform(-30.425, -112.2);

    this.shape_331 = new cjs.Shape();
    this.shape_331.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_331.setTransform(-37.075, -112.075);

    this.shape_332 = new cjs.Shape();
    this.shape_332.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_332.setTransform(-44.775, -113.5);

    this.shape_333 = new cjs.Shape();
    this.shape_333.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgLAHgFQAHgHANAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgFgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_333.setTransform(-56, -112.05);

    this.shape_334 = new cjs.Shape();
    this.shape_334.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_334.setTransform(-63.625, -113.375);

    this.shape_335 = new cjs.Shape();
    this.shape_335.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_335.setTransform(-71.2, -112.1);

    this.shape_336 = new cjs.Shape();
    this.shape_336.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_336.setTransform(-78.875, -113.5);

    this.shape_337 = new cjs.Shape();
    this.shape_337.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_337.setTransform(-84.75, -113.075);

    this.shape_338 = new cjs.Shape();
    this.shape_338.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_338.setTransform(-90.525, -112.075);

    this.shape_339 = new cjs.Shape();
    this.shape_339.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgHgDgDQgEgCgFAAQgHAAgGAEQgFAGAAALIAAApIgLAAIAAguQAAgIgCgDQgDgFgIAAQgHAAgFAFQgGAFAAAPIAAAlIgMAAIAAhHIAMAAIAAAJIAIgHQAGgFAIABQAIgBAGAFQACADACAEQAEgGAGgDQAFgCAHAAQAPAAAFALQADAFAAAKIAAAvg",
      );
    this.shape_339.setTransform(-100.175, -112.2);

    this.shape_340 = new cjs.Shape();
    this.shape_340.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_340.setTransform(101.375, -128.875);

    this.shape_341 = new cjs.Shape();
    this.shape_341.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_341.setTransform(93.675, -130.3);

    this.shape_342 = new cjs.Shape();
    this.shape_342.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_342.setTransform(87.8, -129.875);

    this.shape_343 = new cjs.Shape();
    this.shape_343.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_343.setTransform(80.175, -130.35);

    this.shape_344 = new cjs.Shape();
    this.shape_344.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_344.setTransform(74.3, -128.9);

    this.shape_345 = new cjs.Shape();
    this.shape_345.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_345.setTransform(62.725, -128.875);

    this.shape_346 = new cjs.Shape();
    this.shape_346.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_346.setTransform(55.025, -129);

    this.shape_347 = new cjs.Shape();
    this.shape_347.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_347.setTransform(47.2, -128.9);

    this.shape_348 = new cjs.Shape();
    this.shape_348.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_348.setTransform(37.55, -129.875);

    this.shape_349 = new cjs.Shape();
    this.shape_349.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_349.setTransform(31.975, -128.875);

    this.shape_350 = new cjs.Shape();
    this.shape_350.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_350.setTransform(24.075, -130.3);

    this.shape_351 = new cjs.Shape();
    this.shape_351.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_351.setTransform(18.2, -129.875);

    this.shape_352 = new cjs.Shape();
    this.shape_352.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_352.setTransform(7.4, -128.9);

    this.shape_353 = new cjs.Shape();
    this.shape_353.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_353.setTransform(-1.55, -128.9);

    this.shape_354 = new cjs.Shape();
    this.shape_354.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_354.setTransform(-9.225, -130.3);

    this.shape_355 = new cjs.Shape();
    this.shape_355.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_355.setTransform(-16.6, -128.85);

    this.shape_356 = new cjs.Shape();
    this.shape_356.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_356.setTransform(-27.9, -128.9);

    this.shape_357 = new cjs.Shape();
    this.shape_357.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_357.setTransform(-33.7, -129.875);

    this.shape_358 = new cjs.Shape();
    this.shape_358.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_358.setTransform(-43.325, -128.875);

    this.shape_359 = new cjs.Shape();
    this.shape_359.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_359.setTransform(-48.7, -130.275);

    this.shape_360 = new cjs.Shape();
    this.shape_360.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_360.setTransform(-53.975, -130.175);

    this.shape_361 = new cjs.Shape();
    this.shape_361.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_361.setTransform(-61.725, -128.875);

    this.shape_362 = new cjs.Shape();
    this.shape_362.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_362.setTransform(-73.1, -128.85);

    this.shape_363 = new cjs.Shape();
    this.shape_363.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_363.setTransform(-80.325, -128.875);

    this.shape_364 = new cjs.Shape();
    this.shape_364.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_364.setTransform(-89.45, -128.9);

    this.shape_365 = new cjs.Shape();
    this.shape_365.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AV49EMAAAA6JMgrvAAAMAAAg6Jg");
    this.shape_365.setTransform(0, 0.016, 1.0643, 1.0323);

    this.shape_366 = new cjs.Shape();
    this.shape_366.graphics.f("#FFFFFF").s().p("A13dFMAAAg6JMArvAAAMAAAA6Jg");
    this.shape_366.setTransform(0, 0.016, 1.0643, 1.0323);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_366 },
            { t: this.shape_365 },
            { t: this.shape_364 },
            { t: this.shape_363 },
            { t: this.shape_362 },
            { t: this.shape_361 },
            { t: this.shape_360 },
            { t: this.shape_359 },
            { t: this.shape_358 },
            { t: this.shape_357 },
            { t: this.shape_356 },
            { t: this.shape_355 },
            { t: this.shape_354 },
            { t: this.shape_353 },
            { t: this.shape_352 },
            { t: this.shape_351 },
            { t: this.shape_350 },
            { t: this.shape_349 },
            { t: this.shape_348 },
            { t: this.shape_347 },
            { t: this.shape_346 },
            { t: this.shape_345 },
            { t: this.shape_344 },
            { t: this.shape_343 },
            { t: this.shape_342 },
            { t: this.shape_341 },
            { t: this.shape_340 },
            { t: this.shape_339 },
            { t: this.shape_338 },
            { t: this.shape_337 },
            { t: this.shape_336 },
            { t: this.shape_335 },
            { t: this.shape_334 },
            { t: this.shape_333 },
            { t: this.shape_332 },
            { t: this.shape_331 },
            { t: this.shape_330 },
            { t: this.shape_329 },
            { t: this.shape_328 },
            { t: this.shape_327 },
            { t: this.shape_326 },
            { t: this.shape_325 },
            { t: this.shape_324 },
            { t: this.shape_323 },
            { t: this.shape_322 },
            { t: this.shape_321 },
            { t: this.shape_320 },
            { t: this.shape_319 },
            { t: this.shape_318 },
            { t: this.shape_317 },
            { t: this.shape_316 },
            { t: this.shape_315 },
            { t: this.shape_314 },
            { t: this.shape_313 },
            { t: this.shape_312 },
            { t: this.shape_311 },
            { t: this.shape_310 },
            { t: this.shape_309 },
            { t: this.shape_308 },
            { t: this.shape_307 },
            { t: this.shape_306 },
            { t: this.shape_305 },
            { t: this.shape_304 },
            { t: this.shape_303 },
            { t: this.shape_302 },
            { t: this.shape_301 },
            { t: this.shape_300 },
            { t: this.shape_299 },
            { t: this.shape_298 },
            { t: this.shape_297 },
            { t: this.shape_296 },
            { t: this.shape_295 },
            { t: this.shape_294 },
            { t: this.shape_293 },
            { t: this.shape_292 },
            { t: this.shape_291 },
            { t: this.shape_290 },
            { t: this.shape_289 },
            { t: this.shape_288 },
            { t: this.shape_287 },
            { t: this.shape_286 },
            { t: this.shape_285 },
            { t: this.shape_284 },
            { t: this.shape_283 },
            { t: this.shape_282 },
            { t: this.shape_281 },
            { t: this.shape_280 },
            { t: this.shape_279 },
            { t: this.shape_278 },
            { t: this.shape_277 },
            { t: this.shape_276 },
            { t: this.shape_275 },
            { t: this.shape_274 },
            { t: this.shape_273 },
            { t: this.shape_272 },
            { t: this.shape_271 },
            { t: this.shape_270 },
            { t: this.shape_269 },
            { t: this.shape_268 },
            { t: this.shape_267 },
            { t: this.shape_266 },
            { t: this.shape_265 },
            { t: this.shape_264 },
            { t: this.shape_263 },
            { t: this.shape_262 },
            { t: this.shape_261 },
            { t: this.shape_260 },
            { t: this.shape_259 },
            { t: this.shape_258 },
            { t: this.shape_257 },
            { t: this.shape_256 },
            { t: this.shape_255 },
            { t: this.shape_254 },
            { t: this.shape_253 },
            { t: this.shape_252 },
            { t: this.shape_251 },
            { t: this.shape_250 },
            { t: this.shape_249 },
            { t: this.shape_248 },
            { t: this.shape_247 },
            { t: this.shape_246 },
            { t: this.shape_245 },
            { t: this.shape_244 },
            { t: this.shape_243 },
            { t: this.shape_242 },
            { t: this.shape_241 },
            { t: this.shape_240 },
            { t: this.shape_239 },
            { t: this.shape_238 },
            { t: this.shape_237 },
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.instance_1 },
          ],
        })
        .wait(1),
    );

    // Layer_2
    this.shape_367 = new cjs.Shape();
    this.shape_367.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_367.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_367).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote04testimonialBiogen02,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote03testimonialGSK01 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AgjBMIAAgHIAKgBIAHgCQAEgBACgDQACgDgBgEIAAh6IgFAAIgJAAIgJABQgEAAgDAEIgIAJIgGAKIgDAJIgIAAIAAgpICFAAIAAApIgIAAIgDgJIgGgKIgHgJQgEgDgEgBIgIgBIgKAAIgFAAIAAB5QgBAEACADQACADAEABIAHACIAKACIAAAHg",
      );
    this.shape.setTransform(-97.2, -95.075);

    this.instance_1 = new lib.Logo_GSK();
    this.instance_1.setTransform(85.7, 142.8, 0.3553, 0.3553);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhcIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXgBgAgcAjIAWAAIAKAAQAIgDAGgHQAFgGAEgJIADgKQADgQgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_1.setTransform(-16.912, 57.3);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AggAoQgFgIACgKQACgLAIgGQAFgFAMgFQgEgHgCgFQgBgFABgEQACgIAIgGQAGgHAKAAQAKABAEAFQAFAGgCAHQgCAJgHAHIgNAJIANATIAEgIIADgHIAKAAQgDAJgFAJIgEAHIAAgBIAAABIAMATIgPAAIgGgKIgLAIQgIAFgKAAQgOAAgFgIgAgRAKQgFAGgCAGQgBAIAEAEQAFADAGAAQAHAAAFgDQAGgDADgEIgOgaQgLAHgDACgAAAggQgCACAAADQgBAEABADIAEAKIAKgIQAFgEABgFQABgEgCgDQgCgDgFAAQgHAAgDAFg",
      );
    this.shape_2.setTransform(-26.3536, 57.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AARAuIAAgDIABgHIACgQQACgIgGgEQgDgCgIABIgcAAIgIAnIgNAAIAUhcIAqAAQALAAAGADQAMAHgDAQQgCAIgFAFQgEAFgHACQAFADACAEQACADgCAIIgCANIgBAHQAAAFADABIAAACgAgUgDIAcAAQAJAAAGgEQAFgDACgJQADgLgHgDQgDgCgHAAIgeAAg",
      );
    this.shape_3.setTransform(-34.794, 57.3);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgIALQAEgBADgGIACgEIAAgBIAAgBIgGAAIACgOIAOAAIgEANQgBAHgEAGQgEAFgIACg",
      );
    this.shape_4.setTransform(-45.9, 62.225);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_5.setTransform(-52.4429, 58.475);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgIAmg",
      );
    this.shape_6.setTransform(-59.45, 58.475);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgCIASgBQAEgBACgDIABgEQACgGgEgDQgEgCgHAAQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_7.setTransform(-65.8188, 58.6);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_8.setTransform(-72.9679, 57.275);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_9.setTransform(-80.4137, 59.825);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_10.setTransform(-87.2529, 58.575);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgNIAMAAIgDANg");
    this.shape_11.setTransform(-91.925, 57.3);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAuIAUhcIAoAAQAQAAAEAKQADAGgBAIQgCAIgGAGIgJAGQAGACADACQAGAHgCAKQgCAKgIAGQgLALgRAAgAgaAjIAbAAQALAAAHgGQAEgEABgHQACgKgIgDQgFgCgIAAIgYAAgAgQgHIAVAAQAIAAAGgCQAHgDACgJQACgJgHgEQgDgBgJAAIgWAAg",
      );
    this.shape_12.setTransform(-97.9, 57.3);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_13.setTransform(-10.5, 42.675);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_14.setTransform(-16.7029, 42.775);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_15.setTransform(-21.5321, 41.85);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgJADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgHgDgEQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgEADgIIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_16.setTransform(-26.985, 42.75);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgKAEgQQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAFgBAHQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgIgBgEQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_17.setTransform(-33.9792, 42.8);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAJAAIgBAMQABgEAHgFQAGgFAGAAIABAAIADABIgDAMIgCgBIgBAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_18.setTransform(-39.3, 42.675);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_19.setTransform(-42.975, 41.5);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAPgIALQgPAWgXAAgAgcAkIAWAAIAKgCQAIgCAGgHQAFgGAEgIIADgKQADgRgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_20.setTransform(-49.262, 41.5);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIArQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_21.setTransform(-58.9321, 41.85);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgJADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgHgDgEQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgEADgIIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_22.setTransform(-64.385, 42.75);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgfAZQgCgFACgJIAKgtIALAAIgJAsQgBAFABAEQABAFAJAAQALAAAGgKQAEgGACgJIAHghIAMAAIgPBDIgLAAIADgKIgHAHQgHAFgJAAQgPAAgDgKg",
      );
    this.shape_23.setTransform(-71.1875, 42.85);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AggAnQgGgKADgQQADgOAKgLQAKgLANAAQAIAAAFADIAFAHIAHgiIALAAIgTBdIgLAAIACgKQgFAHgFACQgGADgHAAQgMAAgGgJgAgNgGQgHAGgDAMQgCALADAHQADAIAKAAQAIAAAGgHQAGgHADgMQADgNgEgFQgEgHgIAAQgHABgHAGg",
      );
    this.shape_24.setTransform(-78.2113, 41.6);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_25.setTransform(-85.8029, 42.775);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAHgFAHAAIABAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_26.setTransform(-91.1, 42.675);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgpAvIAUhdIApAAQAMABAGAGQAGAIgCAMQgDALgIAIQgJAHgOAAIgcAAIgJAogAgSgDIAYAAQAJABAGgEQAGgEACgJQACgKgHgEQgEgCgHAAIgYAAg",
      );
    this.shape_27.setTransform(-97.6632, 41.5);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_28.setTransform(79.775, -4.2);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALAAQAHAAAFgDQAGgCAAgHQAAgEgFgDIgLgDIgIgDQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAKQAGAFgBAIIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_29.setTransform(74.35, -7.05);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_30.setTransform(68.85, -8.075);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_31.setTransform(63.275, -7.075);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_32.setTransform(53.425, -7.2);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_33.setTransform(45.675, -7.2);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJAMQgJALgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgJgDgHQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_34.setTransform(39, -7.1);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_35.setTransform(33.275, -8.55);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_36.setTransform(25.5, -8.075);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_37.setTransform(19.775, -7.2);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_38.setTransform(11.975, -7.075);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_39.setTransform(6.225, -7.2);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_40.setTransform(-0.425, -7.075);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_41.setTransform(-6.175, -8.55);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgDQADgHAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_42.setTransform(-9.775, -8.55);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_43.setTransform(-13.275, -8.475);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_44.setTransform(-18.925, -8.375);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_45.setTransform(-30.35, -7.1);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_46.setTransform(-36.15, -8.075);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_47.setTransform(-41.875, -7.2);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_48.setTransform(-47.325, -8.475);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_49.setTransform(-54.7, -8.075);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_50.setTransform(-60.5, -7);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJAMQgJALgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_51.setTransform(-68.25, -7.1);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_52.setTransform(-79.625, -7.075);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_53.setTransform(-85.65, -8.075);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_54.setTransform(-91.225, -7.075);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_55.setTransform(-99.375, -8.375);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_56.setTransform(90.275, -24);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgwIANAAIAAAvQAAAGABADQADAGAJAAQALAAAFgLQADgGgBgKIAAgjIANAAIAABHIgMAAIAAgKQgCAEgDADQgHAFgJAAQgQAAgFgKg",
      );
    this.shape_57.setTransform(83.6, -23.8);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_58.setTransform(75.85, -23.9);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIADgIIgbhJIAOAAIATA6IAUg6IAOAAIgMAfIgMAeQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_59.setTransform(68.55, -22.4);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_60.setTransform(59.2, -24.875);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_61.setTransform(53.425, -23.875);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_62.setTransform(45.45, -22.425);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAATQAAAQgJALQgJAMgQAAQgQAAgIgKgAgQgSQgEAIgBALQABAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_63.setTransform(34.05, -23.9);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_64.setTransform(28.25, -24.875);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAGALABQAHAAAFgEQAGgDgBgGQAAgFgDgCIgLgEIgKgCQgJgCgEgCQgJgFAAgJQABgLAHgFQAIgHAMAAQAQAAAIAJQAEAHAAAHIgMAAQAAgEgCgDQgFgFgKgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEABALQAAAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_65.setTransform(19.05, -23.85);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_66.setTransform(11.825, -23.875);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhHIAOAAIAOA4IAOg4IANAAIAPA3IAPg3IAMAAIgVBHg");
    this.shape_67.setTransform(2.7, -23.9);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_68.setTransform(-8.15, -24.875);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_69.setTransform(-11.575, -25.275);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgLIAFABIACAAIAGgBIACgCIACgGIAEgIIgbhJIANAAIATA6IAUg6IANAAIgLAfIgMAeQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_70.setTransform(-20.45, -22.4);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAGALABQAHAAAFgEQAGgDAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgDgDQgDgFgLgBQgGAAgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQgBAJgHAHQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_71.setTransform(-27.45, -23.85);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_72.setTransform(-34.675, -23.875);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_73.setTransform(-42.625, -23.875);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgMAAIgVhHIANAAIAOA4IAOg4IANAAIAOA3IAPg3IAMAAIgVBHg");
    this.shape_74.setTransform(-55.4, -23.9);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_75.setTransform(-64.35, -23.9);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_76.setTransform(-72.025, -25.3);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_77.setTransform(-83.875, -25.175);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_78.setTransform(-91.375, -24);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_79.setTransform(-98.975, -23.875);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_80.setTransform(93.825, -40.675);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_81.setTransform(86.525, -40.725);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_82.setTransform(79.125, -40.8);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_83.setTransform(71.325, -40.675);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_84.setTransform(65.925, -42.075);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_85.setTransform(60.925, -40.725);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgEgDIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgFgCgDQgEgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_86.setTransform(53.9, -40.65);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_87.setTransform(42.625, -40.675);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_88.setTransform(34.925, -42.1);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_89.setTransform(29.05, -41.675);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgIgFgBgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgEAFgFADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_90.setTransform(19.2, -39.225);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_91.setTransform(11.725, -40.8);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_92.setTransform(6.275, -42.075);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_93.setTransform(0.875, -40.8);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_94.setTransform(-6.875, -40.8);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAGACADQAEAHAIgBQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgEADQgHAFgIABQgQAAgFgLg",
      );
    this.shape_95.setTransform(-14.7, -40.6);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCgBIgCAAQgKABgEAFQgFAHAAAIIAAAog",
      );
    this.shape_96.setTransform(-20.425, -40.8);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgMIAFABIACAAIAFgBIADgDIADgFIADgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgEAGQgDAGgMABg",
      );
    this.shape_97.setTransform(-30.5, -39.2);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_98.setTransform(-35.55, -42.075);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_99.setTransform(-38.65, -42.075);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_100.setTransform(-43.925, -40.675);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQABAGABADQADAHAJgBQAMAAAEgLQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEADQgGAFgKABQgOAAgGgLg",
      );
    this.shape_101.setTransform(-51.9, -40.6);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_102.setTransform(-57.7, -41.675);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_103.setTransform(-63.025, -40.725);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_104.setTransform(-70.275, -40.675);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGADADQAEAHALgBQAHAAAFgCQAGgEgBgGQAAgEgDgDIgLgEIgJgCQgKgCgFgCQgIgFAAgJQABgKAHgHQAHgGANAAQAQAAAIAKQAEAFAAAIIgMAAQAAgFgCgDQgFgEgKAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFABAKQAAAKgIAGQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_105.setTransform(-81.65, -40.65);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_106.setTransform(-88.875, -40.675);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_107.setTransform(-98, -40.7);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p("AgMBAIAAgKIAOAAIAAhrIgOAAIAAgKIAZAAIAAB/g");
    this.shape_108.setTransform(83.325, -57.525);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAIIAAAqg",
      );
    this.shape_109.setTransform(79.775, -57.6);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_110.setTransform(73.125, -57.475);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_111.setTransform(67.3, -58.475);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_112.setTransform(61.575, -57.6);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_113.setTransform(53.775, -57.475);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAqQgQgOAAgcQAAgWAMgOQAMgQAVAAQAUAAAJAKQALAKABANIgNAAQgCgKgHgFQgHgGgMAAQgNAAgJAKQgJALAAAUQAAASAIALQAJALAOAAQAPAAAIgMQAEgGACgKIANAAQgCAQgKALQgLANgUAAQgQAAgMgLg",
      );
    this.shape_114.setTransform(44.85, -58.875);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_115.setTransform(31.875, -58.775);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgEAGAAQAPAAAGAMQADAGAAAKIAAAvg",
      );
    this.shape_116.setTransform(24.375, -57.6);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_117.setTransform(16.775, -57.475);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_118.setTransform(6.925, -57.6);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgHgDgCQgEgDgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgEAHAAQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_119.setTransform(-4.725, -57.6);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_120.setTransform(-14.5, -57.5);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcAqQgPgOAAgcQAAgWAMgOQAMgQAWAAQASAAAKAKQALAKABANIgNAAQgCgKgHgFQgGgGgMAAQgOAAgJAKQgJALAAAUQAAASAIALQAIALAQAAQAOAAAIgMQAEgGACgKIANAAQgBAQgLALQgLANgUAAQgRAAgMgLg",
      );
    this.shape_121.setTransform(-23.4, -58.875);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_122.setTransform(-35.25, -58.875);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAqQgQgOAAgcQAAgWAMgOQANgQAUAAQAUAAAJAKQALAKABANIgNAAQgCgKgHgFQgHgGgMAAQgNAAgJAKQgJALAAAUQAAASAIALQAJALAOAAQAPAAAIgMQAEgGACgKIANAAQgCAQgJALQgMANgVAAQgPAAgMgLg",
      );
    this.shape_123.setTransform(-44.6, -58.875);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_124.setTransform(-54, -58.875);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p("AgMBAIAAh/IAZAAIAAAKIgNAAIAABrIANAAIAAAKg");
    this.shape_125.setTransform(-60.55, -57.525);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_126.setTransform(-68.6, -58.475);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_127.setTransform(-72.025, -58.875);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgMAAIgWhIIAOAAIAOA4IAOg4IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_128.setTransform(-82.5, -57.5);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAOAAAKAJQAKAKAAASQAAARgJAMQgIALgSAAQgOAAgJgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgJgEgHQgEgKgNAAQgKAAgFAIg",
      );
    this.shape_129.setTransform(-91.45, -57.5);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQAAAGAMQADAGAAAJIAAAwg",
      );
    this.shape_130.setTransform(-99.125, -58.9);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_131.setTransform(100.975, -71.4);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_132.setTransform(97.125, -71.4);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics.f("#31353B").s().p("AgGAHIAAgOIANAAIAAAOg");
    this.shape_133.setTransform(93.275, -71.4);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAgtQAAgIgCgDQgDgHgJABQgHAAgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQAAAGALQADAFAAALIAAAug",
      );
    this.shape_134.setTransform(87.475, -75.7);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_135.setTransform(81.6, -75.275);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_136.setTransform(78.175, -75.675);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhHIAOAAIAOA4IAOg4IANAAIAPA3IAPg3IAMAAIgVBHg");
    this.shape_137.setTransform(71.55, -74.3);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_138.setTransform(58.575, -75.575);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhHIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAApg",
      );
    this.shape_139.setTransform(53.025, -74.4);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_140.setTransform(46.575, -74.275);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIABALQgBAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_141.setTransform(38.6, -74.3);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_142.setTransform(31.075, -75.575);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_143.setTransform(19.325, -74.4);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_144.setTransform(11.5, -74.3);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_145.setTransform(1.85, -75.275);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_146.setTransform(-3.925, -74.275);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_147.setTransform(-11.9, -72.825);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgsQAAgIgCgDQgDgIgIABIgHAAQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhHIAMAAIAAAJQAFgFAGgEQAGgCAGAAQAPAAAGALQADAFAAAMIAAAtg",
      );
    this.shape_148.setTransform(-23.225, -74.4);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_149.setTransform(-30.825, -74.275);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_150.setTransform(-38.325, -74.325);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_151.setTransform(-49.625, -74.275);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_152.setTransform(-55, -75.675);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_153.setTransform(-60.275, -72.95);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_154.setTransform(-68.25, -74.3);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_155.setTransform(-75.975, -74.275);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAGAAALQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_156.setTransform(-83.525, -72.95);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgDQADgHAMAAIADAAIACAAIAAALIgCAAIgCAAQgGABgBADQgBACAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_157.setTransform(-93.325, -75.75);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_158.setTransform(-99.2, -74.3);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_159.setTransform(101.75, -92.075);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKAAQAMAAAEgJQAFgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_160.setTransform(95.95, -91.1);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_161.setTransform(90.6, -92.475);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_162.setTransform(81.475, -91.075);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_163.setTransform(71.6, -92.075);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_164.setTransform(66.025, -91.075);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_165.setTransform(58.125, -92.5);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_166.setTransform(52.25, -92.075);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAEAFAJAAQAOAAAEgKQACgGABgPQgEAFgFADQgFADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_167.setTransform(42.4, -89.625);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgFQgDgHgIAAIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPAAAGALQADAHAAAKIAAAug",
      );
    this.shape_168.setTransform(34.925, -91.2);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_169.setTransform(29.475, -92.475);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_170.setTransform(24.075, -92.5);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_171.setTransform(18.2, -92.075);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_172.setTransform(12.425, -91.075);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgFgIgBQgHABgFAFQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgEQAFgDAHAAQAPAAAFALQADAGAAAKIAAAvg",
      );
    this.shape_173.setTransform(2.775, -91.2);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_174.setTransform(-7, -91.1);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAHALgBQAHAAAFgCQAGgEAAgGQAAgEgFgDIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAGAFgBAIIgMAAQAAgFgDgDQgDgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_175.setTransform(-14.3, -91.05);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALgBQAHAAAFgCQAFgEAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_176.setTransform(-25.15, -91.05);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_177.setTransform(-30.225, -92.475);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p("AAoAHIAAgNIAOAAIAAANgAgGAHIAAgNIANAAIAAANgAg1AHIAAgNIAPAAIAAANg");
    this.shape_178.setTransform(-38.775, -88.2);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_179.setTransform(-49.475, -91.075);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_180.setTransform(-57.425, -91.075);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_181.setTransform(-65.375, -92.375);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_182.setTransform(-70.575, -92.475);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_183.setTransform(-79.875, -91.075);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgFADgDQAGgEAIAAQAQAAAGALQADAHAAAJIAAAvg",
      );
    this.shape_184.setTransform(-87.575, -92.5);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_187.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_187).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote03testimonialGSK01,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote02testimonialConsumergoods01 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AAlBNIgmh0IgoB0IgJAAIgWhNIgPg2IgDgGIgFgFIgHgCIgGgCIAAgHIA+AAIAAAHIgOACQgGABAAADIABADIAAADIAJAfIATBAIAlhwIAKAAIAnBzIANguIAJgiIADgOIABgGQAAgEgFgCQgFgDgLgBIAAgHIA3AAIAAAHIgGACIgHADQgDACgDADQgCADgCAGIgSA5IgVBGg",
      );
    this.shape.setTransform(-95.375, -125.275);

    this.instance_1 = new lib.Logo_ConsumerGoodsCompanyLogo();
    this.instance_1.setTransform(56.7, 99.05, 0.7684, 0.7684);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_1.setTransform(3.4321, 60.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_2.setTransform(-3.6529, 61.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_3.setTransform(-8.325, 59.8);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_4.setTransform(-13.3923, 61.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_5.setTransform(-17.675, 59.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p("AgUAiIgLhDIAOAAIAGA2IAeg2IAMAAIgmBDg");
    this.shape_6.setTransform(-21.95, 61.05);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_7.setTransform(-27.025, 59.8);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAuIAUhbIAkAAQAUAAAHANQAHAMgEAUQgDAOgIAMQgPAUgXAAgAgcAkIAWAAIAKgBQAIgDAGgHQAFgGAEgJIADgKQADgQgFgJQgEgKgQAAIgVAAg",
      );
    this.shape_8.setTransform(-33.312, 59.8);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_9.setTransform(-45.3292, 61.1);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAPhDIAKAAIgCAMQABgEAHgFQAFgFAHAAIABAAIADABIgDAMIgBgBIgCAAQgJAAgGAGQgEAFgCAIIgJAmg",
      );
    this.shape_10.setTransform(-50.65, 60.975);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgCQALgFACgLIACgIIgGABg",
      );
    this.shape_11.setTransform(-57.0188, 61.1);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgEgIAAQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAFQgJAHgLAAQgOAAgFgJg",
      );
    this.shape_12.setTransform(-63.535, 61.05);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAvIAJgrQABgHgBgDQgCgGgIAAQgHAAgGAFQgHAFgDANIgHAkIgMAAIAUhdIALAAIgHAjIAIgHQAGgEAIAAQAPAAADAKQACAGgCAJIgJAsg",
      );
    this.shape_13.setTransform(-70.6679, 59.775);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACACIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_14.setTransform(-75.3821, 60.15);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics.f("#949EA7").s().p("AgPAuIAThbIAMAAIgTBbg");
    this.shape_15.setTransform(-78.825, 59.8);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgFACgKQACgJAHgFQAHgEAKgBIASgCQAEgBACgDIABgEQACgGgEgDQgEgDgHAAQgIABgFAFQgDACgBAGIgLAAQADgNAJgFQAJgFAJAAQAMAAAHAFQAGAEgCAJIgIAnIAAACQAAABAAAAQAAAAABABQAAAAABAAQAAAAABAAIABgBIACAAIgBAJIgFABIgDAAQgGAAgCgEQgBgDAAgEQgEAFgHADQgHAEgIAAQgJAAgFgGgAALABIgGACIgHABQgGAAgEACQgFADgCAGQgBAFADADQADADAFAAQAGAAAFgCQALgFACgLIACgIIgGABg",
      );
    this.shape_16.setTransform(-84.3688, 61.1);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgUQgGAHgCAIIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAFg",
      );
    this.shape_17.setTransform(-91.3792, 61.1);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p("AAPAuIAJgrIgwAAIgJArIgNAAIAUhbIANAAIgIAmIAvAAIAIgmIANAAIgUBbg");
    this.shape_18.setTransform(-99.3, 59.8);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_19.setTransform(-56.6321, 44.35);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_20.setTransform(-62.2923, 45.275);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_21.setTransform(-66.575, 44);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_22.setTransform(-69.5821, 44.35);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_23.setTransform(-75.6679, 45.175);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_24.setTransform(-82.7292, 45.3);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-87.425, 44);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgHgDgDQgCgEgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_26.setTransform(-92.285, 45.25);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiApQgIgKADgPIAMAAQgBAIACAGQAFAIAPABQAHAAAGgDQAMgDACgKQACgIgEgDQgEgEgKgCIgLgDQgMgCgEgDQgIgGACgMQADgMAKgIQALgIAPAAQAOAAAJAHQAJAHgDAPIgMAAQAAgHgCgEQgEgHgOAAQgKAAgGAFQgGAEgBAHQgCAGAFADQAEACALAEIANADQAJABAEAEQAIAGgDANQgDAPgNAGQgNAHgOAAQgRAAgIgIg",
      );
    this.shape_27.setTransform(-99.7787, 44);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_28.setTransform(68.075, -1.7);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#31353B")
      .s()
      .p(
        "AgeAyIA2hjIAHAAIg1BjgAARApQgHgHAAgKQAAgKAHgHQAHgHAKAAQAKAAAGAHQAHAHAAAKQAAAKgHAHQgGAGgKAAQgKAAgHgGgAAYAOQgEAEAAAGQAAAGAEAEQAEAEAGAAQAFAAAFgEQAEgEAAgGQAAgGgEgEQgFgFgFAAQgGAAgEAFgAgxgGQgHgHAAgJQAAgLAHgGQAHgIAKABQAJgBAHAIQAHAGAAALQAAAJgHAHQgHAGgJAAQgKAAgHgGgAgqghQgFAFAAAGQAAAFAFAFQAEADAGAAQAFAAAFgDQAEgFAAgFQAAgGgEgFQgFgEgFAAQgGAAgEAEg",
      );
    this.shape_29.setTransform(59.925, -5.7);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_30.setTransform(49.825, -5.725);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWArQgKgHgBgOIANAAQABAKAJAEQAEACAGAAQAKAAAFgHQAFgHAAgIQAAgKgGgGQgGgEgIAAQgGAAgFACQgEACgEAEIgKgBIAHgzIAyAAIAAALIgpAAIgEAcIAHgEQAFgDAGAAQAOAAAJAJQAKAIAAANQAAAOgJALQgIAKgSAAQgMAAgJgGg",
      );
    this.shape_31.setTransform(42.075, -5.625);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#31353B")
      .s()
      .p("AAFAxIAAhFIgWAAIAAgJQANgBAEgDQAGgDACgMIAKAAIAABhg");
    this.shape_32.setTransform(33.65, -5.825);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAIQAFAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_33.setTransform(22.7, -4.6);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_34.setTransform(16.9, -5.575);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_35.setTransform(9.2, -5.575);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_36.setTransform(3.625, -4.575);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_37.setTransform(-4.275, -6);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_38.setTransform(-10.15, -5.575);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgFQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAnIgNAAIAAhkIANAAIAAAmQAEgGADgBQAGgFAIAAQAQABAGAKQADAGAAAKIAAAvg",
      );
    this.shape_39.setTransform(-19.725, -6);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALgBQAHAAAFgCQAGgDgBgHQAAgEgEgDIgKgDIgJgDQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAKQAFAFAAAIIgMAAQAAgEgCgEQgEgEgLAAQgGgBgEADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQAAAKgIAGQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_40.setTransform(-27.1, -4.55);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQgBAGACADQAEAHAIgBQALABAFgMQACgGAAgKIAAgkIANAAIAABIIgMAAIABgLQgDAFgDACQgIAGgJABQgOAAgGgLg",
      );
    this.shape_41.setTransform(-34.55, -4.5);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_42.setTransform(-42.075, -3.25);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_43.setTransform(-54.075, -5.875);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_44.setTransform(-59.25, -5.975);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQABAGABADQAEAHAIgBQAMABAEgMQACgGABgKIAAgkIAMAAIAABIIgMAAIAAgLQgCAFgEACQgGAGgKABQgPAAgFgLg",
      );
    this.shape_45.setTransform(-64.75, -4.5);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgFgKgNAAQgKAAgGAIg",
      );
    this.shape_46.setTransform(-72.5, -4.6);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_47.setTransform(-79.775, -4.625);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_48.setTransform(-91.075, -4.575);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_49.setTransform(-100, -4.6);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_50.setTransform(100.325, -22.675);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_51.setTransform(92.575, -21.375);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_52.setTransform(87, -22.775);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_53.setTransform(77.475, -22.675);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQAAAFACAEQAEAGAIABQAMAAAEgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgEACQgHAHgIgBQgQAAgFgKg",
      );
    this.shape_54.setTransform(69.9, -21.3);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgGAJg",
      );
    this.shape_55.setTransform(62.15, -21.4);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_56.setTransform(56.8, -22.775);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_57.setTransform(51.775, -21.425);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_58.setTransform(40.475, -21.375);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_59.setTransform(32.775, -22.8);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_60.setTransform(26.9, -22.375);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_61.setTransform(17.325, -22.8);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_62.setTransform(11.45, -22.375);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_63.setTransform(8.025, -22.775);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgNAAIgUhIIANAAIAOA4IAOg4IANAAIAOA3IAPg3IAMAAIgVBIg");
    this.shape_64.setTransform(1.4, -21.4);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_65.setTransform(-9.45, -22.375);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIAMAAIAAAvQABAFABAEQAEAGAIABQAMAAAEgMQACgGABgKIAAgjIAMAAIAABIIgMAAIAAgLQgCAEgEACQgGAHgKgBQgPAAgFgKg",
      );
    this.shape_66.setTransform(-15.25, -21.3);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_67.setTransform(-22.775, -22.675);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AgeAyIA2hjIAHAAIg1BjgAARAoQgHgHAAgKQAAgJAHgHQAHgHAKAAQAKAAAGAHQAHAHAAAJQAAAKgHAHQgGAIgKAAQgKAAgHgIgAAYANQgEAFAAAFQAAAHAEADQAEAFAGAAQAFAAAFgFQAEgDAAgHQAAgFgEgFQgFgDgFAAQgGAAgEADgAgxgGQgHgGAAgKQAAgKAHgIQAHgHAKAAQAJAAAHAHQAHAIAAAKQAAAKgHAGQgHAGgJAAQgKAAgHgGgAgqggQgFADAAAHQAAAFAFAEQAEAEAGAAQAFAAAFgEQAEgEAAgFQAAgHgEgDQgFgFgFAAQgGAAgEAFg",
      );
    this.shape_68.setTransform(-36.875, -22.5);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_69.setTransform(-46.975, -22.525);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_70.setTransform(-54.725, -22.525);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p("AAFAxIAAhFIgWAAIAAgJQANgBAFgDQAFgDADgMIAJAAIAABhg");
    this.shape_71.setTransform(-63.15, -22.625);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_72.setTransform(-72.15, -22.375);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAFABAEQADAGAJABQALAAAFgMQADgGgBgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgDACQgHAHgJgBQgQAAgFgKg",
      );
    this.shape_73.setTransform(-77.95, -21.3);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAATQAAAQgJAMQgJALgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgEgHQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_74.setTransform(-85.7, -21.4);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_75.setTransform(-93.225, -22.675);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_76.setTransform(-100.975, -21.375);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_77.setTransform(67, -39.175);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_78.setTransform(61.425, -38.175);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA4IAQg4IALAAIgUBIg");
    this.shape_79.setTransform(48.45, -38.2);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_80.setTransform(39.5, -38.2);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_81.setTransform(31.825, -38.3);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_82.setTransform(22.1, -39.175);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_83.setTransform(16.375, -39.6);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFAAgLIAMAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_84.setTransform(8.35, -36.725);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_85.setTransform(3.175, -39.575);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_86.setTransform(-0.275, -38.3);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgIgFgBgLIANAAQABAFADACQAEAFAIAAQANAAAFgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgLAAgJgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgFAMg",
      );
    this.shape_87.setTransform(-11, -36.725);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgDQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgCAGAAQAPgBAGALQADAGAAAMIAAAtg",
      );
    this.shape_88.setTransform(-18.475, -38.3);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_89.setTransform(-23.925, -39.575);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_90.setTransform(-27.45, -39.175);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_91.setTransform(-33.025, -38.175);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_92.setTransform(-38.975, -38.3);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_93.setTransform(-45.625, -38.175);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAHAAAKQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_94.setTransform(-53.175, -36.85);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgEgGQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_95.setTransform(-61.15, -38.2);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_96.setTransform(-72.725, -38.175);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAFAAAIIAAApg",
      );
    this.shape_97.setTransform(-78.475, -38.3);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAEgBADgEQAAgDAAgEIAAgBIAAgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_98.setTransform(-82.4, -42.825);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_99.setTransform(-88.225, -38.175);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p("AAXAyIgXhSIgXBSIgNAAIgbhjIAPAAIASBQIAYhQIANAAIAXBRIAThRIAPAAIgaBjg");
    this.shape_100.setTransform(-98.35, -39.575);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics.f("#31353B").s().p("AgGAHIAAgNIANAAIAAANg");
    this.shape_101.setTransform(93.625, -52.1);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_102.setTransform(88.625, -56.375);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_103.setTransform(82.775, -55.1);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_104.setTransform(76.1, -55);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p("AAPAkIgPg3IgOA3IgNAAIgUhIIANAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_105.setTransform(67.2, -55);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_106.setTransform(56.425, -55.1);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_107.setTransform(49.975, -54.975);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_108.setTransform(44.4, -56.375);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIANAAIAAAwQgBAGACADQADAHAJgBQALABAFgMQADgGAAgKIAAgkIAMAAIAABIIgMAAIABgLQgDAFgEACQgHAGgJABQgOAAgGgLg",
      );
    this.shape_109.setTransform(38.9, -54.9);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFADACQAEAFAIAAQAOAAAEgKQADgGAAgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAIAAAHAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgIgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgFgHgJAAQgMAAgEAMg",
      );
    this.shape_110.setTransform(30.95, -53.525);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_111.setTransform(23.425, -54.975);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_112.setTransform(17.675, -55.1);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_113.setTransform(9.175, -55.1);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQADAHAJgBQALABAFgMQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDACQgIAGgIABQgQAAgFgLg",
      );
    this.shape_114.setTransform(2.5, -54.9);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_115.setTransform(-5.25, -55);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFADACQADAFAJAAQANAAAFgKQACgGAAgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAIAAAGAEIAHAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQAMAAAGgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_116.setTransform(-17.05, -53.525);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_117.setTransform(-24.525, -55.1);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_118.setTransform(-29.975, -56.375);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAASQAAARgJALQgIAMgSAAQgPAAgIgKgAgPgTQgGAJAAALQAAAMAGAIQAFAHAKABQAMgBAEgIQAFgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_119.setTransform(-35.45, -55);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_120.setTransform(-43.375, -56.275);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_121.setTransform(-52.775, -56.45);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_122.setTransform(-58.65, -55);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAKQAIAJAAASQAAAWgMALQgIAGgLAAQgHABgGgEIgHgHIAAAlgAgRgcQgCAIAAAKQAAAIACAGQAFALAMgBQAIABAGgIQAGgGAAgOQAAgJgDgGQgFgMgMAAQgMAAgFAMg",
      );
    this.shape_123.setTransform(-70.025, -53.65);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgQgTQgEAJgBALQABAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgDgGQgGgKgMAAQgKAAgGAIg",
      );
    this.shape_124.setTransform(-78, -55);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQABAEACABIAFABIABAAIADgBIAAAKIgEABg",
      );
    this.shape_125.setTransform(-83.8, -55.975);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_126.setTransform(-93.375, -55.1);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_127.setTransform(-101.2, -55);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgDQAFgDAAgGQAAgFgDgCIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAGgBAIIgLAAQAAgEgDgDQgFgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_128.setTransform(81.95, -71.75);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_129.setTransform(74.725, -71.775);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgNAAIgUhIIANAAIAOA4IAOg4IANAAIAPA3IAOg3IANAAIgWBIg");
    this.shape_130.setTransform(65.6, -71.8);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_131.setTransform(54.75, -72.775);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_132.setTransform(49.175, -71.775);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_133.setTransform(41.275, -73.2);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_134.setTransform(35.4, -72.775);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_135.setTransform(25.575, -73.075);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_136.setTransform(18.075, -71.9);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_137.setTransform(10.475, -71.775);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQAFgBABgHIABgFIAAAAIgBgBIgGAAIAAgPIAOAAIAAAOQAAAHgEAGQgEAHgGABg",
      );
    this.shape_138.setTransform(0.65, -67.85);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAANIAAAoIgNAAIAAhkIANAAIAAAlQAEgFADgCQAGgEAIgBQAQAAAGAMQADAFAAALIAAAvg",
      );
    this.shape_139.setTransform(-5.125, -73.2);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_140.setTransform(-11, -72.775);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_141.setTransform(-16.725, -71.9);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAPAAQANAAAKAJQAKAKAAATQAAAQgJAMQgJALgQAAQgQAAgIgKgAgPgSQgFAIgBALQABAMAFAHQAFAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_142.setTransform(-24.55, -71.8);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_143.setTransform(-34.175, -71.9);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_144.setTransform(-47.575, -71.775);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_145.setTransform(-57.45, -72.775);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQgBAFACAEQADAGAJABQALAAAFgMQADgGAAgKIAAgjIAMAAIAABIIgMAAIABgLQgDAEgEACQgHAHgJgBQgOAAgGgKg",
      );
    this.shape_146.setTransform(-63.25, -71.7);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAKgLQAIgLAQAAQAOAAAJAJQAKAKAAATQAAAQgJAMQgIALgSAAQgPAAgIgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKAAQAMAAAEgJQAFgKAAgKQAAgKgDgHQgGgKgMAAQgKAAgFAJg",
      );
    this.shape_147.setTransform(-71, -71.8);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_148.setTransform(-78.525, -73.075);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_149.setTransform(-86.275, -71.775);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_150.setTransform(-98.025, -71.9);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_151.setTransform(-103.475, -73.175);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_152.setTransform(99.95, -88.55);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_153.setTransform(92.525, -88.575);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_154.setTransform(87.15, -89.975);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAHAAAKQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_155.setTransform(81.875, -87.25);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_156.setTransform(72.025, -88.7);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_157.setTransform(62.475, -88.575);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIALAAQABAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgDgDQgFgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgHAIgQAAQgPAAgHgIg",
      );
    this.shape_158.setTransform(54.95, -88.55);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_159.setTransform(43.675, -89.725);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_160.setTransform(35.925, -89.725);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgaAjQgHgNAAgVQAAgQAEgMQAIgWAVAAQATAAAIAQQAHAMAAAVQAAATgGANQgJASgTAAQgRAAgJgPgAgPgcQgFAKAAATQAAAPAEAJQAFAOALAAQAJAAAGgIQAFgJAAgWQAAgRgEgKQgEgLgMAAQgKAAgFAKg",
      );
    this.shape_161.setTransform(28.175, -89.725);

    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGALQAEAAACgHIAAgEIAAgBIAAgBIgGAAIAAgPIANAAIAAAOQABAHgEAGQgEAGgGACg",
      );
    this.shape_162.setTransform(22.4, -84.65);

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics
      .f("#31353B")
      .s()
      .p(
        "AghAxQABgNAEgJQAFgKANgHIAMgIQAJgDAEgFQAFgFAAgIQAAgIgFgFQgFgFgJAAQgLAAgFAJQgDAFAAAKIgMAAQAAgNAEgIQAIgOATAAQARAAAIAJQAIAJAAALQAAAMgIAHQgFAFgNAHIgIAFIgLAHQgGAGgCAHIA0AAIAAAMg",
      );
    this.shape_163.setTransform(16.575, -89.85);

    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_164.setTransform(6.9, -89.575);

    this.shape_165 = new cjs.Shape();
    this.shape_165.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGADADQAEAHALAAQAHAAAFgEQAFgDABgGQAAgEgFgDIgLgEIgJgCQgJgCgFgCQgHgFAAgJQgBgKAIgHQAHgGANAAQARAAAGAJQAGAHgBAHIgLAAQgBgFgDgDQgEgEgJgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAHQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_165.setTransform(1.55, -88.55);

    this.shape_166 = new cjs.Shape();
    this.shape_166.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAOAAAKAKQAKAJAAATQAAAQgJALQgIAMgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgLgDgGQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_166.setTransform(-5.9, -88.6);

    this.shape_167 = new cjs.Shape();
    this.shape_167.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgyQAAgGgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgFAIABQAIgBAGAFQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_167.setTransform(-15.525, -88.7);

    this.shape_168 = new cjs.Shape();
    this.shape_168.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_168.setTransform(-22.9, -89.975);

    this.shape_169 = new cjs.Shape();
    this.shape_169.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_169.setTransform(-28.175, -88.575);

    this.shape_170 = new cjs.Shape();
    this.shape_170.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_170.setTransform(-38.05, -89.575);

    this.shape_171 = new cjs.Shape();
    this.shape_171.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQADAGAJAAQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgDADQgIAFgIAAQgQAAgFgKg",
      );
    this.shape_171.setTransform(-43.85, -88.5);

    this.shape_172 = new cjs.Shape();
    this.shape_172.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJALQgJAMgRAAQgOAAgJgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAEgKQAFgJAAgKQAAgLgEgGQgEgKgNAAQgKAAgGAJg",
      );
    this.shape_172.setTransform(-51.6, -88.6);

    this.shape_173 = new cjs.Shape();
    this.shape_173.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_173.setTransform(-63.375, -89.875);

    this.shape_174 = new cjs.Shape();
    this.shape_174.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_174.setTransform(-70.925, -88.575);

    this.shape_175 = new cjs.Shape();
    this.shape_175.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgHgCgDQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhjIANAAIAAAlQAEgGADgCQAGgDAIAAQAQgBAGALQADAGAAALIAAAug",
      );
    this.shape_175.setTransform(-78.625, -90);

    this.shape_176 = new cjs.Shape();
    this.shape_176.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALAAQAHAAAFgEQAFgDAAgGQAAgEgDgDIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgFgEgDQgDgEgKgBQgIAAgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAHQgIAIgPAAQgPAAgHgIg",
      );
    this.shape_176.setTransform(-86, -88.55);

    this.shape_177 = new cjs.Shape();
    this.shape_177.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQAEAGAIAAQAMAAAEgLQACgGAAgKIAAgkIANAAIAABIIgMAAIAAgKQgCAEgEADQgHAFgIAAQgQAAgFgKg",
      );
    this.shape_177.setTransform(-93.45, -88.5);

    this.shape_178 = new cjs.Shape();
    this.shape_178.graphics
      .f("#31353B")
      .s()
      .p(
        "AgfA0IAAhlIAMAAIAAAKQADgFAFgDQAGgEAIAAQAMAAAJAJQAIAKAAASQAAAXgMAKQgIAGgLABQgHgBgGgDIgHgHIAAAlgAgRgbQgCAHAAAKQAAAJACAEQAFAMAMAAQAIgBAGgGQAGgIAAgNQAAgJgDgGQgFgMgMAAQgMAAgFANg",
      );
    this.shape_178.setTransform(-100.975, -87.25);

    this.shape_179 = new cjs.Shape();
    this.shape_179.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_179.setTransform(93.925, -105.375);

    this.shape_180 = new cjs.Shape();
    this.shape_180.graphics
      .f("#31353B")
      .s()
      .p("AgGAkIgbhIIAOAAIATA7IAUg7IAOAAIgcBIg");
    this.shape_180.setTransform(86.575, -105.4);

    this.shape_181 = new cjs.Shape();
    this.shape_181.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQABgDABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_181.setTransform(81.9, -110.025);

    this.shape_182 = new cjs.Shape();
    this.shape_182.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_182.setTransform(76.075, -105.375);

    this.shape_183 = new cjs.Shape();
    this.shape_183.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgMAAIgWhIIAOAAIAOA5IAOg5IANAAIAOA5IAQg5IALAAIgUBIg");
    this.shape_183.setTransform(67.15, -105.4);

    this.shape_184 = new cjs.Shape();
    this.shape_184.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_184.setTransform(54.375, -105.375);

    this.shape_185 = new cjs.Shape();
    this.shape_185.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_185.setTransform(47.075, -105.425);

    this.shape_186 = new cjs.Shape();
    this.shape_186.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_186.setTransform(39.675, -105.5);

    this.shape_187 = new cjs.Shape();
    this.shape_187.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_187.setTransform(34.225, -106.775);

    this.shape_188 = new cjs.Shape();
    this.shape_188.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHAAgLIAMAAQAAAGACADQAFAHALgBQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgEgEgEQgDgEgKAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAFAAAKQABAKgIAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_188.setTransform(29.2, -105.35);

    this.shape_189 = new cjs.Shape();
    this.shape_189.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWA0IgEgBIAAgMIAFACIACAAIAGgCIACgDIACgFIAEgHIgbhLIANAAIATA7IAUg7IANAAIgLAhIgLAdQgLAcgDAGQgEAHgMAAg",
      );
    this.shape_189.setTransform(18.35, -103.9);

    this.shape_190 = new cjs.Shape();
    this.shape_190.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_190.setTransform(13.3, -106.775);

    this.shape_191 = new cjs.Shape();
    this.shape_191.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_191.setTransform(9.75, -106.375);

    this.shape_192 = new cjs.Shape();
    this.shape_192.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgHgCgEQgDgGgIgBIgHABQgFACgDAEQgEAEAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgFAGgEQAGgDAGAAQAPABAGAKQADAGAAALIAAAug",
      );
    this.shape_192.setTransform(4.025, -105.5);

    this.shape_193 = new cjs.Shape();
    this.shape_193.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_193.setTransform(-3.775, -105.375);

    this.shape_194 = new cjs.Shape();
    this.shape_194.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_194.setTransform(-9.175, -106.775);

    this.shape_195 = new cjs.Shape();
    this.shape_195.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_195.setTransform(-14.175, -105.425);

    this.shape_196 = new cjs.Shape();
    this.shape_196.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_196.setTransform(-19.275, -106.775);

    this.shape_197 = new cjs.Shape();
    this.shape_197.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_197.setTransform(-22.725, -106.85);

    this.shape_198 = new cjs.Shape();
    this.shape_198.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAALIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_198.setTransform(-26.325, -106.85);

    this.shape_199 = new cjs.Shape();
    this.shape_199.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_199.setTransform(-32.175, -105.375);

    this.shape_200 = new cjs.Shape();
    this.shape_200.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_200.setTransform(-43.775, -105.375);

    this.shape_201 = new cjs.Shape();
    this.shape_201.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_201.setTransform(-49.525, -105.5);

    this.shape_202 = new cjs.Shape();
    this.shape_202.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAJgLQAKgLAOAAQAPAAAJAJQAKAKAAASQAAARgJALQgIAMgRAAQgQAAgIgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAFgIQAEgKAAgLQAAgKgEgGQgFgKgMAAQgKAAgGAIg",
      );
    this.shape_202.setTransform(-56.2, -105.4);

    this.shape_203 = new cjs.Shape();
    this.shape_203.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgIgDgCQgEgDgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAgvQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAGAAANIAAAmIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIgBQAIABAGAEQACADACAEQAEgGAGgDQAFgDAHAAQAPABAFAKQADAGAAAKIAAAvg",
      );
    this.shape_203.setTransform(-65.825, -105.5);

    this.shape_204 = new cjs.Shape();
    this.shape_204.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_204.setTransform(-78.575, -106.775);

    this.shape_205 = new cjs.Shape();
    this.shape_205.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAHAAAIIAAAog",
      );
    this.shape_205.setTransform(-84.425, -105.5);

    this.shape_206 = new cjs.Shape();
    this.shape_206.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgQQAAgSAKgLQAIgLAPAAQAPAAAJAJQAKAKAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAIQAGAHAKABQAMgBAEgIQAFgKAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_206.setTransform(-91.1, -105.4);

    this.shape_207 = new cjs.Shape();
    this.shape_207.graphics
      .f("#31353B")
      .s()
      .p("AAOAkIgOg3IgOA3IgNAAIgVhIIAOAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBIg");
    this.shape_207.setTransform(-100, -105.4);

    this.shape_208 = new cjs.Shape();
    this.shape_208.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_208.setTransform(96.325, -122.175);

    this.shape_209 = new cjs.Shape();
    this.shape_209.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgMAAIgWhIIAOAAIAOA4IAOg4IANAAIAOA3IAQg3IALAAIgUBIg");
    this.shape_209.setTransform(87.4, -122.2);

    this.shape_210 = new cjs.Shape();
    this.shape_210.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_210.setTransform(74.425, -123.475);

    this.shape_211 = new cjs.Shape();
    this.shape_211.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_211.setTransform(66.875, -122.175);

    this.shape_212 = new cjs.Shape();
    this.shape_212.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_212.setTransform(61.05, -123.175);

    this.shape_213 = new cjs.Shape();
    this.shape_213.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_213.setTransform(55.475, -122.175);

    this.shape_214 = new cjs.Shape();
    this.shape_214.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_214.setTransform(49.525, -122.3);

    this.shape_215 = new cjs.Shape();
    this.shape_215.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_215.setTransform(44.8, -123.175);

    this.shape_216 = new cjs.Shape();
    this.shape_216.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGACAEQAFAFALAAQAHAAAFgDQAFgDABgGQAAgFgFgCIgLgDIgJgDQgJgCgEgCQgIgFAAgJQgBgLAIgFQAIgHAMAAQARAAAGAJQAFAGAAAIIgLAAQAAgEgEgDQgEgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_216.setTransform(39.45, -122.15);

    this.shape_217 = new cjs.Shape();
    this.shape_217.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgHgCgFQgDgGgIAAIgHABQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGgBQAPAAAGAMQADAFAAAMIAAAug",
      );
    this.shape_217.setTransform(32.075, -122.3);

    this.shape_218 = new cjs.Shape();
    this.shape_218.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgRQAAgSAJgLQAKgLAOAAQAOAAAKAJQAKAKAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKAAQAMAAAFgJQAEgKAAgKQAAgKgDgHQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_218.setTransform(24.25, -122.2);

    this.shape_219 = new cjs.Shape();
    this.shape_219.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIABQgHgBgFAGQgGAFAAAOIAAAnIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIAAQAIAAAGAFQACADACAEQAEgFAGgDQAFgDAHgBQAPAAAFAMQADAFAAAKIAAAwg",
      );
    this.shape_219.setTransform(14.625, -122.3);

    this.shape_220 = new cjs.Shape();
    this.shape_220.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_220.setTransform(4.875, -122.175);

    this.shape_221 = new cjs.Shape();
    this.shape_221.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_221.setTransform(-3.075, -123.475);

    this.shape_222 = new cjs.Shape();
    this.shape_222.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgKIAFABIACAAIAGgBIACgEIACgFIAEgIIgbhJIANAAIATA6IAUg6IANAAIgLAfIgLAeQgLAcgDAGQgEAHgMgBg",
      );
    this.shape_222.setTransform(-14.05, -120.7);

    this.shape_223 = new cjs.Shape();
    this.shape_223.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_223.setTransform(-21.675, -123.475);

    this.shape_224 = new cjs.Shape();
    this.shape_224.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_224.setTransform(-29.025, -122.175);

    this.shape_225 = new cjs.Shape();
    this.shape_225.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_225.setTransform(-36.975, -122.175);

    this.shape_226 = new cjs.Shape();
    this.shape_226.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIAAIABAAIADABIAAANIgCAAIgCAAQgKgBgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_226.setTransform(-42.725, -122.3);

    this.shape_227 = new cjs.Shape();
    this.shape_227.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_227.setTransform(-47, -123.575);

    this.shape_228 = new cjs.Shape();
    this.shape_228.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_228.setTransform(-52.275, -122.175);

    this.shape_229 = new cjs.Shape();
    this.shape_229.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_229.setTransform(-64.075, -122.175);

    this.shape_230 = new cjs.Shape();
    this.shape_230.graphics
      .f("#31353B")
      .s()
      .p("AgGAlIgbhIIAOAAIATA6IAUg6IAOAAIgcBIg");
    this.shape_230.setTransform(-71.425, -122.2);

    this.shape_231 = new cjs.Shape();
    this.shape_231.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAEgBADgEQAAgDAAgEIAAgBIAAgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_231.setTransform(-76.1, -126.825);

    this.shape_232 = new cjs.Shape();
    this.shape_232.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_232.setTransform(-81.925, -122.175);

    this.shape_233 = new cjs.Shape();
    this.shape_233.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_234 = new cjs.Shape();
    this.shape_234.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.shape_235 = new cjs.Shape();
    this.shape_235.graphics
      .f()
      .s("#31353B")
      .ss(1, 1, 1)
      .p("AgbiCIA3AAIAAEFIg3AAg");
    this.shape_235.setTransform(143.75, 128.125);

    this.shape_236 = new cjs.Shape();
    this.shape_236.graphics.f("#949EA7").s().p("AgaCDIAAkFIA2AAIAAEFg");
    this.shape_236.setTransform(143.75, 128.125);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_236 },
            { t: this.shape_235 },
            { t: this.shape_234 },
            { t: this.shape_233 },
            { t: this.shape_232 },
            { t: this.shape_231 },
            { t: this.shape_230 },
            { t: this.shape_229 },
            { t: this.shape_228 },
            { t: this.shape_227 },
            { t: this.shape_226 },
            { t: this.shape_225 },
            { t: this.shape_224 },
            { t: this.shape_223 },
            { t: this.shape_222 },
            { t: this.shape_221 },
            { t: this.shape_220 },
            { t: this.shape_219 },
            { t: this.shape_218 },
            { t: this.shape_217 },
            { t: this.shape_216 },
            { t: this.shape_215 },
            { t: this.shape_214 },
            { t: this.shape_213 },
            { t: this.shape_212 },
            { t: this.shape_211 },
            { t: this.shape_210 },
            { t: this.shape_209 },
            { t: this.shape_208 },
            { t: this.shape_207 },
            { t: this.shape_206 },
            { t: this.shape_205 },
            { t: this.shape_204 },
            { t: this.shape_203 },
            { t: this.shape_202 },
            { t: this.shape_201 },
            { t: this.shape_200 },
            { t: this.shape_199 },
            { t: this.shape_198 },
            { t: this.shape_197 },
            { t: this.shape_196 },
            { t: this.shape_195 },
            { t: this.shape_194 },
            { t: this.shape_193 },
            { t: this.shape_192 },
            { t: this.shape_191 },
            { t: this.shape_190 },
            { t: this.shape_189 },
            { t: this.shape_188 },
            { t: this.shape_187 },
            { t: this.shape_186 },
            { t: this.shape_185 },
            { t: this.shape_184 },
            { t: this.shape_183 },
            { t: this.shape_182 },
            { t: this.shape_181 },
            { t: this.shape_180 },
            { t: this.shape_179 },
            { t: this.shape_178 },
            { t: this.shape_177 },
            { t: this.shape_176 },
            { t: this.shape_175 },
            { t: this.shape_174 },
            { t: this.shape_173 },
            { t: this.shape_172 },
            { t: this.shape_171 },
            { t: this.shape_170 },
            { t: this.shape_169 },
            { t: this.shape_168 },
            { t: this.shape_167 },
            { t: this.shape_166 },
            { t: this.shape_165 },
            { t: this.shape_164 },
            { t: this.shape_163 },
            { t: this.shape_162 },
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.instance_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer_3
    this.shape_237 = new cjs.Shape();
    this.shape_237.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_237.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_237).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote02testimonialConsumergoods01,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  (lib.Quote01testimonialBiogen01 = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_3
    this.instance = new lib.quoteSymbol();
    this.instance.setTransform(
      -122.8,
      -181.55,
      1.2873,
      1.2873,
      0,
      0,
      0,
      19.9,
      18.4,
    );

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer_5
    this.instance_1 = new lib.Logo_Biogenbw();
    this.instance_1.setTransform(54.45, 144.55, 0.9023, 0.9006);

    this.shape = new cjs.Shape();
    this.shape.graphics
      .f("#31353B")
      .s()
      .p(
        "AghBMIAAgHIAIgBIAIgBQADgCACgCQACgDAAgEIAAhtQAAgEgCgCQgBgDgEgCIgIgCIgIgCIAAgHIBDAAIAAAHIgIABIgIACQgEABgBADQgCADAAAEIAABtQAAAEACACQACADADACIAIACIAIABIAAAHg",
      );
    this.shape.setTransform(-101.425, -87.175);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_1.setTransform(100.9679, 48.4);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_2.setTransform(94.8821, 49.225);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_3.setTransform(87.8208, 49.35);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_4.setTransform(78.7071, 49.225);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_5.setTransform(72.1679, 48.4);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgXAjIAOhDIAKAAIgBAMQABgEAGgFQAGgFAHAAIACAAIACABIgCAMIgDgBIgCAAQgIAAgFAGQgGAFgBAIIgIAmg",
      );
    this.shape_6.setTransform(68.1, 49.225);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_7.setTransform(61.7312, 49.35);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_8.setTransform(54.3363, 50.575);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_9.setTransform(47.5208, 49.35);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgLQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_10.setTransform(39.388, 48.05);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_11.setTransform(29.7179, 48.4);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_12.setTransform(23.6321, 49.225);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_13.setTransform(16.5708, 49.35);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f("#949EA7")
      .s()
      .p(
        "AAcAjIAKguQACgHgDgDQgDgCgFAAQgHAAgFAEQgGAFgDAKIgIAnIgLAAIAKgsQABgHgBgDQgBgEgHAAQgHAAgGAFQgHAFgCANIgIAjIgLAAIAOhDIALAAIgCAJQAFgFAEgCQAHgEAHAAQAHAAAEAEIAEAHQAFgFAFgDQAGgDAGAAQAOAAADAKQACAFgCAJIgKAtg",
      );
    this.shape_14.setTransform(7.4571, 49.225);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgkAwIAUhdIALAAIgCAJQAFgFADgDQAHgDAIAAQALAAAGAJQAHAIgEARQgFAVgNAKQgJAGgJAAQgHAAgFgEQgDgCgCgEIgIAigAgHgZQgEAGgCAKQgBAIABAEQACALALAAQAIAAAHgHQAGgHADgMQACgIgBgGQgCgLgMAAQgLAAgHAMg",
      );
    this.shape_15.setTransform(-1.8137, 50.575);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAbQgGgKADgQQAEgQALgKQALgKANAAQAOAAAHAJQAHAIgEARQgDAQgKAKQgLALgQAAQgOAAgGgJgAgKgRQgGAIgDAKQgCALADAHQADAHALAAQAKAAAGgIQAGgJACgJQACgKgBgGQgDgJgMAAQgKAAgGAIg",
      );
    this.shape_16.setTransform(-8.6529, 49.325);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_17.setTransform(-13.325, 48.05);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_18.setTransform(-18.6792, 49.35);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f("#949EA7")
      .s()
      .p("AgTAiIgMhDIAOAAIAHA3IAdg3IAMAAIgnBDg");
    this.shape_19.setTransform(-24.8, 49.3);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAbQgHgJAEgRQADgQALgKQALgKAOAAQAHAAAGADQAGAEACAFQADAGgBAGQABAFgDAJIgxAAQgBAKADAHQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAEIgHAIQgHAFgIACIgIABQgNAAgHgJgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_20.setTransform(-32.3792, 49.35);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgrAvIAUhdIAkAAQAUAAAHAOQAHAMgEATQgDAOgIAMQgPAWgXAAgAgcAjIAWAAIAKgBQAIgCAGgHQAFgGAEgIIADgLQADgPgFgKQgEgKgQAAIgVAAg",
      );
    this.shape_21.setTransform(-40.512, 48.05);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_22.setTransform(-50.025, 48.05);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_23.setTransform(-55.5688, 49.35);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAaQgGgKADgOQAEgRAKgKQALgKANAAQALAAAGAGQAGAFgBAOIgLAAQAAgHgDgDQgCgEgIgBQgKAAgHALQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEANgJAHQgJAGgLAAQgOAAgFgKg",
      );
    this.shape_24.setTransform(-62.085, 49.3);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f("#949EA7")
      .s()
      .p("AgPAvIAOhDIALAAIgNBDgAABghIADgNIAMAAIgDANg");
    this.shape_25.setTransform(-66.575, 48.05);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgGIAKgsIgJAAIACgKIAJAAIAEgTIAKAAIgEATIALAAIgCAKIgLAAIgIAqQgBAFACABIAEAAIABAAIADAAIgCAJIgDABg",
      );
    this.shape_26.setTransform(-69.5821, 48.4);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAvIgDAAIACgKIAEABIADAAIAEgBIAEgDIADgFIAEgHIgKhFIANAAIAGA3IAeg3IAMAAIgRAeIgQAbQgPAbgFAFQgFAGgKAAg",
      );
    this.shape_27.setTransform(-75.125, 50.7);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f("#949EA7").s().p("AgPAvIAThdIAMAAIgTBdg");
    this.shape_28.setTransform(-79.525, 48.05);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgcAeQgFgGACgIQACgKAHgFQAHgEAKgCIASgCQAEAAACgDIABgFQACgFgEgDQgEgDgHABQgIAAgFAEQgDADgBAFIgLAAQADgNAJgEQAJgFAJAAQAMAAAHAEQAGAFgCAKIgIAmIAAADQAAAAAAAAQAAAAABABQAAAAABAAQAAAAABAAIABAAIACAAIgBAIIgFABIgDAAQgGAAgCgEQgBgCAAgEQgEAEgHADQgHAEgIAAQgJAAgFgGgAALABIgGABIgHABQgGABgEACQgFADgCAHQgBAFADACQADADAFAAQAGAAAFgDQALgEACgLIACgIIgGABg",
      );
    this.shape_29.setTransform(-85.0688, 49.35);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_30.setTransform(-92.2179, 49.225);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f("#949EA7")
      .s()
      .p("AAcAvIgEgdIgjAAIgRAdIgMAAIA2hdIANAAIAPBdgAAXAIIgGgoIgXAoIAdAAg");
    this.shape_31.setTransform(-100.65, 48.05);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_32.setTransform(-56.6321, 32.6);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAdQgFgGACgLIALAAQgBAGACADQADAGALAAQAFAAAGgDQAFgDABgGQABgEgDgCIgJgDIgIgDQgIgCgEgCQgGgEACgIQACgKAIgGQAIgGALAAQAPAAAFAJQADAGgBAGIgLAAQAAgEgCgDQgCgEgKAAQgGAAgDACQgEADgBAEQgBAEAEADIAGADIAHACQALADAEABQAGAFgCAJQgCAJgIAHQgJAGgNAAQgPAAgFgHg",
      );
    this.shape_33.setTransform(-62.2923, 33.525);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_34.setTransform(-66.575, 32.25);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgFAsQgIAAgCgEQgCgEABgHIAKgsIgJAAIACgJIAJAAIAEgTIAKAAIgEATIALAAIgCAJIgLAAIgIAsQgBADACABIAEABIABAAIADAAIgCAJIgDABg",
      );
    this.shape_35.setTransform(-69.5821, 32.6);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f("#949EA7")
      .s()
      .p(
        "AALAjIAJgqQABgGgBgEQgBgGgIAAIgHAAQgEACgFAEQgDADgCAEIgDAKIgHAjIgMAAIAPhDIAKAAIgCAJQAGgGAFgCQAGgDAHAAQAOAAADAKQACAGgCAKIgJArg",
      );
    this.shape_36.setTransform(-75.6679, 33.425);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgbAaQgHgIAEgRQADgPALgLQALgKAOAAQAHAAAGAEQAGADACAFQADAGgBAGQABAFgDAJIgxAAQgBALADAGQADAGAKAAQAIAAAGgGIAGgIIALAAQgBAEgDAFIgHAHQgHAFgIACIgIABQgNAAgHgKgAgIgTQgGAFgCAJIAkAAQABgHgBgFQgDgIgLAAQgHAAgHAGg",
      );
    this.shape_37.setTransform(-82.7292, 33.55);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f("#949EA7")
      .s()
      .p("AgPAuIAOhCIALAAIgNBCgAABghIADgMIAMAAIgDAMg");
    this.shape_38.setTransform(-87.425, 32.25);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgaAbQgGgKADgPQAEgRAKgKQALgKANAAQALAAAGAFQAGAGgBAOIgLAAQAAgGgDgFQgCgDgIAAQgKAAgHAKQgFAHgCAJQgCAKADAHQACAHAKAAQAGAAAFgEQAFgFADgHIALAAQgEAOgJAGQgJAGgLAAQgOAAgFgJg",
      );
    this.shape_39.setTransform(-92.285, 33.5);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f("#949EA7")
      .s()
      .p(
        "AgiAoQgIgIADgPIAMAAQgBAHACAFQAFAKAPgBQAHAAAGgBQAMgEACgLQACgHgEgEQgEgDgKgCIgLgDQgMgDgEgCQgIgGACgLQADgNAKgIQALgIAPAAQAOAAAJAHQAJAHgDAQIgMAAQAAgIgCgEQgEgHgOAAQgKAAgGAEQgGAFgBAGQgCAIAFACQAEADALACIANADQAJACAEADQAIAHgDAMQgDAQgNAHQgNAGgOAAQgRAAgIgJg",
      );
    this.shape_40.setTransform(-99.7787, 32.25);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics.f("#31353B").s().p("AgGAIIAAgPIANAAIAAAPg");
    this.shape_41.setTransform(-9.375, -13.45);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgEgHQgFgKgMAAQgKAAgGAJg",
      );
    this.shape_42.setTransform(-15.25, -16.35);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_43.setTransform(-23.175, -17.625);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_44.setTransform(-34.775, -17.625);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_45.setTransform(-39.95, -17.725);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAFABAEQAEAGAIABQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgDACQgIAHgIgBQgPAAgGgKg",
      );
    this.shape_46.setTransform(-45.45, -16.25);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAPAAQAOAAAKAKQAKAJAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_47.setTransform(-53.2, -16.35);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_48.setTransform(-60.475, -16.375);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_49.setTransform(-69.65, -17.725);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_50.setTransform(-77.55, -17.325);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_51.setTransform(-83.125, -16.325);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAguQAAgHgCgFQgDgFgJAAQgHgBgGAGQgGAFAAAOIAAAnIgNAAIAAhkIANAAIAAAlQAEgFADgDQAGgDAIAAQAQAAAGALQADAFAAALIAAAvg",
      );
    this.shape_52.setTransform(-91.025, -17.75);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f("#31353B")
      .s()
      .p("AAOAlIgOg4IgOA4IgNAAIgVhIIAOAAIAOA4IAOg4IANAAIAPA3IAOg3IANAAIgWBIg");
    this.shape_53.setTransform(-100, -16.35);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAPAAQANAAAKAKQAKAJAAASQAAARgJALQgJAMgQAAQgQAAgIgKgAgPgTQgFAJgBALQABAMAFAHQAFAIAKAAQAMAAAFgJQAEgJAAgLQAAgKgDgGQgGgKgMAAQgKAAgFAIg",
      );
    this.shape_54.setTransform(92.9, -33.15);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_55.setTransform(87.1, -34.125);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_56.setTransform(79.4, -34.125);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_57.setTransform(75.975, -34.525);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgHgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIAAQAIAAAGAEQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_58.setTransform(68.625, -33.25);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_59.setTransform(61.225, -34.525);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_60.setTransform(58.15, -34.525);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_61.setTransform(49.025, -33.125);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIANAAQAAAGACADQAFAHALAAQAHAAAFgDQAFgEABgGQAAgFgFgCIgLgEIgJgCQgJgCgEgCQgIgFAAgJQgBgKAIgHQAIgGAMAAQARAAAGAJQAFAHAAAHIgLAAQAAgFgEgDQgEgEgJAAQgIAAgDACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFgBAKQAAAKgHAGQgIAIgOAAQgQAAgHgIg",
      );
    this.shape_62.setTransform(37.65, -33.1);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQAEgBABgEQABgDAAgEIAAgBIAAgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_63.setTransform(33.2, -37.775);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_64.setTransform(27.375, -33.125);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_65.setTransform(21.625, -33.25);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_66.setTransform(14.975, -33.125);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_67.setTransform(7.275, -34.55);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_68.setTransform(1.4, -34.125);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f("#31353B")
      .s()
      .p("AAOAyIgWglIgKAKIAAAbIgLAAIAAhjIALAAIAAA5IAfgeIAQAAIgdAaIAeAug");
    this.shape_69.setTransform(-7.375, -34.525);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_70.setTransform(-15.175, -33.25);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_71.setTransform(-20.625, -34.525);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_72.setTransform(-26.025, -34.55);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQAAAEACABIAFABIACAAIACgBIAAAKIgFABg",
      );
    this.shape_73.setTransform(-31.9, -34.125);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgCIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgbhKIAPAAIASA7IAUg7IAOAAIgMAhIgMAdQgKAcgEAHQgEAFgKABg",
      );
    this.shape_74.setTransform(-41.1, -31.65);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_75.setTransform(-46.15, -34.525);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_76.setTransform(-49.25, -34.525);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_77.setTransform(-54.525, -33.125);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_78.setTransform(-62.475, -33.125);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_79.setTransform(-68.225, -33.25);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_80.setTransform(-76.8, -34.125);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBABgEQABgDAAgEIAAgBIAAgBIgHAAIAAgPIAOAAIAAAOQAAAIgDAGQgEAGgHABg",
      );
    this.shape_81.setTransform(-79.85, -37.775);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_82.setTransform(-85.625, -33.25);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAPAAAJAKQAKAJAAASQAAARgJALQgJAMgRAAQgOAAgJgKgAgQgTQgEAJAAALQAAAMAEAHQAGAIAKAAQAMAAAEgJQAFgJAAgLQAAgKgEgGQgEgKgNAAQgKAAgGAIg",
      );
    this.shape_83.setTransform(-93.45, -33.15);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_84.setTransform(-101.375, -34.425);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_85.setTransform(83.75, -51.325);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f("#31353B")
      .s()
      .p("AgfAyIAAhjIAOAAIAABXIAxAAIAAAMg");
    this.shape_86.setTransform(74.85, -51.325);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f("#31353B")
      .s()
      .p(
        "AgcAqQgPgOAAgcQAAgWAMgOQAMgQAWAAQASAAALAKQAKAKABANIgNAAQgCgKgHgFQgHgGgLAAQgOAAgJAKQgJALAAAUQAAASAIALQAIALAQAAQAOAAAIgMQAEgGACgKIANAAQgBAQgKALQgMANgVAAQgPAAgNgLg",
      );
    this.shape_87.setTransform(65.5, -51.325);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f("#31353B")
      .s()
      .p("AgkAyIAAhjIBIAAIAAAMIg7AAIAAAfIA2AAIAAAKIg2AAIAAAiIA8AAIAAAMg");
    this.shape_88.setTransform(56.1, -51.325);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f("#31353B")
      .s()
      .p(
        "AgUAvQgHgFgCgLIANAAQABAFACACQAFAFAIAAQANAAAFgKQACgGABgPQgFAFgEADQgGADgHAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLAMAAQAJAAAFAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgHAPgVAAQgLAAgJgGgAgPgdQgDAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgEAMg",
      );
    this.shape_89.setTransform(43.2, -48.475);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAguQAAgGgCgFQgDgGgIgBIgHACQgFABgDAEQgEAEAAAEIgBALIAAAmIgNAAIAAhJIAMAAIAAALQAFgHAGgCQAGgEAGAAQAPABAGAKQADAHAAAKIAAAvg",
      );
    this.shape_90.setTransform(35.725, -50.05);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_91.setTransform(30.275, -51.325);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGACAEQAFAFALAAQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgDgDQgFgEgJAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_92.setTransform(25.25, -49.9);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgFAAgKIAAgxIAMAAIAAAwQAAAGACADQADAHAJAAQALAAAFgMQADgGgBgKIAAgkIANAAIAABJIgMAAIAAgMQgCAFgDACQgIAHgIAAQgQAAgFgLg",
      );
    this.shape_93.setTransform(17.8, -49.85);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgyQAAgIgDgCQgEgDgFAAQgHAAgGAEQgFAFAAAMIAAAqIgLAAIAAgwQAAgGgCgEQgDgGgIAAQgHAAgFAGQgGAFAAAOIAAAnIgMAAIAAhJIAMAAIAAALIAIgIQAGgEAIgBQAIABAGAEQACACACAFQAEgFAGgDQAFgEAHAAQAPABAFAKQADAGAAAKIAAAwg",
      );
    this.shape_94.setTransform(4.325, -50.05);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAMQADgBACgEQABgDABgEIAAgBIgBgBIgGAAIAAgPIANAAIAAAOQAAAIgDAGQgEAGgGABg",
      );
    this.shape_95.setTransform(-2.7, -54.575);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_96.setTransform(-6.4, -51.325);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgLQAAgIADgEQADgGAMAAIADAAIACABIAAAKIgCAAIgCAAQgGAAgBADQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_97.setTransform(-14.225, -51.4);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_98.setTransform(-17.725, -51.325);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALAAQAHAAAFgCQAFgDAAgHQAAgEgDgDIgMgDIgJgDQgJgCgEgCQgJgFABgJQAAgKAHgHQAIgGAMAAQAQAAAIAKQAFAFgBAIIgLAAQAAgFgEgDQgDgEgKAAQgIgBgDADQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAIQgIAHgPAAQgPAAgHgHg",
      );
    this.shape_99.setTransform(-26.6, -49.9);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_100.setTransform(-33.825, -49.925);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_101.setTransform(-41.775, -49.925);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhJIAMAAIAAANQABgEAFgFQAFgFAIgBIABAAIADABIAAANIgCAAIgCAAQgKAAgEAFQgFAGAAAJIAAApg",
      );
    this.shape_102.setTransform(-47.525, -50.05);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_103.setTransform(-54.175, -49.925);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAzIAAgvQAAgHgCgEQgDgFgJgBQgHAAgGAGQgGAFAAANIAAAoIgNAAIAAhlIANAAIAAAmQAEgFADgCQAGgFAIAAQAQABAGAKQADAHAAAJIAAAwg",
      );
    this.shape_104.setTransform(-61.875, -51.35);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgNAAIgUhJIANAAIAOA5IAOg5IANAAIAPA5IAOg5IANAAIgWBJg");
    this.shape_105.setTransform(-70.85, -49.95);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAGgCABgFIAAgGIAAAAIAAgBIgHAAIAAgPIAOAAIAAAOQAAAHgDAGQgDAGgIACg",
      );
    this.shape_106.setTransform(-81.65, -46);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgBIAAgLIAFABIADAAIAEgBIADgEIADgFIACgHIgbhLIAPAAIASA7IAUg7IAOAAIgMAgIgMAeQgKAcgEAGQgDAHgLAAg",
      );
    this.shape_107.setTransform(-86, -48.45);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_108.setTransform(-93.225, -49.925);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAqQgJgLAAgRQAAgPAIgMQAIgLAPAAQAHAAAGADQADACAEAFIAAglIAMAAIAABkIgLAAIAAgKQgEAHgGADQgGADgGAAQgNAAgIgKgAgNgGQgFAGAAANQAAAMAFAIQAEAIAKAAQAJAAAFgHQAGgIAAgNQAAgNgGgHQgFgHgJAAQgIAAgGAIg",
      );
    this.shape_109.setTransform(-101.375, -51.225);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_110.setTransform(95.125, -66.725);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIAMAAQAAAGACAEQAFAFALABQAHgBAFgDQAFgDAAgGQAAgFgDgCIgMgEIgJgCQgJgCgEgCQgJgFABgJQAAgLAHgFQAIgHAMAAQAQAAAIAJQAFAHgBAHIgLAAQAAgEgDgDQgFgGgJAAQgIABgDACQgEADAAAEQAAAFAFADIAIADIAIACQANADAFACQAGAEAAALQABAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_111.setTransform(83.75, -66.7);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAzIgEgBIAAgKIAFAAIACAAIAGAAIACgDIACgGIAEgIIgbhJIANAAIATA6IAUg6IANAAIgLAfIgMAeQgKAcgDAHQgFAFgLAAg",
      );
    this.shape_112.setTransform(76.75, -65.25);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_113.setTransform(69.525, -66.725);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIAAgLIALAAQABAGADAEQAEAFALABQAHgBAFgDQAGgDgBgGQAAgFgDgCIgLgEIgJgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAFAHAAAHIgMAAQAAgEgCgDQgEgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEAAALQAAAJgIAIQgHAHgQAAQgPAAgHgHg",
      );
    this.shape_114.setTransform(62, -66.7);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAgQgHgIgBgLIANAAQAAAGADAEQAEAFALABQAHgBAFgDQAGgDAAgGQAAgFgFgCIgLgEIgIgCQgKgCgFgCQgHgFgBgJQAAgLAIgFQAHgHANAAQARAAAGAJQAGAHgBAHIgMAAQAAgEgDgDQgDgGgLAAQgGABgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAEgBALQAAAJgHAIQgIAHgOAAQgQAAgHgHg",
      );
    this.shape_115.setTransform(55, -66.7);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_116.setTransform(47.775, -66.725);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAJgLQAKgLAOAAQAOAAAKAKQAKAJAAATQAAAQgJAMQgIALgRAAQgQAAgIgKgAgQgSQgEAIAAALQAAAMAEAHQAGAJAKgBQAMABAFgKQAEgJAAgKQAAgKgDgHQgFgKgNAAQgKAAgGAJg",
      );
    this.shape_117.setTransform(35.95, -66.75);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f("#31353B")
      .s()
      .p("AAPAlIgPg4IgOA4IgNAAIgUhIIANAAIAOA4IAOg4IANAAIAOA3IAPg3IAMAAIgVBIg");
    this.shape_118.setTransform(27.05, -66.75);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIAMAAIAAAUIALAAIAAAKIgLAAIAAAvQgBAEADABIAFABIACAAIACgBIAAAKIgEABg",
      );
    this.shape_119.setTransform(20.05, -67.725);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_120.setTransform(10.425, -66.725);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_121.setTransform(2.875, -68.025);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAzIgDgBIAAgKIAFAAIADAAIAEAAIADgDIADgGIACgIIgbhJIAPAAIASA6IAUg6IAOAAIgMAfIgMAeQgKAcgEAHQgEAFgKAAg",
      );
    this.shape_122.setTransform(-4.65, -65.25);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_123.setTransform(-11.875, -66.725);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAmIAAgzQAAgGgDgEQgEgCgFAAQgHAAgGAEQgFAGAAALIAAAqIgLAAIAAgvQAAgIgCgDQgDgGgIABQgHgBgFAGQgGAFAAAPIAAAmIgMAAIAAhIIAMAAIAAAKIAIgIQAGgFAIABQAIgBAGAFQACADACAEQAEgFAGgDQAFgDAHAAQAPAAAFALQADAFAAAKIAAAwg",
      );
    this.shape_124.setTransform(-21.725, -66.85);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_125.setTransform(-35.325, -66.725);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_126.setTransform(-43.025, -66.85);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f("#31353B")
      .s()
      .p(
        "AgYAdQgJgLAAgRQAAgRAKgLQAIgLAQAAQAOAAAJAKQAKAJAAATQAAAQgJAMQgIALgSAAQgOAAgJgKgAgPgSQgGAIAAALQAAAMAGAHQAFAJAKgBQAMABAEgKQAFgJAAgKQAAgKgEgHQgEgKgNAAQgKAAgFAJg",
      );
    this.shape_127.setTransform(-50.85, -66.75);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_128.setTransform(-62.375, -66.85);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgwIANAAIAAAvQAAAFABAEQAEAGAIABQALAAAFgMQACgGAAgKIAAgjIANAAIAABIIgMAAIAAgLQgCAEgDACQgIAHgIgBQgPAAgGgKg",
      );
    this.shape_129.setTransform(-70.2, -66.65);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAmIAAhIIAMAAIAAAMQABgEAFgFQAFgGAIABIABAAIADAAIAAANIgCgBIgCAAQgKAAgEAHQgFAGAAAHIAAAqg",
      );
    this.shape_130.setTransform(-75.925, -66.85);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAmIAAgtQAAgIgCgDQgDgIgIABIgHABQgFABgDAFQgEADAAAEIgBALIAAAmIgNAAIAAhIIAMAAIAAAKQAFgHAGgCQAGgDAGAAQAPAAAGALQADAFAAAMIAAAug",
      );
    this.shape_131.setTransform(-86.375, -66.85);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_132.setTransform(-93.975, -66.725);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAcQgIgKAAgQQAAgSAJgLQAKgLANAAQAMAAAIAGQAIAGABAPIgLAAQgCgHgDgEQgEgFgJAAQgLAAgFAMQgDAHAAAKQAAALAFAIQAEAHAJAAQAIAAAEgEQAFgFACgIIALAAQgCAOgIAHQgIAHgNAAQgNAAgJgLg",
      );
    this.shape_133.setTransform(-101.475, -66.775);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_134.setTransform(100.6, -84.925);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_135.setTransform(92.775, -85);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_136.setTransform(89.3, -84.925);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_137.setTransform(83.825, -83.525);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f("#31353B")
      .s()
      .p(
        "AgWAfQgHgHgBgLIAMAAQABAGADADQAEAHALAAQAHAAAFgDQAGgEAAgGQgBgFgEgCIgKgEIgJgCQgKgCgFgCQgHgFgBgJQAAgKAIgHQAHgGANAAQARAAAGAJQAFAHAAAHIgMAAQAAgFgDgDQgDgEgLAAQgGAAgEACQgEADAAAEQAAAFAFADIAIADIAHACQAOADAEACQAIAFAAAKQgBAKgHAGQgHAIgPAAQgQAAgHgIg",
      );
    this.shape_138.setTransform(76.5, -83.5);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXA0IgDgCIAAgLIAFABIADAAIAEgBIADgCIADgGIACgIIgahKIAOAAIASA7IAUg7IANAAIgLAhIgLAdQgLAcgEAHQgEAFgKABg",
      );
    this.shape_139.setTransform(69.5, -82.05);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgHgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIAAQAIAAAGAEQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_140.setTransform(60.175, -83.65);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f("#31353B")
      .s()
      .p(
        "AgNAwQgDgDgEgFIAAAJIgLAAIAAhkIAMAAIAAAlQAEgFAFgDQAGgDAGAAQANAAAJAKQAIAJAAARQAAASgIALQgIAMgPAAQgIAAgGgEgAgOgIQgGAHAAANQAAAKADAHQAEAMANAAQAKAAAFgIQAFgIAAgNQAAgMgFgGQgFgIgKAAQgHAAgHAGg",
      );
    this.shape_141.setTransform(46.775, -84.825);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f("#31353B")
      .s()
      .p(
        "AgbAhQgHgHAAgJQAAgKAHgGQAGgEAKgCIATgCQAEgBACgDIABgEQAAgHgFgCQgEgDgIAAQgJAAgEAFQgDADAAAFIgMAAQABgNAIgFQAIgGAMAAQALAAAIAFQAIAFAAAKIAAAqIABADIAEABIABAAIADAAIAAAJIgFABIgEAAQgGAAgDgFIgCgGQgEAEgHAEQgGAEgJAAQgKAAgGgGgAAIABIgHACIgGABQgHABgDACQgGADAAAHQAAAFAEADQAEADAFAAQAHAAAFgDQAKgFAAgLIAAgJIgGABg",
      );
    this.shape_142.setTransform(39.025, -83.525);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics.f("#31353B").s().p("AgFAyIAAhjIALAAIAABjg");
    this.shape_143.setTransform(33.45, -84.925);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f("#31353B")
      .s()
      .p(
        "AgXAdQgJgKAAgSQAAgRAJgLQAKgLAOAAQAIAAAHAEQAHAEAEAGQAEAFABAHQABAGAAAKIg0AAQAAALAFAGQAFAHAJAAQAKAAAFgGQAEgEABgFIAMAAQAAAEgDAFQgDAFgDADQgGAGgIACIgJABQgOAAgJgKgAAUgFQAAgIgDgFQgFgJgMAAQgHAAgGAGQgGAGAAAKIAnAAIAAAAg",
      );
    this.shape_144.setTransform(24.125, -83.525);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAyIAAguQAAgGgCgEQgDgHgJAAQgHABgGAFQgGAFAAAOIAAAmIgNAAIAAhkIANAAIAAAmQAEgGADgCQAGgDAIAAQAQgBAGALQADAHAAAJIAAAvg",
      );
    this.shape_145.setTransform(16.425, -84.95);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_146.setTransform(10.55, -84.525);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_147.setTransform(0.975, -83.65);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_148.setTransform(-4.475, -84.925);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f("#31353B")
      .s()
      .p(
        "AAIAvQgIAAgDgEQgDgEAAgHIAAgwIgKAAIAAgKIAKAAIAAgUIALAAIAAAUIAMAAIAAAKIgMAAIAAAvQAAAEADABIAFABIABAAIADgBIAAAKIgFABg",
      );
    this.shape_149.setTransform(-11.85, -84.525);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_150.setTransform(-15.275, -84.925);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics
      .f("#31353B")
      .s()
      .p(
        "AgTAvQgJgFAAgLIAMAAQABAFACACQAFAFAIAAQAOAAAEgKQADgGgBgPQgDAFgGADQgEADgIAAQgMAAgJgJQgJgIAAgTQAAgSAJgKQAJgLANAAQAHAAAGAEIAIAHIAAgJIALAAIAABCQAAAOgEAIQgIAPgUAAQgMAAgHgGgAgQgdQgCAHAAAKQAAAMAFAGQAFAHAIAAQANAAAFgMQADgGAAgJQAAgOgGgGQgGgHgIAAQgMAAgFAMg",
      );
    this.shape_151.setTransform(-24.8, -82.075);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_152.setTransform(-32.275, -83.65);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f("#31353B")
      .s()
      .p("AgFAyIAAhIIALAAIAABIgAgFgjIAAgOIALAAIAAAOg");
    this.shape_153.setTransform(-37.725, -84.925);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_154.setTransform(-43.125, -83.65);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f("#31353B")
      .s()
      .p(
        "AARAlIAAgtQAAgGgCgEQgDgIgIAAIgHABQgFACgDAFQgEADAAAEIgBALIAAAlIgNAAIAAhIIAMAAIAAAKQAFgGAGgDQAGgCAGAAQAPgBAGALQADAHAAAKIAAAug",
      );
    this.shape_155.setTransform(-50.875, -83.65);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f("#31353B")
      .s()
      .p(
        "AgZAbQgDgGAAgJIAAgxIAMAAIAAAwQAAAFACAEQADAGAJAAQALAAAFgLQADgGgBgKIAAgkIANAAIAABIIgMAAIAAgLQgCAFgDADQgIAFgIAAQgQABgFgLg",
      );
    this.shape_156.setTransform(-58.7, -83.45);

    this.shape_157 = new cjs.Shape();
    this.shape_157.graphics
      .f("#31353B")
      .s()
      .p(
        "AgRAlIAAhIIAMAAIAAANQABgEAFgFQAFgFAIAAIABAAIADAAIAAANIgCgBIgCAAQgKABgEAFQgFAGAAAJIAAAog",
      );
    this.shape_157.setTransform(-64.425, -83.65);

    this.shape_158 = new cjs.Shape();
    this.shape_158.graphics
      .f("#31353B")
      .s()
      .p(
        "AAkAlIAAgxQAAgHgDgEQgEgCgFAAQgHAAgGAFQgFAEAAAMIAAApIgLAAIAAguQAAgIgCgDQgDgFgIgBQgHABgFAFQgGAGAAAOIAAAlIgMAAIAAhIIAMAAIAAAKIAIgHQAGgEAIAAQAIAAAGAEQACACACAFQAEgGAGgDQAFgCAHAAQAPgBAFALQADAGAAAKIAAAvg",
      );
    this.shape_158.setTransform(-76.825, -83.65);

    this.shape_159 = new cjs.Shape();
    this.shape_159.graphics
      .f("#31353B")
      .s()
      .p(
        "AgHAMQAFgBACgEQABgDAAgEIAAgBIgBgBIgHAAIAAgPIAPAAIAAAOQAAAIgFAGQgDAGgHABg",
      );
    this.shape_159.setTransform(-83.85, -88.175);

    this.shape_160 = new cjs.Shape();
    this.shape_160.graphics.f("#31353B").s().p("AgGAyIAAhjIANAAIAABjg");
    this.shape_160.setTransform(-87.55, -84.925);

    this.shape_161 = new cjs.Shape();
    this.shape_161.graphics
      .f("#31353B")
      .s()
      .p(
        "AgGAzIAAg+IgKAAIAAgKIAKAAIAAgMQAAgHADgEQADgGAMAAIADAAIACAAIAAAMIgCAAIgCAAQgGAAgBACQgBADAAAMIAMAAIAAAKIgMAAIAAA+g",
      );
    this.shape_161.setTransform(-95.375, -85);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_161 },
            { t: this.shape_160 },
            { t: this.shape_159 },
            { t: this.shape_158 },
            { t: this.shape_157 },
            { t: this.shape_156 },
            { t: this.shape_155 },
            { t: this.shape_154 },
            { t: this.shape_153 },
            { t: this.shape_152 },
            { t: this.shape_151 },
            { t: this.shape_150 },
            { t: this.shape_149 },
            { t: this.shape_148 },
            { t: this.shape_147 },
            { t: this.shape_146 },
            { t: this.shape_145 },
            { t: this.shape_144 },
            { t: this.shape_143 },
            { t: this.shape_142 },
            { t: this.shape_141 },
            { t: this.shape_140 },
            { t: this.shape_139 },
            { t: this.shape_138 },
            { t: this.shape_137 },
            { t: this.shape_136 },
            { t: this.shape_135 },
            { t: this.shape_134 },
            { t: this.shape_133 },
            { t: this.shape_132 },
            { t: this.shape_131 },
            { t: this.shape_130 },
            { t: this.shape_129 },
            { t: this.shape_128 },
            { t: this.shape_127 },
            { t: this.shape_126 },
            { t: this.shape_125 },
            { t: this.shape_124 },
            { t: this.shape_123 },
            { t: this.shape_122 },
            { t: this.shape_121 },
            { t: this.shape_120 },
            { t: this.shape_119 },
            { t: this.shape_118 },
            { t: this.shape_117 },
            { t: this.shape_116 },
            { t: this.shape_115 },
            { t: this.shape_114 },
            { t: this.shape_113 },
            { t: this.shape_112 },
            { t: this.shape_111 },
            { t: this.shape_110 },
            { t: this.shape_109 },
            { t: this.shape_108 },
            { t: this.shape_107 },
            { t: this.shape_106 },
            { t: this.shape_105 },
            { t: this.shape_104 },
            { t: this.shape_103 },
            { t: this.shape_102 },
            { t: this.shape_101 },
            { t: this.shape_100 },
            { t: this.shape_99 },
            { t: this.shape_98 },
            { t: this.shape_97 },
            { t: this.shape_96 },
            { t: this.shape_95 },
            { t: this.shape_94 },
            { t: this.shape_93 },
            { t: this.shape_92 },
            { t: this.shape_91 },
            { t: this.shape_90 },
            { t: this.shape_89 },
            { t: this.shape_88 },
            { t: this.shape_87 },
            { t: this.shape_86 },
            { t: this.shape_85 },
            { t: this.shape_84 },
            { t: this.shape_83 },
            { t: this.shape_82 },
            { t: this.shape_81 },
            { t: this.shape_80 },
            { t: this.shape_79 },
            { t: this.shape_78 },
            { t: this.shape_77 },
            { t: this.shape_76 },
            { t: this.shape_75 },
            { t: this.shape_74 },
            { t: this.shape_73 },
            { t: this.shape_72 },
            { t: this.shape_71 },
            { t: this.shape_70 },
            { t: this.shape_69 },
            { t: this.shape_68 },
            { t: this.shape_67 },
            { t: this.shape_66 },
            { t: this.shape_65 },
            { t: this.shape_64 },
            { t: this.shape_63 },
            { t: this.shape_62 },
            { t: this.shape_61 },
            { t: this.shape_60 },
            { t: this.shape_59 },
            { t: this.shape_58 },
            { t: this.shape_57 },
            { t: this.shape_56 },
            { t: this.shape_55 },
            { t: this.shape_54 },
            { t: this.shape_53 },
            { t: this.shape_52 },
            { t: this.shape_51 },
            { t: this.shape_50 },
            { t: this.shape_49 },
            { t: this.shape_48 },
            { t: this.shape_47 },
            { t: this.shape_46 },
            { t: this.shape_45 },
            { t: this.shape_44 },
            { t: this.shape_43 },
            { t: this.shape_42 },
            { t: this.shape_41 },
            { t: this.shape_40 },
            { t: this.shape_39 },
            { t: this.shape_38 },
            { t: this.shape_37 },
            { t: this.shape_36 },
            { t: this.shape_35 },
            { t: this.shape_34 },
            { t: this.shape_33 },
            { t: this.shape_32 },
            { t: this.shape_31 },
            { t: this.shape_30 },
            { t: this.shape_29 },
            { t: this.shape_28 },
            { t: this.shape_27 },
            { t: this.shape_26 },
            { t: this.shape_25 },
            { t: this.shape_24 },
            { t: this.shape_23 },
            { t: this.shape_22 },
            { t: this.shape_21 },
            { t: this.shape_20 },
            { t: this.shape_19 },
            { t: this.shape_18 },
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.instance_1 },
          ],
        })
        .wait(1),
    );

    // Layer_2
    this.shape_162 = new cjs.Shape();
    this.shape_162.graphics
      .f()
      .s("#CCCCCC")
      .ss(1, 0, 1)
      .p("AXS+AMAAAA8BMgujAAAMAAAg8Bg");

    this.shape_163 = new cjs.Shape();
    this.shape_163.graphics.f("#FFFFFF").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_163 }, { t: this.shape_162 }] })
        .wait(1),
    );

    // Layer_4
    this.shape_164 = new cjs.Shape();
    this.shape_164.graphics.f("#F2F4F5").s().p("A3ReBMAAAg8BMAujAAAMAAAA8Bg");
    this.shape_164.setTransform(4.85, 4.85);

    this.timeline.addTween(cjs.Tween.get(this.shape_164).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Quote01testimonialBiogen01,
    new cjs.Rectangle(-150.3, -207.2, 304.20000000000005, 404.1),
    null,
  );

  // stage content:
  (lib.TestimonialAnimation = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = {};
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Quote01
    this.instance = new lib.Quote01testimonialBiogen01();
    this.instance.setTransform(1244.9, 225.75, 0.661, 0.661, 0, 0, 0, 0.2, 0.2);
    this.instance.alpha = 0;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(85)
        .to({ scaleY: 0.7581, x: 1013.05 }, 0)
        .to(
          {
            regX: 0.5,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 1011.1,
            y: 225.9,
          },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(54)
        .to({ scaleX: 0.9966, scaleY: 0.9964 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.75,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9 }, 2)
        .wait(78)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          7,
        )
        .wait(2)
        .to({ _off: true }, 65)
        .wait(950),
    );

    // Quote02
    this.instance_1 = new lib.Quote02testimonialConsumergoods01();
    this.instance_1.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_1.alpha = 0;
    this.instance_1._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_1)
        .wait(97)
        .to({ _off: false }, 0)
        .to({ x: 1248.9 }, 2)
        .to({ scaleX: 0.7415, scaleY: 0.7413, x: 1011.05, alpha: 1 }, 8)
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(54)
        .to({ x: 1013.3 }, 0)
        .to(
          {
            regX: 0.6,
            regY: 0.6,
            scaleX: 0.7418,
            scaleY: 0.741,
            x: 1011.9,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regX: 0.1,
            regY: -0.1,
            scaleX: 0.9966,
            scaleY: 0.9963,
            x: 720,
            y: 219.05,
          },
          8,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 1.0134,
            scaleY: 1.0134,
            x: 719.95,
            y: 219.1,
          },
          2,
        )
        .wait(78)
        .to({ scaleY: 1.0133, x: 720, y: 219.15 }, 0)
        .to(
          { regX: 0.1, regY: 0.1, scaleX: 0.9966, scaleY: 0.9964, y: 219.1 },
          2,
        )
        .to(
          { regY: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.9, y: 225.75 },
          7,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 427.95 }, 2)
        .wait(65)
        .to({ regX: 0.1, x: 427.9 }, 0)
        .to({ regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.95 }, 2)
        .to({ scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 102)
        .wait(836),
    );

    // Quote03
    this.instance_2 = new lib.Quote03testimonialGSK01();
    this.instance_2.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_2.alpha = 0;
    this.instance_2._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_2)
        .wait(163)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          8,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(78)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          7,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(65)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(102)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          8,
        )
        .wait(2)
        .to({ _off: true }, 64)
        .wait(760),
    );

    // Quote04
    this.instance_3 = new lib.Quote04testimonialBiogen02();
    this.instance_3.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_3.alpha = 0;
    this.instance_3._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_3)
        .wait(253)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          7,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(65)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(102)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(64)
        .to({ x: 427.95 }, 2)
        .to({ regX: 0.2, scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 57)
        .wait(691),
    );

    // Quote05
    this.instance_4 = new lib.Quote05testimonialConsumergoods03();
    this.instance_4.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_4.alpha = 0;
    this.instance_4._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_4)
        .wait(329)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          8,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(102)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(64)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(57)
        .to({ scaleX: 0.7415, scaleY: 0.7412, x: 430.9 }, 2)
        .to({ regX: 0.2, scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 114)
        .wait(565),
    );

    // Quote06
    this.instance_5 = new lib.Quote06testimonialGSK02();
    this.instance_5.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_5.alpha = 0;
    this.instance_5._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_5)
        .wait(443)
        .to({ _off: false }, 0)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(64)
        .to({ scaleY: 0.7581, x: 1013.05 }, 0)
        .to(
          {
            regX: 0.5,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 1011.1,
            y: 225.9,
          },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(57)
        .to({ scaleX: 0.9966, scaleY: 0.9964 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.75,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9 }, 2)
        .wait(114)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          8,
        )
        .wait(2)
        .to({ _off: true }, 114)
        .wait(439),
    );

    // Quote07
    this.instance_6 = new lib.Quote07testimonialDarpa01();
    this.instance_6.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_6.alpha = 0;
    this.instance_6._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_6)
        .wait(519)
        .to({ _off: false }, 0)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(57)
        .to({ scaleY: 0.7581, x: 1013.05 }, 0)
        .to(
          {
            regX: 0.5,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 1011.1,
            y: 225.9,
          },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(114)
        .to({ scaleX: 0.9966, scaleY: 0.9964 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.75,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9 }, 2)
        .wait(114)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          7,
        )
        .wait(2)
        .to({ _off: true }, 108)
        .wait(320),
    );

    // Quote08
    this.instance_7 = new lib.Quote08testimonialConsumergoods04();
    this.instance_7.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_7.alpha = 0;
    this.instance_7._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_7)
        .wait(588)
        .to({ _off: false }, 0)
        .to({ x: 1248.9 }, 2)
        .to({ scaleX: 0.7415, scaleY: 0.7413, x: 1011.05, alpha: 1 }, 8)
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(114)
        .to({ x: 1013.3 }, 0)
        .to(
          {
            regX: 0.6,
            regY: 0.6,
            scaleX: 0.7418,
            scaleY: 0.741,
            x: 1011.9,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regX: 0.1,
            regY: -0.1,
            scaleX: 0.9966,
            scaleY: 0.9963,
            x: 720,
            y: 219.05,
          },
          8,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 1.0134,
            scaleY: 1.0134,
            x: 719.95,
            y: 219.1,
          },
          2,
        )
        .wait(114)
        .to({ scaleY: 1.0133, x: 720, y: 219.15 }, 0)
        .to(
          { regX: 0.1, regY: 0.1, scaleX: 0.9966, scaleY: 0.9964, y: 219.1 },
          2,
        )
        .to(
          { regY: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.9, y: 225.75 },
          7,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 427.95 }, 2)
        .wait(108)
        .to({ regX: 0.1, x: 427.9 }, 0)
        .to({ regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.95 }, 2)
        .to({ scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 78)
        .wait(230),
    );

    // Quote09
    this.instance_8 = new lib.Quote09testimonialBiogen03();
    this.instance_8.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_8.alpha = 0;
    this.instance_8._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_8)
        .wait(714)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          8,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(114)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          7,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(108)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(78)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          8,
        )
        .wait(2)
        .to({ _off: true }, 40)
        .wait(178),
    );

    // Quote10
    this.instance_9 = new lib.Quote10testimonialGSK03();
    this.instance_9.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_9.alpha = 0;
    this.instance_9._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_9)
        .wait(840)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          7,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(108)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(78)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(40)
        .to({ regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.95 }, 2)
        .to({ scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 66)
        .wait(100),
    );

    // Quote11
    this.instance_10 = new lib.Quote11testimonialDarpa02();
    this.instance_10.setTransform(
      1244.9,
      225.75,
      0.661,
      0.661,
      0,
      0,
      0,
      0.2,
      0.2,
    );
    this.instance_10.alpha = 0;
    this.instance_10._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance_10)
        .wait(959)
        .to({ _off: false }, 0)
        .to({ scaleX: 0.6442, scaleY: 0.6442 }, 2)
        .to(
          { regX: 0.1, scaleX: 0.7415, scaleY: 0.7414, x: 1011.05, alpha: 1 },
          8,
        )
        .to({ regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1 }, 2)
        .wait(78)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(40)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(66)
        .to({ regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 430.95 }, 2)
        .to({ scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .wait(88),
    );

    // Quote12
    this.instance_11 = new lib.Quote12testimonialBiogen04();
    this.instance_11.setTransform(
      427.9,
      225.75,
      0.7583,
      0.7582,
      0,
      0,
      0,
      0.1,
      0.2,
    );

    this.timeline.addTween(
      cjs.Tween.get(this.instance_11)
        .to({ x: 427.95 }, 2)
        .to({ regX: 0.2, scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 85)
        .wait(952)
        .to({ _off: false, x: 1244.9 }, 0)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(40)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(66)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(88),
    );

    // Quote13
    this.instance_12 = new lib.Quote13testimonialGSK04();
    this.instance_12.setTransform(719.95, 219.1, 1.0134, 1.0134);

    this.timeline.addTween(
      cjs.Tween.get(this.instance_12)
        .to({ scaleX: 0.9966, scaleY: 0.9964, y: 219.2 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.7,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9, y: 225.75 }, 2)
        .wait(85)
        .to({ scaleX: 0.7415, scaleY: 0.7412, x: 430.9 }, 2)
        .to({ regX: 0.2, scaleX: 0.661, scaleY: 0.661, x: 185.7, alpha: 0 }, 8)
        .to({ x: 193.7 }, 2)
        .to({ _off: true }, 54)
        .wait(938)
        .to({ _off: false, x: 1244.9 }, 0)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(66)
        .to({ regX: 0.1 }, 0)
        .to(
          { regX: 0.2, scaleX: 0.7415, scaleY: 0.7414, x: 1011.1, y: 225.7 },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(88),
    );

    // Quote14
    this.instance_13 = new lib.Quote14testimonialConsumergoods02();
    this.instance_13.setTransform(
      1013.05,
      225.75,
      0.7583,
      0.7581,
      0,
      0,
      0,
      0.2,
      0.2,
    );

    this.timeline.addTween(
      cjs.Tween.get(this.instance_13)
        .to(
          {
            regX: 0.5,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 1011.1,
            y: 225.9,
          },
          2,
        )
        .to(
          {
            regX: 0,
            regY: 0,
            scaleX: 0.9966,
            scaleY: 0.9964,
            x: 719.95,
            y: 219.2,
          },
          8,
        )
        .to({ scaleX: 1.0134, scaleY: 1.0134, y: 219.1 }, 2)
        .wait(85)
        .to({ scaleX: 0.9966, scaleY: 0.9964 }, 2)
        .to(
          {
            regX: 0.1,
            regY: 0.2,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 430.85,
            y: 225.75,
          },
          8,
        )
        .to({ scaleX: 0.7583, scaleY: 0.7582, x: 427.9 }, 2)
        .wait(54)
        .to(
          {
            regX: 0.2,
            regY: 0.4,
            scaleX: 0.7415,
            scaleY: 0.7412,
            x: 430.95,
            y: 225.8,
          },
          2,
        )
        .to(
          {
            regY: 0.2,
            scaleX: 0.661,
            scaleY: 0.661,
            x: 185.7,
            y: 225.75,
            alpha: 0,
          },
          8,
        )
        .wait(2)
        .to({ _off: true }, 78)
        .wait(926)
        .to({ _off: false, x: 1244.9 }, 0)
        .to({ x: 1248.9 }, 2)
        .to(
          {
            regX: 0.1,
            scaleX: 0.7415,
            scaleY: 0.7414,
            x: 1010.05,
            y: 225.65,
            alpha: 1,
          },
          8,
        )
        .to(
          { regX: 0.2, scaleX: 0.7583, scaleY: 0.7582, x: 1013.1, y: 225.75 },
          2,
        )
        .wait(88),
    );

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(806.1, 249.1, 544.4, 169.6);
  // library properties:
  lib.properties = {
    id: "9EBBEA3FBB31418981CD7D62E26341DE",
    width: 1440,
    height: 480,
    fps: 24,
    color: "#FFFFFF",
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) {
      this.seek(ms);
    }
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; i += 1) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions["9EBBEA3FBB31418981CD7D62E26341DE"] = {
    getStage() {
      return exportRoot.stage;
    },
    getLibrary() {
      return lib;
    },
    getSpriteSheet() {
      return ss;
    },
    getImages() {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j += 1) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener("resize", resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim === "width" && lastW === iw) ||
          (respDim === "height" && lastH === ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) {
            sRatio = Math.min(xRatio, yRatio);
          }
        } else if (scaleType === 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType === 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach((container) => {
        container.style.width = w * sRatio + "px";
        container.style.height = h * sRatio + "px";
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (
            var index = 0;
            index < target.filterCacheList.length;
            index += 1
          ) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}

var canvas, stage, exportRoot, anim_container, fnStartAnimation;

function init() {
  canvas = document.getElementById("canvas");
  anim_container = document.getElementById("animation_container");
  var comp = window.AdobeAn.getComposition("9EBBEA3FBB31418981CD7D62E26341DE");
  handleComplete({}, comp);
}
function handleComplete(evt, comp) {
  //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
  var lib = comp.getLibrary();
  exportRoot = new lib.TestimonialAnimation();
  stage = new lib.Stage(canvas);
  //Registers the "tick" event listener.
  fnStartAnimation = function () {
    stage.addChild(exportRoot);
    window.cjs.Ticker.framerate = lib.properties.fps;
    window.cjs.Ticker.addEventListener("tick", stage);
  };
  //Code to support hidpi screens and responsive scaling.
  window.AdobeAn.makeResponsive(false, "both", false, 1, [
    canvas,
    anim_container,
  ]);
  window.AdobeAn.compositionLoaded(lib.properties.id);
  fnStartAnimation();
}

export default function loadTestimonial() {
  console.log("loadTestimonial running");
  initSetup(window.cjs, window.AdobeAn);
  // console.log('window.AdobeAn', window.AdobeAn);
  // console.log('window.cjs', window.cjs);
  init();
  console.log("loadTestimonial done");
}
